class CountryHelper {
	constructor(value) {
		// Internal array of countries
		this.countries = [
			{
				TwoDigit: "CA",
				ThreeDigit: "CAN",
				Name: "Canada",
				Capital: "Ottawa",
				Region: "Americas",
				Subregion: "Northern America",
				States: [
					{
						StateCode: "AB",
						Name: "Alberta",
						Subdivision: "province",
					},
					{
						StateCode: "BC",
						Name: "British Columbia",
						Subdivision: "province",
					},
					{
						StateCode: "MB",
						Name: "Manitoba",
						Subdivision: "province",
					},
					{
						StateCode: "NB",
						Name: "New Brunswick",
						Subdivision: "province",
					},
					{
						StateCode: "NL",
						Name: "Newfoundland and Labrador",
						Subdivision: "province",
					},
					{
						StateCode: "NS",
						Name: "Nova Scotia",
						Subdivision: "province",
					},
					{
						StateCode: "ON",
						Name: "Ontario",
						Subdivision: "province",
					},
					{
						StateCode: "PE",
						Name: "Prince Edward Island",
						Subdivision: "province",
					},
					{
						StateCode: "QC",
						Name: "Quebec",
						Subdivision: "province",
					},
					{
						StateCode: "SK",
						Name: "Saskatchewan",
						Subdivision: "province",
					},
					{
						StateCode: "NT",
						Name: "Northwest Territories",
						Subdivision: "territory",
					},
					{
						StateCode: "NU",
						Name: "Nunavut",
						Subdivision: "territory",
					},
					{
						StateCode: "YT",
						Name: "Yukon",
						Subdivision: "territory",
					},
				],
			},
			{
				TwoDigit: "US",
				ThreeDigit: "USA",
				Name: "United States",
				Capital: "Washington, D.C.",
				Region: "Americas",
				Subregion: "Northern America",
				States: [
					{
						StateCode: "DC",
						Name: "District of Columbia",
						Subdivision: "district",
					},
					{
						StateCode: "AS",
						Name: "American Samoa",
						Subdivision: "outlying territory",
					},
					{
						StateCode: "GU",
						Name: "Guam",
						Subdivision: "outlying territory",
					},
					{
						StateCode: "MP",
						Name: "Northern Mariana Islands",
						Subdivision: "outlying territory",
					},
					{
						StateCode: "PR",
						Name: "Puerto Rico",
						Subdivision: "outlying territory",
					},
					{
						StateCode: "UM",
						Name: "United States Minor Outlying Islands",
						Subdivision: "outlying territory",
					},
					{
						StateCode: "VI",
						Name: "Virgin Islands, U.S.",
						Subdivision: "outlying territory",
					},
					{
						StateCode: "AL",
						Name: "Alabama",
						Subdivision: "state",
					},
					{
						StateCode: "AK",
						Name: "Alaska",
						Subdivision: "state",
					},
					{
						StateCode: "AZ",
						Name: "Arizona",
						Subdivision: "state",
					},
					{
						StateCode: "AR",
						Name: "Arkansas",
						Subdivision: "state",
					},
					{
						StateCode: "CA",
						Name: "California",
						Subdivision: "state",
					},
					{
						StateCode: "CO",
						Name: "Colorado",
						Subdivision: "state",
					},
					{
						StateCode: "CT",
						Name: "Connecticut",
						Subdivision: "state",
					},
					{
						StateCode: "DE",
						Name: "Delaware",
						Subdivision: "state",
					},
					{
						StateCode: "FL",
						Name: "Florida",
						Subdivision: "state",
					},
					{
						StateCode: "GA",
						Name: "Georgia",
						Subdivision: "state",
					},
					{
						StateCode: "HI",
						Name: "Hawaii",
						Subdivision: "state",
					},
					{
						StateCode: "ID",
						Name: "Idaho",
						Subdivision: "state",
					},
					{
						StateCode: "IL",
						Name: "Illinois",
						Subdivision: "state",
					},
					{
						StateCode: "IN",
						Name: "Indiana",
						Subdivision: "state",
					},
					{
						StateCode: "IA",
						Name: "Iowa",
						Subdivision: "state",
					},
					{
						StateCode: "KS",
						Name: "Kansas",
						Subdivision: "state",
					},
					{
						StateCode: "KY",
						Name: "Kentucky",
						Subdivision: "state",
					},
					{
						StateCode: "LA",
						Name: "Louisiana",
						Subdivision: "state",
					},
					{
						StateCode: "ME",
						Name: "Maine",
						Subdivision: "state",
					},
					{
						StateCode: "MD",
						Name: "Maryland",
						Subdivision: "state",
					},
					{
						StateCode: "MA",
						Name: "Massachusetts",
						Subdivision: "state",
					},
					{
						StateCode: "MI",
						Name: "Michigan",
						Subdivision: "state",
					},
					{
						StateCode: "MN",
						Name: "Minnesota",
						Subdivision: "state",
					},
					{
						StateCode: "MS",
						Name: "Mississippi",
						Subdivision: "state",
					},
					{
						StateCode: "MO",
						Name: "Missouri",
						Subdivision: "state",
					},
					{
						StateCode: "MT",
						Name: "Montana",
						Subdivision: "state",
					},
					{
						StateCode: "NE",
						Name: "Nebraska",
						Subdivision: "state",
					},
					{
						StateCode: "NV",
						Name: "Nevada",
						Subdivision: "state",
					},
					{
						StateCode: "NH",
						Name: "New Hampshire",
						Subdivision: "state",
					},
					{
						StateCode: "NJ",
						Name: "New Jersey",
						Subdivision: "state",
					},
					{
						StateCode: "NM",
						Name: "New Mexico",
						Subdivision: "state",
					},
					{
						StateCode: "NY",
						Name: "New York",
						Subdivision: "state",
					},
					{
						StateCode: "NC",
						Name: "North Carolina",
						Subdivision: "state",
					},
					{
						StateCode: "ND",
						Name: "North Dakota",
						Subdivision: "state",
					},
					{
						StateCode: "OH",
						Name: "Ohio",
						Subdivision: "state",
					},
					{
						StateCode: "OK",
						Name: "Oklahoma",
						Subdivision: "state",
					},
					{
						StateCode: "OR",
						Name: "Oregon",
						Subdivision: "state",
					},
					{
						StateCode: "PA",
						Name: "Pennsylvania",
						Subdivision: "state",
					},
					{
						StateCode: "RI",
						Name: "Rhode Island",
						Subdivision: "state",
					},
					{
						StateCode: "SC",
						Name: "South Carolina",
						Subdivision: "state",
					},
					{
						StateCode: "SD",
						Name: "South Dakota",
						Subdivision: "state",
					},
					{
						StateCode: "TN",
						Name: "Tennessee",
						Subdivision: "state",
					},
					{
						StateCode: "TX",
						Name: "Texas",
						Subdivision: "state",
					},
					{
						StateCode: "UT",
						Name: "Utah",
						Subdivision: "state",
					},
					{
						StateCode: "VT",
						Name: "Vermont",
						Subdivision: "state",
					},
					{
						StateCode: "VA",
						Name: "Virginia",
						Subdivision: "state",
					},
					{
						StateCode: "WA",
						Name: "Washington",
						Subdivision: "state",
					},
					{
						StateCode: "WV",
						Name: "West Virginia",
						Subdivision: "state",
					},
					{
						StateCode: "WI",
						Name: "Wisconsin",
						Subdivision: "state",
					},
					{
						StateCode: "WY",
						Name: "Wyoming",
						Subdivision: "state",
					},
				],
			},
			{
				TwoDigit: "AF",
				ThreeDigit: "AFG",
				Name: "Afghanistan",
				Capital: "Kabul",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "BDS",
						Name: "Badakhshān",
						Subdivision: null,
					},
					{
						StateCode: "BGL",
						Name: "Baghlān",
						Subdivision: null,
					},
					{
						StateCode: "BAL",
						Name: "Balkh",
						Subdivision: null,
					},
					{
						StateCode: "BDG",
						Name: "Bādghīs",
						Subdivision: null,
					},
					{
						StateCode: "BAM",
						Name: "Bāmyān",
						Subdivision: null,
					},
					{
						StateCode: "DAY",
						Name: "Dāykundī",
						Subdivision: null,
					},
					{
						StateCode: "FRA",
						Name: "Farāh",
						Subdivision: null,
					},
					{
						StateCode: "FYB",
						Name: "Fāryāb",
						Subdivision: null,
					},
					{
						StateCode: "GHA",
						Name: "Ghaznī",
						Subdivision: null,
					},
					{
						StateCode: "GHO",
						Name: "Ghōr",
						Subdivision: null,
					},
					{
						StateCode: "HEL",
						Name: "Helmand",
						Subdivision: null,
					},
					{
						StateCode: "HER",
						Name: "Herāt",
						Subdivision: null,
					},
					{
						StateCode: "JOW",
						Name: "Jowzjān",
						Subdivision: null,
					},
					{
						StateCode: "KAN",
						Name: "Kandahār",
						Subdivision: null,
					},
					{
						StateCode: "KHO",
						Name: "Khōst",
						Subdivision: null,
					},
					{
						StateCode: "KNR",
						Name: "Kunar",
						Subdivision: null,
					},
					{
						StateCode: "KDZ",
						Name: "Kunduz",
						Subdivision: null,
					},
					{
						StateCode: "KAB",
						Name: "Kābul",
						Subdivision: null,
					},
					{
						StateCode: "KAP",
						Name: "Kāpīsā",
						Subdivision: null,
					},
					{
						StateCode: "LAG",
						Name: "Laghmān",
						Subdivision: null,
					},
					{
						StateCode: "LOG",
						Name: "Lōgar",
						Subdivision: null,
					},
					{
						StateCode: "NAN",
						Name: "Nangarhār",
						Subdivision: null,
					},
					{
						StateCode: "NIM",
						Name: "Nīmrōz",
						Subdivision: null,
					},
					{
						StateCode: "NUR",
						Name: "Nūristān",
						Subdivision: null,
					},
					{
						StateCode: "PIA",
						Name: "Paktiyā",
						Subdivision: null,
					},
					{
						StateCode: "PKA",
						Name: "Paktīkā",
						Subdivision: null,
					},
					{
						StateCode: "PAN",
						Name: "Panjshayr",
						Subdivision: null,
					},
					{
						StateCode: "PAR",
						Name: "Parwān",
						Subdivision: null,
					},
					{
						StateCode: "SAM",
						Name: "Samangān",
						Subdivision: null,
					},
					{
						StateCode: "SAR",
						Name: "Sar-e Pul",
						Subdivision: null,
					},
					{
						StateCode: "TAK",
						Name: "Takhār",
						Subdivision: null,
					},
					{
						StateCode: "URU",
						Name: "Uruzgān",
						Subdivision: null,
					},
					{
						StateCode: "WAR",
						Name: "Wardak",
						Subdivision: null,
					},
					{
						StateCode: "ZAB",
						Name: "Zābul",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AX",
				ThreeDigit: "ALA",
				Name: "Åland Islands",
				Capital: "Mariehamn",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [],
			},
			{
				TwoDigit: "AL",
				ThreeDigit: "ALB",
				Name: "Albania",
				Capital: "Tirana",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Berat",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Dibër",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Durrës",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Elbasan",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Fier",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Gjirokastër",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Korçë",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Kukës",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Lezhë",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Shkodër",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Tiranë",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Vlorë",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "DZ",
				ThreeDigit: "DZA",
				Name: "Algeria",
				Capital: "Algiers",
				Region: "Africa",
				Subregion: "Northern Africa",
				States: [
					{
						StateCode: "01",
						Name: "Adrar",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Alger",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Annaba",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Aïn Defla",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Aïn Témouchent",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Batna",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Biskra",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Blida",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Bordj Bou Arréridj",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Bouira",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Boumerdès",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Béchar",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Béjaïa",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Chlef",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Constantine",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Djelfa",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "El Bayadh",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "El Oued",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "El Tarf",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Ghardaïa",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Guelma",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Illizi",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Jijel",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Khenchela",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Laghouat",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Mascara",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Mila",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Mostaganem",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Msila",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Médéa",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Naama",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Oran",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Ouargla",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Oum el Bouaghi",
						Subdivision: null,
					},
					{
						StateCode: "48",
						Name: "Relizane",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Saïda",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Sidi Bel Abbès",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Skikda",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Souk Ahras",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Sétif",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Tamanghasset",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Tiaret",
						Subdivision: null,
					},
					{
						StateCode: "37",
						Name: "Tindouf",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Tipaza",
						Subdivision: null,
					},
					{
						StateCode: "38",
						Name: "Tissemsilt",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Tizi Ouzou",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Tlemcen",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Tébessa",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AS",
				ThreeDigit: "ASM",
				Name: "American Samoa",
				Capital: "Pago Pago",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [],
			},
			{
				TwoDigit: "AD",
				ThreeDigit: "AND",
				Name: "Andorra",
				Capital: "Andorra la Vella",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "07",
						Name: "Andorra la Vella",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Canillo",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Encamp",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Escaldes-Engordany",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "La Massana",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Ordino",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Sant Julià de Lòria",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AO",
				ThreeDigit: "AGO",
				Name: "Angola",
				Capital: "Luanda",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "BGO",
						Name: "Bengo",
						Subdivision: null,
					},
					{
						StateCode: "BGU",
						Name: "Benguela",
						Subdivision: null,
					},
					{
						StateCode: "BIE",
						Name: "Bié",
						Subdivision: null,
					},
					{
						StateCode: "CAB",
						Name: "Cabinda",
						Subdivision: null,
					},
					{
						StateCode: "CNN",
						Name: "Cunene",
						Subdivision: null,
					},
					{
						StateCode: "HUA",
						Name: "Huambo",
						Subdivision: null,
					},
					{
						StateCode: "HUI",
						Name: "Huíla",
						Subdivision: null,
					},
					{
						StateCode: "CCU",
						Name: "Kuando Kubango",
						Subdivision: null,
					},
					{
						StateCode: "CNO",
						Name: "Kwanza Norte",
						Subdivision: null,
					},
					{
						StateCode: "CUS",
						Name: "Kwanza Sul",
						Subdivision: null,
					},
					{
						StateCode: "LUA",
						Name: "Luanda",
						Subdivision: null,
					},
					{
						StateCode: "LNO",
						Name: "Lunda Norte",
						Subdivision: null,
					},
					{
						StateCode: "LSU",
						Name: "Lunda Sul",
						Subdivision: null,
					},
					{
						StateCode: "MAL",
						Name: "Malange",
						Subdivision: null,
					},
					{
						StateCode: "MOX",
						Name: "Moxico",
						Subdivision: null,
					},
					{
						StateCode: "NAM",
						Name: "Namibe",
						Subdivision: null,
					},
					{
						StateCode: "UIG",
						Name: "Uíge",
						Subdivision: null,
					},
					{
						StateCode: "ZAI",
						Name: "Zaire",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AI",
				ThreeDigit: "AIA",
				Name: "Anguilla",
				Capital: "The Valley",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "AQ",
				ThreeDigit: "ATA",
				Name: "Antarctica",
				Capital: "",
				Region: "Polar",
				Subregion: "",
				States: [],
			},
			{
				TwoDigit: "AG",
				ThreeDigit: "ATG",
				Name: "Antigua and Barbuda",
				Capital: "Saint John's",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "10",
						Name: "Barbuda",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Redonda",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Saint George",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Saint John",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Saint Mary",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Saint Paul",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Saint Peter",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Saint Philip",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AR",
				ThreeDigit: "ARG",
				Name: "Argentina",
				Capital: "Buenos Aires",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "B",
						Name: "Buenos Aires",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Catamarca",
						Subdivision: null,
					},
					{
						StateCode: "H",
						Name: "Chaco",
						Subdivision: null,
					},
					{
						StateCode: "U",
						Name: "Chubut",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Ciudad Autónoma de Buenos Aires",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Corrientes",
						Subdivision: null,
					},
					{
						StateCode: "X",
						Name: "Córdoba",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Entre Ríos",
						Subdivision: null,
					},
					{
						StateCode: "P",
						Name: "Formosa",
						Subdivision: null,
					},
					{
						StateCode: "Y",
						Name: "Jujuy",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "La Pampa",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "La Rioja",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Mendoza",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Misiones",
						Subdivision: null,
					},
					{
						StateCode: "Q",
						Name: "Neuquén",
						Subdivision: null,
					},
					{
						StateCode: "R",
						Name: "Río Negro",
						Subdivision: null,
					},
					{
						StateCode: "A",
						Name: "Salta",
						Subdivision: null,
					},
					{
						StateCode: "J",
						Name: "San Juan",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "San Luis",
						Subdivision: null,
					},
					{
						StateCode: "Z",
						Name: "Santa Cruz",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Santa Fe",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Santiago del Estero",
						Subdivision: null,
					},
					{
						StateCode: "V",
						Name: "Tierra del Fuego",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Tucumán",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AM",
				ThreeDigit: "ARM",
				Name: "Armenia",
				Capital: "Yerevan",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "AG",
						Name: "Aragac̣otn",
						Subdivision: null,
					},
					{
						StateCode: "AR",
						Name: "Ararat",
						Subdivision: null,
					},
					{
						StateCode: "AV",
						Name: "Armavir",
						Subdivision: null,
					},
					{
						StateCode: "ER",
						Name: "Erevan",
						Subdivision: null,
					},
					{
						StateCode: "GR",
						Name: "Geġark'unik'",
						Subdivision: null,
					},
					{
						StateCode: "KT",
						Name: "Kotayk'",
						Subdivision: null,
					},
					{
						StateCode: "LO",
						Name: "Loṙi",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "Syunik'",
						Subdivision: null,
					},
					{
						StateCode: "TV",
						Name: "Tavuš",
						Subdivision: null,
					},
					{
						StateCode: "VD",
						Name: "Vayoć Jor",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Širak",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AW",
				ThreeDigit: "ABW",
				Name: "Aruba",
				Capital: "Oranjestad",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "AU",
				ThreeDigit: "AUS",
				Name: "Australia",
				Capital: "Canberra",
				Region: "Oceania",
				Subregion: "Australia and New Zealand",
				States: [
					{
						StateCode: "ACT",
						Name: "Australian Capital Territory",
						Subdivision: null,
					},
					{
						StateCode: "NSW",
						Name: "New South Wales",
						Subdivision: null,
					},
					{
						StateCode: "NT",
						Name: "Northern Territory",
						Subdivision: null,
					},
					{
						StateCode: "QLD",
						Name: "Queensland",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "South Australia",
						Subdivision: null,
					},
					{
						StateCode: "TAS",
						Name: "Tasmania",
						Subdivision: null,
					},
					{
						StateCode: "VIC",
						Name: "Victoria",
						Subdivision: null,
					},
					{
						StateCode: "WA",
						Name: "Western Australia",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AT",
				ThreeDigit: "AUT",
				Name: "Austria",
				Capital: "Vienna",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "B",
						Name: "Burgenland",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Kärnten",
						Subdivision: null,
					},
					{
						StateCode: "NÖ",
						Name: "Niederösterreich",
						Subdivision: null,
					},
					{
						StateCode: "OÖ",
						Name: "Oberösterreich",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Salzburg",
						Subdivision: null,
					},
					{
						StateCode: "ST",
						Name: "Steiermark",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Tirol",
						Subdivision: null,
					},
					{
						StateCode: "V",
						Name: "Vorarlberg",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Wien",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AZ",
				ThreeDigit: "AZE",
				Name: "Azerbaijan",
				Capital: "Baku",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "NX",
						Name: "Naxçıvan",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BS",
				ThreeDigit: "BHS",
				Name: "The Bahamas",
				Capital: "Nassau",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "AK",
						Name: "Acklins",
						Subdivision: null,
					},
					{
						StateCode: "BY",
						Name: "Berry Islands",
						Subdivision: null,
					},
					{
						StateCode: "BI",
						Name: "Bimini",
						Subdivision: null,
					},
					{
						StateCode: "BP",
						Name: "Black Point",
						Subdivision: null,
					},
					{
						StateCode: "CI",
						Name: "Cat Island",
						Subdivision: null,
					},
					{
						StateCode: "CO",
						Name: "Central Abaco",
						Subdivision: null,
					},
					{
						StateCode: "CS",
						Name: "Central Andros",
						Subdivision: null,
					},
					{
						StateCode: "CE",
						Name: "Central Eleuthera",
						Subdivision: null,
					},
					{
						StateCode: "FP",
						Name: "City of Freeport",
						Subdivision: null,
					},
					{
						StateCode: "CK",
						Name: "Crooked Island and Long Cay",
						Subdivision: null,
					},
					{
						StateCode: "EG",
						Name: "East Grand Bahama",
						Subdivision: null,
					},
					{
						StateCode: "EX",
						Name: "Exuma",
						Subdivision: null,
					},
					{
						StateCode: "GC",
						Name: "Grand Cay",
						Subdivision: null,
					},
					{
						StateCode: "HI",
						Name: "Harbour Island",
						Subdivision: null,
					},
					{
						StateCode: "HT",
						Name: "Hope Town",
						Subdivision: null,
					},
					{
						StateCode: "IN",
						Name: "Inagua",
						Subdivision: null,
					},
					{
						StateCode: "LI",
						Name: "Long Island",
						Subdivision: null,
					},
					{
						StateCode: "MC",
						Name: "Mangrove Cay",
						Subdivision: null,
					},
					{
						StateCode: "MG",
						Name: "Mayaguana",
						Subdivision: null,
					},
					{
						StateCode: "MI",
						Name: "Moores Island",
						Subdivision: null,
					},
					{
						StateCode: "NO",
						Name: "North Abaco",
						Subdivision: null,
					},
					{
						StateCode: "NS",
						Name: "North Andros",
						Subdivision: null,
					},
					{
						StateCode: "NE",
						Name: "North Eleuthera",
						Subdivision: null,
					},
					{
						StateCode: "RI",
						Name: "Ragged Island",
						Subdivision: null,
					},
					{
						StateCode: "RC",
						Name: "Rum Cay",
						Subdivision: null,
					},
					{
						StateCode: "SS",
						Name: "San Salvador",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "South Abaco",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "South Andros",
						Subdivision: null,
					},
					{
						StateCode: "SE",
						Name: "South Eleuthera",
						Subdivision: null,
					},
					{
						StateCode: "SW",
						Name: "Spanish Wells",
						Subdivision: null,
					},
					{
						StateCode: "WG",
						Name: "West Grand Bahama",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BH",
				ThreeDigit: "BHR",
				Name: "Bahrain",
				Capital: "Manama",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "14",
						Name: "Al Janūbīyah",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Al Manāmah",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Al Muḩarraq",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Al Wusţá",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Ash Shamālīyah",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BD",
				ThreeDigit: "BGD",
				Name: "Bangladesh",
				Capital: "Dhaka",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "A",
						Name: "Barisal",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "Chittagong",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Dhaka",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Khulna",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Rajshahi",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Rangpur",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Sylhet",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BB",
				ThreeDigit: "BRB",
				Name: "Barbados",
				Capital: "Bridgetown",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "01",
						Name: "Christ Church",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Saint Andrew",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Saint George",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Saint James",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Saint John",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Saint Joseph",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Saint Lucy",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Saint Michael",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Saint Peter",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Saint Philip",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Saint Thomas",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BY",
				ThreeDigit: "BLR",
				Name: "Belarus",
				Capital: "Minsk",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "BR",
						Name: "Brestskaya voblasts'",
						Subdivision: null,
					},
					{
						StateCode: "HO",
						Name: "Homyel'skaya voblasts'",
						Subdivision: null,
					},
					{
						StateCode: "HM",
						Name: "Horad Minsk",
						Subdivision: null,
					},
					{
						StateCode: "HR",
						Name: "Hrodzenskaya voblasts'",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Mahilyowskaya voblasts'",
						Subdivision: null,
					},
					{
						StateCode: "MI",
						Name: "Minskaya voblasts'",
						Subdivision: null,
					},
					{
						StateCode: "VI",
						Name: "Vitsyebskaya voblasts'",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BE",
				ThreeDigit: "BEL",
				Name: "Belgium",
				Capital: "Brussels",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "BRU",
						Name: "Brussels Hoofdstedelijk Gewest",
						Subdivision: null,
					},
					{
						StateCode: "WAL",
						Name: "Région Wallonne",
						Subdivision: null,
					},
					{
						StateCode: "VLG",
						Name: "Vlaams Gewest",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BZ",
				ThreeDigit: "BLZ",
				Name: "Belize",
				Capital: "Belmopan",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "BZ",
						Name: "Belize",
						Subdivision: null,
					},
					{
						StateCode: "CY",
						Name: "Cayo",
						Subdivision: null,
					},
					{
						StateCode: "CZL",
						Name: "Corozal",
						Subdivision: null,
					},
					{
						StateCode: "OW",
						Name: "Orange Walk",
						Subdivision: null,
					},
					{
						StateCode: "SC",
						Name: "Stann Creek",
						Subdivision: null,
					},
					{
						StateCode: "TOL",
						Name: "Toledo",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BJ",
				ThreeDigit: "BEN",
				Name: "Benin",
				Capital: "Porto-Novo",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "AL",
						Name: "Alibori",
						Subdivision: null,
					},
					{
						StateCode: "AK",
						Name: "Atakora",
						Subdivision: null,
					},
					{
						StateCode: "AQ",
						Name: "Atlantique",
						Subdivision: null,
					},
					{
						StateCode: "BO",
						Name: "Borgou",
						Subdivision: null,
					},
					{
						StateCode: "CO",
						Name: "Collines",
						Subdivision: null,
					},
					{
						StateCode: "DO",
						Name: "Donga",
						Subdivision: null,
					},
					{
						StateCode: "KO",
						Name: "Kouffo",
						Subdivision: null,
					},
					{
						StateCode: "LI",
						Name: "Littoral",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Mono",
						Subdivision: null,
					},
					{
						StateCode: "OU",
						Name: "Ouémé",
						Subdivision: null,
					},
					{
						StateCode: "PL",
						Name: "Plateau",
						Subdivision: null,
					},
					{
						StateCode: "ZO",
						Name: "Zou",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BM",
				ThreeDigit: "BMU",
				Name: "Bermuda",
				Capital: "Hamilton",
				Region: "Americas",
				Subregion: "Northern America",
				States: [],
			},
			{
				TwoDigit: "BT",
				ThreeDigit: "BTN",
				Name: "Bhutan",
				Capital: "Thimphu",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "33",
						Name: "Bumthang",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Chhukha",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Dagana",
						Subdivision: null,
					},
					{
						StateCode: "GA",
						Name: "Gasa",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Ha",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Lhuentse",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Monggar",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Paro",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Pemagatshel",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Punakha",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Samdrup Jongkha",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Samtse",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Sarpang",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Thimphu",
						Subdivision: null,
					},
					{
						StateCode: "TY",
						Name: "Trashi Yangtse",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Trashigang",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Trongsa",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Tsirang",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Wangdue Phodrang",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Zhemgang",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BO",
				ThreeDigit: "BOL",
				Name: "Bolivia",
				Capital: "Sucre",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "H",
						Name: "Chuquisaca",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Cochabamba",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "El Beni",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "La Paz",
						Subdivision: null,
					},
					{
						StateCode: "O",
						Name: "Oruro",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Pando",
						Subdivision: null,
					},
					{
						StateCode: "P",
						Name: "Potosí",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Santa Cruz",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Tarija",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BQ",
				ThreeDigit: "BES",
				Name: "Bonaire",
				Capital: "Kralendijk",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "BA",
				ThreeDigit: "BIH",
				Name: "Bosnia and Herzegovina",
				Capital: "Sarajevo",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "BRC",
						Name: "Brčko distrikt",
						Subdivision: null,
					},
					{
						StateCode: "BIH",
						Name: "Federacija Bosna i Hercegovina",
						Subdivision: null,
					},
					{
						StateCode: "SRP",
						Name: "Republika Srpska",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BW",
				ThreeDigit: "BWA",
				Name: "Botswana",
				Capital: "Gaborone",
				Region: "Africa",
				Subregion: "Southern Africa",
				States: [
					{
						StateCode: "CE",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "CH",
						Name: "Chobe",
						Subdivision: null,
					},
					{
						StateCode: "FR",
						Name: "Francistown",
						Subdivision: null,
					},
					{
						StateCode: "GA",
						Name: "Gaborone",
						Subdivision: null,
					},
					{
						StateCode: "GH",
						Name: "Ghanzi",
						Subdivision: null,
					},
					{
						StateCode: "JW",
						Name: "Jwaneng",
						Subdivision: null,
					},
					{
						StateCode: "KG",
						Name: "Kgalagadi",
						Subdivision: null,
					},
					{
						StateCode: "KL",
						Name: "Kgatleng",
						Subdivision: null,
					},
					{
						StateCode: "KW",
						Name: "Kweneng",
						Subdivision: null,
					},
					{
						StateCode: "LO",
						Name: "Lobatse",
						Subdivision: null,
					},
					{
						StateCode: "NE",
						Name: "North-East",
						Subdivision: null,
					},
					{
						StateCode: "NW",
						Name: "North-West",
						Subdivision: null,
					},
					{
						StateCode: "SP",
						Name: "Selibe Phikwe",
						Subdivision: null,
					},
					{
						StateCode: "SE",
						Name: "South-East",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Southern",
						Subdivision: null,
					},
					{
						StateCode: "ST",
						Name: "Sowa Town",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BV",
				ThreeDigit: "BVT",
				Name: "Bouvet Island",
				Capital: "",
				Region: "",
				Subregion: "",
				States: [],
			},
			{
				TwoDigit: "BR",
				ThreeDigit: "BRA",
				Name: "Brazil",
				Capital: "Brasília",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "AC",
						Name: "Acre",
						Subdivision: null,
					},
					{
						StateCode: "AL",
						Name: "Alagoas",
						Subdivision: null,
					},
					{
						StateCode: "AP",
						Name: "Amapá",
						Subdivision: null,
					},
					{
						StateCode: "AM",
						Name: "Amazonas",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Bahia",
						Subdivision: null,
					},
					{
						StateCode: "CE",
						Name: "Ceará",
						Subdivision: null,
					},
					{
						StateCode: "DF",
						Name: "Distrito Federal",
						Subdivision: null,
					},
					{
						StateCode: "ES",
						Name: "Espírito Santo",
						Subdivision: null,
					},
					{
						StateCode: "GO",
						Name: "Goiás",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Maranhão",
						Subdivision: null,
					},
					{
						StateCode: "MT",
						Name: "Mato Grosso",
						Subdivision: null,
					},
					{
						StateCode: "MS",
						Name: "Mato Grosso do Sul",
						Subdivision: null,
					},
					{
						StateCode: "MG",
						Name: "Minas Gerais",
						Subdivision: null,
					},
					{
						StateCode: "PR",
						Name: "Paraná",
						Subdivision: null,
					},
					{
						StateCode: "PB",
						Name: "Paraíba",
						Subdivision: null,
					},
					{
						StateCode: "PA",
						Name: "Pará",
						Subdivision: null,
					},
					{
						StateCode: "PE",
						Name: "Pernambuco",
						Subdivision: null,
					},
					{
						StateCode: "PI",
						Name: "Piauí",
						Subdivision: null,
					},
					{
						StateCode: "RN",
						Name: "Rio Grande do Norte",
						Subdivision: null,
					},
					{
						StateCode: "RS",
						Name: "Rio Grande do Sul",
						Subdivision: null,
					},
					{
						StateCode: "RJ",
						Name: "Rio de Janeiro",
						Subdivision: null,
					},
					{
						StateCode: "RO",
						Name: "Rondônia",
						Subdivision: null,
					},
					{
						StateCode: "RR",
						Name: "Roraima",
						Subdivision: null,
					},
					{
						StateCode: "SC",
						Name: "Santa Catarina",
						Subdivision: null,
					},
					{
						StateCode: "SE",
						Name: "Sergipe",
						Subdivision: null,
					},
					{
						StateCode: "SP",
						Name: "São Paulo",
						Subdivision: null,
					},
					{
						StateCode: "TO",
						Name: "Tocantins",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IO",
				ThreeDigit: "IOT",
				Name: "British Indian Ocean Territory",
				Capital: "Diego Garcia",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [],
			},
			{
				TwoDigit: "UM",
				ThreeDigit: "UMI",
				Name: "United States Minor Outlying Islands",
				Capital: "",
				Region: "Americas",
				Subregion: "Northern America",
				States: [
					{
						StateCode: "81",
						Name: "Baker Island",
						Subdivision: null,
					},
					{
						StateCode: "84",
						Name: "Howland Island",
						Subdivision: null,
					},
					{
						StateCode: "86",
						Name: "Jarvis Island",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Johnston Atoll",
						Subdivision: null,
					},
					{
						StateCode: "89",
						Name: "Kingman Reef",
						Subdivision: null,
					},
					{
						StateCode: "71",
						Name: "Midway Islands",
						Subdivision: null,
					},
					{
						StateCode: "76",
						Name: "Navassa Island",
						Subdivision: null,
					},
					{
						StateCode: "95",
						Name: "Palmyra Atoll",
						Subdivision: null,
					},
					{
						StateCode: "79",
						Name: "Wake Island",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "VG",
				ThreeDigit: "VGB",
				Name: "Virgin Islands (British)",
				Capital: "Road Town",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "VI",
				ThreeDigit: "VIR",
				Name: "Virgin Islands (U.S.)",
				Capital: "Charlotte Amalie",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "BN",
				ThreeDigit: "BRN",
				Name: "Brunei",
				Capital: "Bandar Seri Begawan",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "BE",
						Name: "Belait",
						Subdivision: null,
					},
					{
						StateCode: "BM",
						Name: "Brunei-Muara",
						Subdivision: null,
					},
					{
						StateCode: "TE",
						Name: "Temburong",
						Subdivision: null,
					},
					{
						StateCode: "TU",
						Name: "Tutong",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BG",
				ThreeDigit: "BGR",
				Name: "Bulgaria",
				Capital: "Sofia",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Blagoevgrad",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Burgas",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Dobrich",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Gabrovo",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Haskovo",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Kardzhali",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Kyustendil",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Lovech",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Montana",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Pazardzhik",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Pernik",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Pleven",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Plovdiv",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Razgrad",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Ruse",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Shumen",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Silistra",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Sliven",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Smolyan",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Sofia",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Sofia-Grad",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Stara Zagora",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Targovishte",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Varna",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Veliko Tarnovo",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Vidin",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Vratsa",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Yambol",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BF",
				ThreeDigit: "BFA",
				Name: "Burkina Faso",
				Capital: "Ouagadougou",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "01",
						Name: "Boucle du Mouhoun",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Cascades",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Centre",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Centre-Est",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Centre-Nord",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Centre-Ouest",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Centre-Sud",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Est",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Hauts-Bassins",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Nord",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Plateau-Central",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Sahel",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Sud-Ouest",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BI",
				ThreeDigit: "BDI",
				Name: "Burundi",
				Capital: "Bujumbura",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "BB",
						Name: "Bubanza",
						Subdivision: null,
					},
					{
						StateCode: "BM",
						Name: "Bujumbura Mairie",
						Subdivision: null,
					},
					{
						StateCode: "BL",
						Name: "Bujumbura Rural",
						Subdivision: null,
					},
					{
						StateCode: "BR",
						Name: "Bururi",
						Subdivision: null,
					},
					{
						StateCode: "CA",
						Name: "Cankuzo",
						Subdivision: null,
					},
					{
						StateCode: "CI",
						Name: "Cibitoke",
						Subdivision: null,
					},
					{
						StateCode: "GI",
						Name: "Gitega",
						Subdivision: null,
					},
					{
						StateCode: "KR",
						Name: "Karuzi",
						Subdivision: null,
					},
					{
						StateCode: "KY",
						Name: "Kayanza",
						Subdivision: null,
					},
					{
						StateCode: "KI",
						Name: "Kirundo",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Makamba",
						Subdivision: null,
					},
					{
						StateCode: "MU",
						Name: "Muramvya",
						Subdivision: null,
					},
					{
						StateCode: "MY",
						Name: "Muyinga",
						Subdivision: null,
					},
					{
						StateCode: "MW",
						Name: "Mwaro",
						Subdivision: null,
					},
					{
						StateCode: "NG",
						Name: "Ngozi",
						Subdivision: null,
					},
					{
						StateCode: "RT",
						Name: "Rutana",
						Subdivision: null,
					},
					{
						StateCode: "RY",
						Name: "Ruyigi",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KH",
				ThreeDigit: "KHM",
				Name: "Cambodia",
				Capital: "Phnom Penh",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "2",
						Name: "Baat Dambang",
						Subdivision: null,
					},
					{
						StateCode: "1",
						Name: "Banteay Mean Chey",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Kampong Chaam",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Kampong Chhnang",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Kampong Spueu",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "Kampong Thum",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "Kampot",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Kandaal",
						Subdivision: null,
					},
					{
						StateCode: "9",
						Name: "Kaoh Kong",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Kracheh",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Krong Kaeb",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Krong Pailin",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Krong Preah Sihanouk",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Mondol Kiri",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Otdar Mean Chey",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Phnom Penh",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Pousaat",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Preah Vihear",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Prey Veaeng",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Rotanak Kiri",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Siem Reab",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Stueng Traeng",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Svaay Rieng",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Taakaev",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CM",
				ThreeDigit: "CMR",
				Name: "Cameroon",
				Capital: "Yaoundé",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "AD",
						Name: "Adamaoua",
						Subdivision: null,
					},
					{
						StateCode: "CE",
						Name: "Centre",
						Subdivision: null,
					},
					{
						StateCode: "ES",
						Name: "East",
						Subdivision: null,
					},
					{
						StateCode: "EN",
						Name: "Far North",
						Subdivision: null,
					},
					{
						StateCode: "LT",
						Name: "Littoral",
						Subdivision: null,
					},
					{
						StateCode: "NO",
						Name: "North",
						Subdivision: null,
					},
					{
						StateCode: "NW",
						Name: "North-West",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "South",
						Subdivision: null,
					},
					{
						StateCode: "SW",
						Name: "South-West",
						Subdivision: null,
					},
					{
						StateCode: "OU",
						Name: "West",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CV",
				ThreeDigit: "CPV",
				Name: "Cape Verde",
				Capital: "Praia",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "B",
						Name: "Ilhas de Barlavento",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Ilhas de Sotavento",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KY",
				ThreeDigit: "CYM",
				Name: "Cayman Islands",
				Capital: "George Town",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "CF",
				ThreeDigit: "CAF",
				Name: "Central African Republic",
				Capital: "Bangui",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "BB",
						Name: "Bamingui-Bangoran",
						Subdivision: null,
					},
					{
						StateCode: "BGF",
						Name: "Bangui",
						Subdivision: null,
					},
					{
						StateCode: "BK",
						Name: "Basse-Kotto",
						Subdivision: null,
					},
					{
						StateCode: "KB",
						Name: "Gribingui",
						Subdivision: null,
					},
					{
						StateCode: "HM",
						Name: "Haut-Mbomou",
						Subdivision: null,
					},
					{
						StateCode: "HK",
						Name: "Haute-Kotto",
						Subdivision: null,
					},
					{
						StateCode: "HS",
						Name: "Haute-Sangha / Mambéré-Kadéï",
						Subdivision: null,
					},
					{
						StateCode: "KG",
						Name: "Kémo-Gribingui",
						Subdivision: null,
					},
					{
						StateCode: "LB",
						Name: "Lobaye",
						Subdivision: null,
					},
					{
						StateCode: "MB",
						Name: "Mbomou",
						Subdivision: null,
					},
					{
						StateCode: "NM",
						Name: "Nana-Mambéré",
						Subdivision: null,
					},
					{
						StateCode: "MP",
						Name: "Ombella-Mpoko",
						Subdivision: null,
					},
					{
						StateCode: "UK",
						Name: "Ouaka",
						Subdivision: null,
					},
					{
						StateCode: "AC",
						Name: "Ouham",
						Subdivision: null,
					},
					{
						StateCode: "OP",
						Name: "Ouham-Pendé",
						Subdivision: null,
					},
					{
						StateCode: "SE",
						Name: "Sangha",
						Subdivision: null,
					},
					{
						StateCode: "VK",
						Name: "Vakaga",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TD",
				ThreeDigit: "TCD",
				Name: "Chad",
				Capital: "N'Djamena",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "BA",
						Name: "Al Baṭḩah",
						Subdivision: null,
					},
					{
						StateCode: "LC",
						Name: "Al Buḩayrah",
						Subdivision: null,
					},
					{
						StateCode: "BG",
						Name: "Baḩr al Ghazāl",
						Subdivision: null,
					},
					{
						StateCode: "BO",
						Name: "Būrkū",
						Subdivision: null,
					},
					{
						StateCode: "EN",
						Name: "Innīdī",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Kānim",
						Subdivision: null,
					},
					{
						StateCode: "LO",
						Name: "Lūqūn al Gharbī",
						Subdivision: null,
					},
					{
						StateCode: "LR",
						Name: "Lūqūn ash Sharqī",
						Subdivision: null,
					},
					{
						StateCode: "ND",
						Name: "Madīnat Injamīnā",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Māndūl",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Māyū Kībbī al Gharbī",
						Subdivision: null,
					},
					{
						StateCode: "ME",
						Name: "Māyū Kībbī ash Sharqī",
						Subdivision: null,
					},
					{
						StateCode: "GR",
						Name: "Qīrā",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Salāmāt",
						Subdivision: null,
					},
					{
						StateCode: "CB",
						Name: "Shārī Bāqirmī",
						Subdivision: null,
					},
					{
						StateCode: "MC",
						Name: "Shārī al Awsaṭ",
						Subdivision: null,
					},
					{
						StateCode: "SI",
						Name: "Sīlā",
						Subdivision: null,
					},
					{
						StateCode: "TI",
						Name: "Tibastī",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tānjilī",
						Subdivision: null,
					},
					{
						StateCode: "OD",
						Name: "Waddāy",
						Subdivision: null,
					},
					{
						StateCode: "WF",
						Name: "Wādī Fīrā",
						Subdivision: null,
					},
					{
						StateCode: "HL",
						Name: "Ḥajjar Lamīs",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CL",
				ThreeDigit: "CHL",
				Name: "Chile",
				Capital: "Santiago",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "AI",
						Name: "Aisén del General Carlos Ibañez del Campo",
						Subdivision: null,
					},
					{
						StateCode: "AN",
						Name: "Antofagasta",
						Subdivision: null,
					},
					{
						StateCode: "AR",
						Name: "Araucanía",
						Subdivision: null,
					},
					{
						StateCode: "AP",
						Name: "Arica y Parinacota",
						Subdivision: null,
					},
					{
						StateCode: "AT",
						Name: "Atacama",
						Subdivision: null,
					},
					{
						StateCode: "BI",
						Name: "Bío-Bío",
						Subdivision: null,
					},
					{
						StateCode: "CO",
						Name: "Coquimbo",
						Subdivision: null,
					},
					{
						StateCode: "LI",
						Name: "Libertador General Bernardo O'Higgins",
						Subdivision: null,
					},
					{
						StateCode: "LL",
						Name: "Los Lagos",
						Subdivision: null,
					},
					{
						StateCode: "LR",
						Name: "Los Ríos",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Magallanes",
						Subdivision: null,
					},
					{
						StateCode: "ML",
						Name: "Maule",
						Subdivision: null,
					},
					{
						StateCode: "RM",
						Name: "Región Metropolitana de Santiago",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tarapacá",
						Subdivision: null,
					},
					{
						StateCode: "VS",
						Name: "Valparaíso",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CN",
				ThreeDigit: "CHN",
				Name: "China",
				Capital: "Beijing",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [
					{
						StateCode: "45",
						Name: "Guangxi",
						Subdivision: "Autonomous region",
					},
					{
						StateCode: "15",
						Name: "Nei Mongol",
						Subdivision: "Autonomous region",
					},
					{
						StateCode: "64",
						Name: "Ningxia",
						Subdivision: "Autonomous region",
					},
					{
						StateCode: "65",
						Name: "Xinjiang",
						Subdivision: "Autonomous region",
					},
					{
						StateCode: "54",
						Name: "Xizang",
						Subdivision: "Autonomous region",
					},
					{
						StateCode: "11",
						Name: "Beijing",
						Subdivision: "Municipality",
					},
					{
						StateCode: "50",
						Name: "Chongqing",
						Subdivision: "Municipality",
					},
					{
						StateCode: "31",
						Name: "Shanghai",
						Subdivision: "Municipality",
					},
					{
						StateCode: "12",
						Name: "Tianjin",
						Subdivision: "Municipality",
					},
					{
						StateCode: "34",
						Name: "Anhui",
						Subdivision: "Province",
					},
					{
						StateCode: "35",
						Name: "Fujian",
						Subdivision: "Province",
					},
					{
						StateCode: "62",
						Name: "Gansu",
						Subdivision: "Province",
					},
					{
						StateCode: "44",
						Name: "Guangdong",
						Subdivision: "Province",
					},
					{
						StateCode: "52",
						Name: "Guizhou",
						Subdivision: "Province",
					},
					{
						StateCode: "46",
						Name: "Hainan",
						Subdivision: "Province",
					},
					{
						StateCode: "13",
						Name: "Hebei",
						Subdivision: "Province",
					},
					{
						StateCode: "23",
						Name: "Heilongjiang",
						Subdivision: "Province",
					},
					{
						StateCode: "41",
						Name: "Henan",
						Subdivision: "Province",
					},
					{
						StateCode: "42",
						Name: "Hubei",
						Subdivision: "Province",
					},
					{
						StateCode: "43",
						Name: "Hunan",
						Subdivision: "Province",
					},
					{
						StateCode: "32",
						Name: "Jiangsu",
						Subdivision: "Province",
					},
					{
						StateCode: "36",
						Name: "Jiangxi",
						Subdivision: "Province",
					},
					{
						StateCode: "22",
						Name: "Jilin",
						Subdivision: "Province",
					},
					{
						StateCode: "21",
						Name: "Liaoning",
						Subdivision: "Province",
					},
					{
						StateCode: "63",
						Name: "Qinghai",
						Subdivision: "Province",
					},
					{
						StateCode: "61",
						Name: "Shaanxi",
						Subdivision: "Province",
					},
					{
						StateCode: "37",
						Name: "Shandong",
						Subdivision: "Province",
					},
					{
						StateCode: "14",
						Name: "Shanxi",
						Subdivision: "Province",
					},
					{
						StateCode: "51",
						Name: "Sichuan",
						Subdivision: "Province",
					},
					{
						StateCode: "71",
						Name: "Taiwan",
						Subdivision: "Province",
					},
					{
						StateCode: "53",
						Name: "Yunnan",
						Subdivision: "Province",
					},
					{
						StateCode: "33",
						Name: "Zhejiang",
						Subdivision: "Province",
					},
					{
						StateCode: "91",
						Name: "Hong Kong",
						Subdivision: "Special administrative region",
					},
					{
						StateCode: "92",
						Name: "Macao",
						Subdivision: "Special administrative region",
					},
					{
						StateCode: "",
						Name: "Hong Kong Island",
						Subdivision: "Special administrative region",
					},
					{
						StateCode: "KOWLOON",
						Name: "Kowloon",
						Subdivision: "Special administrative region",
					},
					{
						StateCode: "NEW TERRITORIES",
						Name: "New Territories",
						Subdivision: "Special administrative region",
					},
				],
			},
			{
				TwoDigit: "CX",
				ThreeDigit: "CXR",
				Name: "Christmas Island",
				Capital: "Flying Fish Cove",
				Region: "Oceania",
				Subregion: "Australia and New Zealand",
				States: [],
			},
			{
				TwoDigit: "CC",
				ThreeDigit: "CCK",
				Name: "Cocos (Keeling) Islands",
				Capital: "West Island",
				Region: "Oceania",
				Subregion: "Australia and New Zealand",
				States: [],
			},
			{
				TwoDigit: "CO",
				ThreeDigit: "COL",
				Name: "Colombia",
				Capital: "Bogotá",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "AMA",
						Name: "Amazonas",
						Subdivision: null,
					},
					{
						StateCode: "ANT",
						Name: "Antioquia",
						Subdivision: null,
					},
					{
						StateCode: "ARA",
						Name: "Arauca",
						Subdivision: null,
					},
					{
						StateCode: "ATL",
						Name: "Atlántico",
						Subdivision: null,
					},
					{
						StateCode: "BOL",
						Name: "Bolívar",
						Subdivision: null,
					},
					{
						StateCode: "BOY",
						Name: "Boyacá",
						Subdivision: null,
					},
					{
						StateCode: "CAL",
						Name: "Caldas",
						Subdivision: null,
					},
					{
						StateCode: "CAQ",
						Name: "Caquetá",
						Subdivision: null,
					},
					{
						StateCode: "CAS",
						Name: "Casanare",
						Subdivision: null,
					},
					{
						StateCode: "CAU",
						Name: "Cauca",
						Subdivision: null,
					},
					{
						StateCode: "CES",
						Name: "Cesar",
						Subdivision: null,
					},
					{
						StateCode: "CHO",
						Name: "Chocó",
						Subdivision: null,
					},
					{
						StateCode: "CUN",
						Name: "Cundinamarca",
						Subdivision: null,
					},
					{
						StateCode: "COR",
						Name: "Córdoba",
						Subdivision: null,
					},
					{
						StateCode: "DC",
						Name: "Distrito Capital de Bogotá",
						Subdivision: null,
					},
					{
						StateCode: "GUA",
						Name: "Guainía",
						Subdivision: null,
					},
					{
						StateCode: "GUV",
						Name: "Guaviare",
						Subdivision: null,
					},
					{
						StateCode: "HUI",
						Name: "Huila",
						Subdivision: null,
					},
					{
						StateCode: "LAG",
						Name: "La Guajira",
						Subdivision: null,
					},
					{
						StateCode: "MAG",
						Name: "Magdalena",
						Subdivision: null,
					},
					{
						StateCode: "MET",
						Name: "Meta",
						Subdivision: null,
					},
					{
						StateCode: "NAR",
						Name: "Nariño",
						Subdivision: null,
					},
					{
						StateCode: "NSA",
						Name: "Norte de Santander",
						Subdivision: null,
					},
					{
						StateCode: "PUT",
						Name: "Putumayo",
						Subdivision: null,
					},
					{
						StateCode: "QUI",
						Name: "Quindío",
						Subdivision: null,
					},
					{
						StateCode: "RIS",
						Name: "Risaralda",
						Subdivision: null,
					},
					{
						StateCode: "SAP",
						Name: "San Andrés, Providencia y Santa Catalina",
						Subdivision: null,
					},
					{
						StateCode: "SAN",
						Name: "Santander",
						Subdivision: null,
					},
					{
						StateCode: "SUC",
						Name: "Sucre",
						Subdivision: null,
					},
					{
						StateCode: "TOL",
						Name: "Tolima",
						Subdivision: null,
					},
					{
						StateCode: "VAC",
						Name: "Valle del Cauca",
						Subdivision: null,
					},
					{
						StateCode: "VAU",
						Name: "Vaupés",
						Subdivision: null,
					},
					{
						StateCode: "VID",
						Name: "Vichada",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KM",
				ThreeDigit: "COM",
				Name: "Comoros",
				Capital: "Moroni",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "A",
						Name: "Anjouan",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Grande Comore",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Mohéli",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CG",
				ThreeDigit: "COG",
				Name: "Republic of the Congo",
				Capital: "Brazzaville",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "11",
						Name: "Bouenza",
						Subdivision: null,
					},
					{
						StateCode: "BZV",
						Name: "Brazzaville",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Cuvette",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Cuvette-Ouest",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Kouilou",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "Likouala",
						Subdivision: null,
					},
					{
						StateCode: "2",
						Name: "Lékoumou",
						Subdivision: null,
					},
					{
						StateCode: "9",
						Name: "Niari",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Plateaux",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Pointe-Noire",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Pool",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Sangha",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CD",
				ThreeDigit: "COD",
				Name: "Democratic Republic of the Congo",
				Capital: "Kinshasa",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "BN",
						Name: "Bandundu",
						Subdivision: null,
					},
					{
						StateCode: "BC",
						Name: "Bas-Congo",
						Subdivision: null,
					},
					{
						StateCode: "KW",
						Name: "Kasai-Occidental",
						Subdivision: null,
					},
					{
						StateCode: "KE",
						Name: "Kasai-Oriental",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Katanga",
						Subdivision: null,
					},
					{
						StateCode: "KN",
						Name: "Kinshasa",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Maniema",
						Subdivision: null,
					},
					{
						StateCode: "NK",
						Name: "Nord-Kivu",
						Subdivision: null,
					},
					{
						StateCode: "OR",
						Name: "Orientale",
						Subdivision: null,
					},
					{
						StateCode: "SK",
						Name: "Sud-Kivu",
						Subdivision: null,
					},
					{
						StateCode: "EQ",
						Name: "Équateur",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CK",
				ThreeDigit: "COK",
				Name: "Cook Islands",
				Capital: "Avarua",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [],
			},
			{
				TwoDigit: "CR",
				ThreeDigit: "CRI",
				Name: "Costa Rica",
				Capital: "San José",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "A",
						Name: "Alajuela",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Cartago",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Guanacaste",
						Subdivision: null,
					},
					{
						StateCode: "H",
						Name: "Heredia",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Limón",
						Subdivision: null,
					},
					{
						StateCode: "P",
						Name: "Puntarenas",
						Subdivision: null,
					},
					{
						StateCode: "SJ",
						Name: "San José",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "HR",
				ThreeDigit: "HRV",
				Name: "Croatia",
				Capital: "Zagreb",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "07",
						Name: "Bjelovarsko-bilogorska županija",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Brodsko-posavska županija",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Dubrovačko-neretvanska županija",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Grad Zagreb",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Istarska županija",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Karlovačka županija",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Koprivničko-križevačka županija",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Krapinsko-zagorska županija",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Ličko-senjska županija",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Međimurska županija",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Osječko-baranjska županija",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Požeško-slavonska županija",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Primorsko-goranska županija",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Sisačko-moslavačka županija",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Splitsko-dalmatinska županija",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Varaždinska županija",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Virovitičko-podravska županija",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Vukovarsko-srijemska županija",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Zadarska županija",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Zagrebačka županija",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Šibensko-kninska županija",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CU",
				ThreeDigit: "CUB",
				Name: "Cuba",
				Capital: "Havana",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "15",
						Name: "Artemisa",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Camagüey",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Ciego de Ávila",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Cienfuegos",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Granma",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Guantánamo",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Holguín",
						Subdivision: null,
					},
					{
						StateCode: "99",
						Name: "Isla de la Juventud",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "La Habana",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Las Tunas",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Matanzas",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Mayabeque",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Pinar del Río",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Sancti Spíritus",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Santiago de Cuba",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Villa Clara",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CW",
				ThreeDigit: "CUW",
				Name: "Curaçao",
				Capital: "Willemstad",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "CY",
				ThreeDigit: "CYP",
				Name: "Cyprus",
				Capital: "Nicosia",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "04",
						Name: "Ammochostos",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Keryneia",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Larnaka",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Lefkosia",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Lemesos",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Pafos",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CZ",
				ThreeDigit: "CZE",
				Name: "Czech Republic",
				Capital: "Prague",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "JM",
						Name: "Jihomoravský kraj",
						Subdivision: null,
					},
					{
						StateCode: "JC",
						Name: "Jihočeský kraj",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Karlovarský kraj",
						Subdivision: null,
					},
					{
						StateCode: "KR",
						Name: "Královéhradecký kraj",
						Subdivision: null,
					},
					{
						StateCode: "LI",
						Name: "Liberecký kraj",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Moravskoslezský kraj",
						Subdivision: null,
					},
					{
						StateCode: "OL",
						Name: "Olomoucký kraj",
						Subdivision: null,
					},
					{
						StateCode: "PA",
						Name: "Pardubický kraj",
						Subdivision: null,
					},
					{
						StateCode: "PL",
						Name: "Plzeňský kraj",
						Subdivision: null,
					},
					{
						StateCode: "PR",
						Name: "Praha, hlavní město",
						Subdivision: null,
					},
					{
						StateCode: "ST",
						Name: "Středočeský kraj",
						Subdivision: null,
					},
					{
						StateCode: "VY",
						Name: "Vysočina",
						Subdivision: null,
					},
					{
						StateCode: "ZL",
						Name: "Zlínský kraj",
						Subdivision: null,
					},
					{
						StateCode: "US",
						Name: "Ústecký kraj",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "DK",
				ThreeDigit: "DNK",
				Name: "Denmark",
				Capital: "Copenhagen",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "84",
						Name: "Hovedstaden",
						Subdivision: null,
					},
					{
						StateCode: "82",
						Name: "Midtjylland",
						Subdivision: null,
					},
					{
						StateCode: "81",
						Name: "Nordjylland",
						Subdivision: null,
					},
					{
						StateCode: "85",
						Name: "Sjælland",
						Subdivision: null,
					},
					{
						StateCode: "83",
						Name: "Syddanmark",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "DJ",
				ThreeDigit: "DJI",
				Name: "Djibouti",
				Capital: "Djibouti",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "AS",
						Name: "Ali Sabieh",
						Subdivision: null,
					},
					{
						StateCode: "AR",
						Name: "Arta",
						Subdivision: null,
					},
					{
						StateCode: "DI",
						Name: "Dikhil",
						Subdivision: null,
					},
					{
						StateCode: "DJ",
						Name: "Djibouti",
						Subdivision: null,
					},
					{
						StateCode: "OB",
						Name: "Obock",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tadjourah",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "DM",
				ThreeDigit: "DMA",
				Name: "Dominica",
				Capital: "Roseau",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "02",
						Name: "Saint Andrew",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Saint David",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Saint George",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Saint John",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Saint Joseph",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Saint Luke",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Saint Mark",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Saint Patrick",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Saint Paul",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Saint Peter",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "DO",
				ThreeDigit: "DOM",
				Name: "Dominican Republic",
				Capital: "Santo Domingo",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "33",
						Name: "Cibao Nordeste",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Cibao Noroeste",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Cibao Norte",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Cibao Sur",
						Subdivision: null,
					},
					{
						StateCode: "37",
						Name: "El Valle",
						Subdivision: null,
					},
					{
						StateCode: "38",
						Name: "Enriquillo",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Higuamo",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Ozama",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Valdesia",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Yuma",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "EC",
				ThreeDigit: "ECU",
				Name: "Ecuador",
				Capital: "Quito",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "A",
						Name: "Azuay",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "Bolívar",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Carchi",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Cañar",
						Subdivision: null,
					},
					{
						StateCode: "H",
						Name: "Chimborazo",
						Subdivision: null,
					},
					{
						StateCode: "X",
						Name: "Cotopaxi",
						Subdivision: null,
					},
					{
						StateCode: "O",
						Name: "El Oro",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Esmeraldas",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Galápagos",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Guayas",
						Subdivision: null,
					},
					{
						StateCode: "I",
						Name: "Imbabura",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Loja",
						Subdivision: null,
					},
					{
						StateCode: "R",
						Name: "Los Ríos",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Manabí",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Morona-Santiago",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Napo",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Orellana",
						Subdivision: null,
					},
					{
						StateCode: "Y",
						Name: "Pastaza",
						Subdivision: null,
					},
					{
						StateCode: "P",
						Name: "Pichincha",
						Subdivision: null,
					},
					{
						StateCode: "SE",
						Name: "Santa Elena",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Santo Domingo de los Tsáchilas",
						Subdivision: null,
					},
					{
						StateCode: "U",
						Name: "Sucumbíos",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Tungurahua",
						Subdivision: null,
					},
					{
						StateCode: "Z",
						Name: "Zamora-Chinchipe",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "EG",
				ThreeDigit: "EGY",
				Name: "Egypt",
				Capital: "Cairo",
				Region: "Africa",
				Subregion: "Northern Africa",
				States: [
					{
						StateCode: "DK",
						Name: "Ad Daqahlīyah",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Al Baḩr al Aḩmar",
						Subdivision: null,
					},
					{
						StateCode: "BH",
						Name: "Al Buḩayrah",
						Subdivision: null,
					},
					{
						StateCode: "FYM",
						Name: "Al Fayyūm",
						Subdivision: null,
					},
					{
						StateCode: "GH",
						Name: "Al Gharbīyah",
						Subdivision: null,
					},
					{
						StateCode: "ALX",
						Name: "Al Iskandarīyah",
						Subdivision: null,
					},
					{
						StateCode: "IS",
						Name: "Al Ismāٰīlīyah",
						Subdivision: null,
					},
					{
						StateCode: "GZ",
						Name: "Al Jīzah",
						Subdivision: null,
					},
					{
						StateCode: "MN",
						Name: "Al Minyā",
						Subdivision: null,
					},
					{
						StateCode: "MNF",
						Name: "Al Minūfīyah",
						Subdivision: null,
					},
					{
						StateCode: "KB",
						Name: "Al Qalyūbīyah",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Al Qāhirah",
						Subdivision: null,
					},
					{
						StateCode: "LX",
						Name: "Al Uqşur",
						Subdivision: null,
					},
					{
						StateCode: "WAD",
						Name: "Al Wādī al Jadīd",
						Subdivision: null,
					},
					{
						StateCode: "SUZ",
						Name: "As Suways",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "As Sādis min Uktūbar",
						Subdivision: null,
					},
					{
						StateCode: "SHR",
						Name: "Ash Sharqīyah",
						Subdivision: null,
					},
					{
						StateCode: "ASN",
						Name: "Aswān",
						Subdivision: null,
					},
					{
						StateCode: "AST",
						Name: "Asyūţ",
						Subdivision: null,
					},
					{
						StateCode: "BNS",
						Name: "Banī Suwayf",
						Subdivision: null,
					},
					{
						StateCode: "PTS",
						Name: "Būr Saٰīd",
						Subdivision: null,
					},
					{
						StateCode: "DT",
						Name: "Dumyāţ",
						Subdivision: null,
					},
					{
						StateCode: "JS",
						Name: "Janūb Sīnā'",
						Subdivision: null,
					},
					{
						StateCode: "KFS",
						Name: "Kafr ash Shaykh",
						Subdivision: null,
					},
					{
						StateCode: "MT",
						Name: "Maţrūḩ",
						Subdivision: null,
					},
					{
						StateCode: "KN",
						Name: "Qinā",
						Subdivision: null,
					},
					{
						StateCode: "SIN",
						Name: "Shamāl Sīnā'",
						Subdivision: null,
					},
					{
						StateCode: "SHG",
						Name: "Sūhāj",
						Subdivision: null,
					},
					{
						StateCode: "HU",
						Name: "Ḩulwān",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SV",
				ThreeDigit: "SLV",
				Name: "El Salvador",
				Capital: "San Salvador",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "AH",
						Name: "Ahuachapán",
						Subdivision: null,
					},
					{
						StateCode: "CA",
						Name: "Cabañas",
						Subdivision: null,
					},
					{
						StateCode: "CH",
						Name: "Chalatenango",
						Subdivision: null,
					},
					{
						StateCode: "CU",
						Name: "Cuscatlán",
						Subdivision: null,
					},
					{
						StateCode: "LI",
						Name: "La Libertad",
						Subdivision: null,
					},
					{
						StateCode: "PA",
						Name: "La Paz",
						Subdivision: null,
					},
					{
						StateCode: "UN",
						Name: "La Unión",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Morazán",
						Subdivision: null,
					},
					{
						StateCode: "SM",
						Name: "San Miguel",
						Subdivision: null,
					},
					{
						StateCode: "SS",
						Name: "San Salvador",
						Subdivision: null,
					},
					{
						StateCode: "SV",
						Name: "San Vicente",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Santa Ana",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Sonsonate",
						Subdivision: null,
					},
					{
						StateCode: "US",
						Name: "Usulután",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GQ",
				ThreeDigit: "GNQ",
				Name: "Equatorial Guinea",
				Capital: "Malabo",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "C",
						Name: "Región Continental",
						Subdivision: null,
					},
					{
						StateCode: "I",
						Name: "Región Insular",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ER",
				ThreeDigit: "ERI",
				Name: "Eritrea",
				Capital: "Asmara",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "MA",
						Name: "Al Awsaţ",
						Subdivision: null,
					},
					{
						StateCode: "DU",
						Name: "Al Janūbĩ",
						Subdivision: null,
					},
					{
						StateCode: "AN",
						Name: "Ansabā",
						Subdivision: null,
					},
					{
						StateCode: "DK",
						Name: "Janūbī al Baḩrī al Aḩmar",
						Subdivision: null,
					},
					{
						StateCode: "GB",
						Name: "Qāsh-Barkah",
						Subdivision: null,
					},
					{
						StateCode: "SK",
						Name: "Shimālī al Baḩrī al Aḩmar",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "EE",
				ThreeDigit: "EST",
				Name: "Estonia",
				Capital: "Tallinn",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "37",
						Name: "Harjumaa",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Hiiumaa",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Ida-Virumaa",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "Järvamaa",
						Subdivision: null,
					},
					{
						StateCode: "49",
						Name: "Jõgevamaa",
						Subdivision: null,
					},
					{
						StateCode: "59",
						Name: "Lääne-Virumaa",
						Subdivision: null,
					},
					{
						StateCode: "57",
						Name: "Läänemaa",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Pärnumaa",
						Subdivision: null,
					},
					{
						StateCode: "65",
						Name: "Põlvamaa",
						Subdivision: null,
					},
					{
						StateCode: "70",
						Name: "Raplamaa",
						Subdivision: null,
					},
					{
						StateCode: "74",
						Name: "Saaremaa",
						Subdivision: null,
					},
					{
						StateCode: "78",
						Name: "Tartumaa",
						Subdivision: null,
					},
					{
						StateCode: "82",
						Name: "Valgamaa",
						Subdivision: null,
					},
					{
						StateCode: "84",
						Name: "Viljandimaa",
						Subdivision: null,
					},
					{
						StateCode: "86",
						Name: "Võrumaa",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ET",
				ThreeDigit: "ETH",
				Name: "Ethiopia",
				Capital: "Addis Ababa",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "BE",
						Name: "Bīnshangul Gumuz",
						Subdivision: null,
					},
					{
						StateCode: "DD",
						Name: "Dirē Dawa",
						Subdivision: null,
					},
					{
						StateCode: "GA",
						Name: "Gambēla Hizboch",
						Subdivision: null,
					},
					{
						StateCode: "HA",
						Name: "Hārerī Hizb",
						Subdivision: null,
					},
					{
						StateCode: "OR",
						Name: "Oromīya",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Sumalē",
						Subdivision: null,
					},
					{
						StateCode: "TI",
						Name: "Tigray",
						Subdivision: null,
					},
					{
						StateCode: "SN",
						Name: "YeDebub Bihēroch Bihēreseboch na Hizboch",
						Subdivision: null,
					},
					{
						StateCode: "AA",
						Name: "Ādīs Ābeba",
						Subdivision: null,
					},
					{
						StateCode: "AF",
						Name: "Āfar",
						Subdivision: null,
					},
					{
						StateCode: "AM",
						Name: "Āmara",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "FK",
				ThreeDigit: "FLK",
				Name: "Falkland Islands",
				Capital: "Stanley",
				Region: "Americas",
				Subregion: "South America",
				States: [],
			},
			{
				TwoDigit: "FO",
				ThreeDigit: "FRO",
				Name: "Faroe Islands",
				Capital: "Tórshavn",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [],
			},
			{
				TwoDigit: "FJ",
				ThreeDigit: "FJI",
				Name: "Fiji",
				Capital: "Suva",
				Region: "Oceania",
				Subregion: "Melanesia",
				States: [
					{
						StateCode: "C",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Eastern",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Northern",
						Subdivision: null,
					},
					{
						StateCode: "R",
						Name: "Rotuma",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Western",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "FI",
				ThreeDigit: "FIN",
				Name: "Finland",
				Capital: "Helsinki",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Ahvenanmaan maakunta",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Etelä-Karjala",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Etelä-Pohjanmaa",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Etelä-Savo",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Kainuu",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Kanta-Häme",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Keski-Pohjanmaa",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Keski-Suomi",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Kymenlaakso",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Lappi",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Pirkanmaa",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Pohjanmaa",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Pohjois-Karjala",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Pohjois-Pohjanmaa",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Pohjois-Savo",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Päijät-Häme",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Satakunta",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Uusimaa",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Varsinais-Suomi",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "FR",
				ThreeDigit: "FRA",
				Name: "France",
				Capital: "Paris",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "A",
						Name: "Alsace",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "B",
						Name: "Aquitaine",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "C",
						Name: "Auvergne",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "E",
						Name: "Brittany",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "D",
						Name: "Burgundy",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "F",
						Name: "Centre-Val de Loire",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "G",
						Name: "Champagne-Ardenne",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "H",
						Name: "Corsica",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "I",
						Name: "Franche-Comté",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "K",
						Name: "Languedoc-Roussillon",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "L",
						Name: "Limousin",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "M",
						Name: "Lorraine",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "P",
						Name: "Lower Normandy",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "N",
						Name: "Midi-Pyrénées",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "O",
						Name: "Nord-Pas-de-Calais",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "R",
						Name: "Pays de la Loire",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "S",
						Name: "Picardy",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "T",
						Name: "Poitou-Charentes",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "U",
						Name: "Provence-Alpes-Côte d'Azur",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "V",
						Name: "Rhône-Alpes",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "Q",
						Name: "Upper Normandy",
						Subdivision: "Metropolitan region",
					},
					{
						StateCode: "J",
						Name: "Île-de-France",
						Subdivision: "Metropolitan region",
					},
				],
			},
			{
				TwoDigit: "GF",
				ThreeDigit: "GUF",
				Name: "French Guiana",
				Capital: "Cayenne",
				Region: "Americas",
				Subregion: "South America",
				States: [],
			},
			{
				TwoDigit: "PF",
				ThreeDigit: "PYF",
				Name: "French Polynesia",
				Capital: "Papeetē",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [],
			},
			{
				TwoDigit: "TF",
				ThreeDigit: "ATF",
				Name: "French Southern and Antarctic Lands",
				Capital: "Port-aux-Français",
				Region: "Africa",
				Subregion: "Southern Africa",
				States: [],
			},
			{
				TwoDigit: "GA",
				ThreeDigit: "GAB",
				Name: "Gabon",
				Capital: "Libreville",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "1",
						Name: "Estuaire",
						Subdivision: null,
					},
					{
						StateCode: "2",
						Name: "Haut-Ogooué",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Moyen-Ogooué",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Ngounié",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Nyanga",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "Ogooué-Ivindo",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "Ogooué-Lolo",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Ogooué-Maritime",
						Subdivision: null,
					},
					{
						StateCode: "9",
						Name: "Woleu-Ntem",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GM",
				ThreeDigit: "GMB",
				Name: "The Gambia",
				Capital: "Banjul",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "B",
						Name: "Banjul",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Central River",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Lower River",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "North Bank",
						Subdivision: null,
					},
					{
						StateCode: "U",
						Name: "Upper River",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Western",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GE",
				ThreeDigit: "GEO",
				Name: "Georgia",
				Capital: "Tbilisi",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "AB",
						Name: "Abkhazia",
						Subdivision: null,
					},
					{
						StateCode: "AJ",
						Name: "Ajaria",
						Subdivision: null,
					},
					{
						StateCode: "GU",
						Name: "Guria",
						Subdivision: null,
					},
					{
						StateCode: "IM",
						Name: "Imereti",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "K'akheti",
						Subdivision: null,
					},
					{
						StateCode: "KK",
						Name: "Kvemo Kartli",
						Subdivision: null,
					},
					{
						StateCode: "MM",
						Name: "Mtskheta-Mtianeti",
						Subdivision: null,
					},
					{
						StateCode: "RL",
						Name: "Rach'a-Lechkhumi-Kvemo Svaneti",
						Subdivision: null,
					},
					{
						StateCode: "SZ",
						Name: "Samegrelo-Zemo Svaneti",
						Subdivision: null,
					},
					{
						StateCode: "SJ",
						Name: "Samtskhe-Javakheti",
						Subdivision: null,
					},
					{
						StateCode: "SK",
						Name: "Shida Kartli",
						Subdivision: null,
					},
					{
						StateCode: "TB",
						Name: "Tbilisi",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "DE",
				ThreeDigit: "DEU",
				Name: "Germany",
				Capital: "Berlin",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "BW",
						Name: "Baden-Württemberg",
						Subdivision: null,
					},
					{
						StateCode: "BY",
						Name: "Bayern",
						Subdivision: null,
					},
					{
						StateCode: "BE",
						Name: "Berlin",
						Subdivision: null,
					},
					{
						StateCode: "BB",
						Name: "Brandenburg",
						Subdivision: null,
					},
					{
						StateCode: "HB",
						Name: "Bremen",
						Subdivision: null,
					},
					{
						StateCode: "HH",
						Name: "Hamburg",
						Subdivision: null,
					},
					{
						StateCode: "HE",
						Name: "Hessen",
						Subdivision: null,
					},
					{
						StateCode: "MV",
						Name: "Mecklenburg-Vorpommern",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Niedersachsen",
						Subdivision: null,
					},
					{
						StateCode: "NW",
						Name: "Nordrhein-Westfalen",
						Subdivision: null,
					},
					{
						StateCode: "RP",
						Name: "Rheinland-Pfalz",
						Subdivision: null,
					},
					{
						StateCode: "SL",
						Name: "Saarland",
						Subdivision: null,
					},
					{
						StateCode: "SN",
						Name: "Sachsen",
						Subdivision: null,
					},
					{
						StateCode: "ST",
						Name: "Sachsen-Anhalt",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Schleswig-Holstein",
						Subdivision: null,
					},
					{
						StateCode: "TH",
						Name: "Thüringen",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GH",
				ThreeDigit: "GHA",
				Name: "Ghana",
				Capital: "Accra",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "AH",
						Name: "Ashanti",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Brong-Ahafo",
						Subdivision: null,
					},
					{
						StateCode: "CP",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "EP",
						Name: "Eastern",
						Subdivision: null,
					},
					{
						StateCode: "AA",
						Name: "Greater Accra",
						Subdivision: null,
					},
					{
						StateCode: "NP",
						Name: "Northern",
						Subdivision: null,
					},
					{
						StateCode: "UE",
						Name: "Upper East",
						Subdivision: null,
					},
					{
						StateCode: "UW",
						Name: "Upper West",
						Subdivision: null,
					},
					{
						StateCode: "TV",
						Name: "Volta",
						Subdivision: null,
					},
					{
						StateCode: "WP",
						Name: "Western",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GI",
				ThreeDigit: "GIB",
				Name: "Gibraltar",
				Capital: "Gibraltar",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [],
			},
			{
				TwoDigit: "GR",
				ThreeDigit: "GRC",
				Name: "Greece",
				Capital: "Athens",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "A",
						Name: "Anatoliki Makedonia kai Thraki",
						Subdivision: null,
					},
					{
						StateCode: "I",
						Name: "Attiki",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Dytiki Ellada",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Dytiki Makedonia",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Ionia Nisia",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Ipeiros",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "Kentriki Makedonia",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Kriti",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Notio Aigaio",
						Subdivision: null,
					},
					{
						StateCode: "J",
						Name: "Peloponnisos",
						Subdivision: null,
					},
					{
						StateCode: "H",
						Name: "Sterea Ellada",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Thessalia",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Voreio Aigaio",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GL",
				ThreeDigit: "GRL",
				Name: "Greenland",
				Capital: "Nuuk",
				Region: "Americas",
				Subregion: "Northern America",
				States: [
					{
						StateCode: "KU",
						Name: "Kommune Kujalleq",
						Subdivision: null,
					},
					{
						StateCode: "SM",
						Name: "Kommuneqarfik Sermersooq",
						Subdivision: null,
					},
					{
						StateCode: "QA",
						Name: "Qaasuitsup Kommunia",
						Subdivision: null,
					},
					{
						StateCode: "QE",
						Name: "Qeqqata Kommunia",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GD",
				ThreeDigit: "GRD",
				Name: "Grenada",
				Capital: "St. George's",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "01",
						Name: "Saint Andrew",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Saint David",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Saint George",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Saint John",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Saint Mark",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Saint Patrick",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Southern Grenadine Islands",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GP",
				ThreeDigit: "GLP",
				Name: "Guadeloupe",
				Capital: "Basse-Terre",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "GU",
				ThreeDigit: "GUM",
				Name: "Guam",
				Capital: "Hagåtña",
				Region: "Oceania",
				Subregion: "Micronesia",
				States: [],
			},
			{
				TwoDigit: "GT",
				ThreeDigit: "GTM",
				Name: "Guatemala",
				Capital: "Guatemala City",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "AV",
						Name: "Alta Verapaz",
						Subdivision: null,
					},
					{
						StateCode: "BV",
						Name: "Baja Verapaz",
						Subdivision: null,
					},
					{
						StateCode: "CM",
						Name: "Chimaltenango",
						Subdivision: null,
					},
					{
						StateCode: "CQ",
						Name: "Chiquimula",
						Subdivision: null,
					},
					{
						StateCode: "PR",
						Name: "El Progreso",
						Subdivision: null,
					},
					{
						StateCode: "ES",
						Name: "Escuintla",
						Subdivision: null,
					},
					{
						StateCode: "GU",
						Name: "Guatemala",
						Subdivision: null,
					},
					{
						StateCode: "HU",
						Name: "Huehuetenango",
						Subdivision: null,
					},
					{
						StateCode: "IZ",
						Name: "Izabal",
						Subdivision: null,
					},
					{
						StateCode: "JA",
						Name: "Jalapa",
						Subdivision: null,
					},
					{
						StateCode: "JU",
						Name: "Jutiapa",
						Subdivision: null,
					},
					{
						StateCode: "PE",
						Name: "Petén",
						Subdivision: null,
					},
					{
						StateCode: "QZ",
						Name: "Quetzaltenango",
						Subdivision: null,
					},
					{
						StateCode: "QC",
						Name: "Quiché",
						Subdivision: null,
					},
					{
						StateCode: "RE",
						Name: "Retalhuleu",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Sacatepéquez",
						Subdivision: null,
					},
					{
						StateCode: "SM",
						Name: "San Marcos",
						Subdivision: null,
					},
					{
						StateCode: "SR",
						Name: "Santa Rosa",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Sololá",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "Suchitepéquez",
						Subdivision: null,
					},
					{
						StateCode: "TO",
						Name: "Totonicapán",
						Subdivision: null,
					},
					{
						StateCode: "ZA",
						Name: "Zacapa",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GG",
				ThreeDigit: "GGY",
				Name: "Guernsey",
				Capital: "St. Peter Port",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [],
			},
			{
				TwoDigit: "GN",
				ThreeDigit: "GIN",
				Name: "Guinea",
				Capital: "Conakry",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "B",
						Name: "Boké",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Conakry",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Faranah",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Kankan",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Kindia",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Labé",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Mamou",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Nzérékoré",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GW",
				ThreeDigit: "GNB",
				Name: "Guinea-Bissau",
				Capital: "Bissau",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "L",
						Name: "Leste",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Norte",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Sul",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GY",
				ThreeDigit: "GUY",
				Name: "Guyana",
				Capital: "Georgetown",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "BA",
						Name: "Barima-Waini",
						Subdivision: null,
					},
					{
						StateCode: "CU",
						Name: "Cuyuni-Mazaruni",
						Subdivision: null,
					},
					{
						StateCode: "DE",
						Name: "Demerara-Mahaica",
						Subdivision: null,
					},
					{
						StateCode: "EB",
						Name: "East Berbice-Corentyne",
						Subdivision: null,
					},
					{
						StateCode: "ES",
						Name: "Essequibo Islands-West Demerara",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Mahaica-Berbice",
						Subdivision: null,
					},
					{
						StateCode: "PM",
						Name: "Pomeroon-Supenaam",
						Subdivision: null,
					},
					{
						StateCode: "PT",
						Name: "Potaro-Siparuni",
						Subdivision: null,
					},
					{
						StateCode: "UD",
						Name: "Upper Demerara-Berbice",
						Subdivision: null,
					},
					{
						StateCode: "UT",
						Name: "Upper Takutu-Upper Essequibo",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "HT",
				ThreeDigit: "HTI",
				Name: "Haiti",
				Capital: "Port-au-Prince",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "AR",
						Name: "Artibonite",
						Subdivision: null,
					},
					{
						StateCode: "CE",
						Name: "Centre",
						Subdivision: null,
					},
					{
						StateCode: "GA",
						Name: "Grande-Anse",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Nippes",
						Subdivision: null,
					},
					{
						StateCode: "ND",
						Name: "Nord",
						Subdivision: null,
					},
					{
						StateCode: "NE",
						Name: "Nord-Est",
						Subdivision: null,
					},
					{
						StateCode: "NO",
						Name: "Nord-Ouest",
						Subdivision: null,
					},
					{
						StateCode: "OU",
						Name: "Ouest",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Sud",
						Subdivision: null,
					},
					{
						StateCode: "SE",
						Name: "Sud-Est",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "HM",
				ThreeDigit: "HMD",
				Name: "Heard Island and McDonald Islands",
				Capital: "",
				Region: "",
				Subregion: "",
				States: [],
			},
			{
				TwoDigit: "VA",
				ThreeDigit: "VAT",
				Name: "Holy See",
				Capital: "Rome",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [],
			},
			{
				TwoDigit: "HN",
				ThreeDigit: "HND",
				Name: "Honduras",
				Capital: "Tegucigalpa",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "AT",
						Name: "Atlántida",
						Subdivision: null,
					},
					{
						StateCode: "CH",
						Name: "Choluteca",
						Subdivision: null,
					},
					{
						StateCode: "CL",
						Name: "Colón",
						Subdivision: null,
					},
					{
						StateCode: "CM",
						Name: "Comayagua",
						Subdivision: null,
					},
					{
						StateCode: "CP",
						Name: "Copán",
						Subdivision: null,
					},
					{
						StateCode: "CR",
						Name: "Cortés",
						Subdivision: null,
					},
					{
						StateCode: "EP",
						Name: "El Paraíso",
						Subdivision: null,
					},
					{
						StateCode: "FM",
						Name: "Francisco Morazán",
						Subdivision: null,
					},
					{
						StateCode: "GD",
						Name: "Gracias a Dios",
						Subdivision: null,
					},
					{
						StateCode: "IN",
						Name: "Intibucá",
						Subdivision: null,
					},
					{
						StateCode: "IB",
						Name: "Islas de la Bahía",
						Subdivision: null,
					},
					{
						StateCode: "LP",
						Name: "La Paz",
						Subdivision: null,
					},
					{
						StateCode: "LE",
						Name: "Lempira",
						Subdivision: null,
					},
					{
						StateCode: "OC",
						Name: "Ocotepeque",
						Subdivision: null,
					},
					{
						StateCode: "OL",
						Name: "Olancho",
						Subdivision: null,
					},
					{
						StateCode: "SB",
						Name: "Santa Bárbara",
						Subdivision: null,
					},
					{
						StateCode: "VA",
						Name: "Valle",
						Subdivision: null,
					},
					{
						StateCode: "YO",
						Name: "Yoro",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "HK",
				ThreeDigit: "HKG",
				Name: "Hong Kong",
				Capital: "City of Victoria",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [],
			},
			{
				TwoDigit: "HU",
				ThreeDigit: "HUN",
				Name: "Hungary",
				Capital: "Budapest",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "BA",
						Name: "Baranya",
						Subdivision: null,
					},
					{
						StateCode: "BZ",
						Name: "Borsod-Abaúj-Zemplén",
						Subdivision: null,
					},
					{
						StateCode: "BU",
						Name: "Budapest",
						Subdivision: null,
					},
					{
						StateCode: "BK",
						Name: "Bács-Kiskun",
						Subdivision: null,
					},
					{
						StateCode: "BE",
						Name: "Békés",
						Subdivision: null,
					},
					{
						StateCode: "BC",
						Name: "Békéscsaba",
						Subdivision: null,
					},
					{
						StateCode: "CS",
						Name: "Csongrád",
						Subdivision: null,
					},
					{
						StateCode: "DE",
						Name: "Debrecen",
						Subdivision: null,
					},
					{
						StateCode: "DU",
						Name: "Dunaújváros",
						Subdivision: null,
					},
					{
						StateCode: "EG",
						Name: "Eger",
						Subdivision: null,
					},
					{
						StateCode: "FE",
						Name: "Fejér",
						Subdivision: null,
					},
					{
						StateCode: "GY",
						Name: "Győr",
						Subdivision: null,
					},
					{
						StateCode: "GS",
						Name: "Győr-Moson-Sopron",
						Subdivision: null,
					},
					{
						StateCode: "HB",
						Name: "Hajdú-Bihar",
						Subdivision: null,
					},
					{
						StateCode: "HE",
						Name: "Heves",
						Subdivision: null,
					},
					{
						StateCode: "HV",
						Name: "Hódmezővásárhely",
						Subdivision: null,
					},
					{
						StateCode: "JN",
						Name: "Jász-Nagykun-Szolnok",
						Subdivision: null,
					},
					{
						StateCode: "KV",
						Name: "Kaposvár",
						Subdivision: null,
					},
					{
						StateCode: "KM",
						Name: "Kecskemét",
						Subdivision: null,
					},
					{
						StateCode: "KE",
						Name: "Komárom-Esztergom",
						Subdivision: null,
					},
					{
						StateCode: "MI",
						Name: "Miskolc",
						Subdivision: null,
					},
					{
						StateCode: "NK",
						Name: "Nagykanizsa",
						Subdivision: null,
					},
					{
						StateCode: "NY",
						Name: "Nyíregyháza",
						Subdivision: null,
					},
					{
						StateCode: "NO",
						Name: "Nógrád",
						Subdivision: null,
					},
					{
						StateCode: "PE",
						Name: "Pest",
						Subdivision: null,
					},
					{
						StateCode: "PS",
						Name: "Pécs",
						Subdivision: null,
					},
					{
						StateCode: "ST",
						Name: "Salgótarján",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Somogy",
						Subdivision: null,
					},
					{
						StateCode: "SN",
						Name: "Sopron",
						Subdivision: null,
					},
					{
						StateCode: "SZ",
						Name: "Szabolcs-Szatmár-Bereg",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Szeged",
						Subdivision: null,
					},
					{
						StateCode: "SS",
						Name: "Szekszárd",
						Subdivision: null,
					},
					{
						StateCode: "SK",
						Name: "Szolnok",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Szombathely",
						Subdivision: null,
					},
					{
						StateCode: "SF",
						Name: "Székesfehérvár",
						Subdivision: null,
					},
					{
						StateCode: "TB",
						Name: "Tatabánya",
						Subdivision: null,
					},
					{
						StateCode: "TO",
						Name: "Tolna",
						Subdivision: null,
					},
					{
						StateCode: "VA",
						Name: "Vas",
						Subdivision: null,
					},
					{
						StateCode: "VE",
						Name: "Veszprém",
						Subdivision: null,
					},
					{
						StateCode: "VM",
						Name: "Veszprém",
						Subdivision: null,
					},
					{
						StateCode: "ZA",
						Name: "Zala",
						Subdivision: null,
					},
					{
						StateCode: "ZE",
						Name: "Zalaegerszeg",
						Subdivision: null,
					},
					{
						StateCode: "ER",
						Name: "Érd",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IS",
				ThreeDigit: "ISL",
				Name: "Iceland",
				Capital: "Reykjavík",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "7",
						Name: "Austurland",
						Subdivision: null,
					},
					{
						StateCode: "1",
						Name: "Höfuðborgarsvæði utan Reykjavíkur",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "Norðurland eystra",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Norðurland vestra",
						Subdivision: null,
					},
					{
						StateCode: "0",
						Name: "Reykjavík",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Suðurland",
						Subdivision: null,
					},
					{
						StateCode: "2",
						Name: "Suðurnes",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Vestfirðir",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Vesturland",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IN",
				ThreeDigit: "IND",
				Name: "India",
				Capital: "New Delhi",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "AN",
						Name: "Andaman and Nicobar Islands",
						Subdivision: "Union territory",
					},
					{
						StateCode: "CH",
						Name: "Chandigarh",
						Subdivision: "Union territory",
					},
					{
						StateCode: "DN",
						Name: "Dadra and Nagar Haveli",
						Subdivision: "Union territory",
					},
					{
						StateCode: "DD",
						Name: "Daman and Diu",
						Subdivision: "Union territory",
					},
					{
						StateCode: "DL",
						Name: "Delhi",
						Subdivision: "Union territory",
					},
					{
						StateCode: "LD",
						Name: "Lakshadweep",
						Subdivision: "Union territory",
					},
					{
						StateCode: "PY",
						Name: "Puducherry",
						Subdivision: "Union territory",
					},
					{
						StateCode: "AP",
						Name: "Andhra Pradesh",
						Subdivision: "state",
					},
					{
						StateCode: "AR",
						Name: "Arunachal Pradesh",
						Subdivision: "state",
					},
					{
						StateCode: "AS",
						Name: "Assam",
						Subdivision: "state",
					},
					{
						StateCode: "BR",
						Name: "Bihar",
						Subdivision: "state",
					},
					{
						StateCode: "CT",
						Name: "Chhattisgarh",
						Subdivision: "state",
					},
					{
						StateCode: "GA",
						Name: "Goa",
						Subdivision: "state",
					},
					{
						StateCode: "GJ",
						Name: "Gujarat",
						Subdivision: "state",
					},
					{
						StateCode: "HR",
						Name: "Haryana",
						Subdivision: "state",
					},
					{
						StateCode: "HP",
						Name: "Himachal Pradesh",
						Subdivision: "state",
					},
					{
						StateCode: "JK",
						Name: "Jammu and Kashmir",
						Subdivision: "state",
					},
					{
						StateCode: "JH",
						Name: "Jharkhand",
						Subdivision: "state",
					},
					{
						StateCode: "KA",
						Name: "Karnataka",
						Subdivision: "state",
					},
					{
						StateCode: "KL",
						Name: "Kerala",
						Subdivision: "state",
					},
					{
						StateCode: "MP",
						Name: "Madhya Pradesh",
						Subdivision: "state",
					},
					{
						StateCode: "MH",
						Name: "Maharashtra",
						Subdivision: "state",
					},
					{
						StateCode: "MN",
						Name: "Manipur",
						Subdivision: "state",
					},
					{
						StateCode: "ML",
						Name: "Meghalaya",
						Subdivision: "state",
					},
					{
						StateCode: "MZ",
						Name: "Mizoram",
						Subdivision: "state",
					},
					{
						StateCode: "NL",
						Name: "Nagaland",
						Subdivision: "state",
					},
					{
						StateCode: "OR",
						Name: "Odisha",
						Subdivision: "state",
					},
					{
						StateCode: "PB",
						Name: "Punjab",
						Subdivision: "state",
					},
					{
						StateCode: "RJ",
						Name: "Rajasthan",
						Subdivision: "state",
					},
					{
						StateCode: "SK",
						Name: "Sikkim",
						Subdivision: "state",
					},
					{
						StateCode: "TN",
						Name: "Tamil Nadu",
						Subdivision: "state",
					},
					{
						StateCode: "TG",
						Name: "Telangana",
						Subdivision: "state",
					},
					{
						StateCode: "TR",
						Name: "Tripura",
						Subdivision: "state",
					},
					{
						StateCode: "UP",
						Name: "Uttar Pradesh",
						Subdivision: "state",
					},
					{
						StateCode: "UT",
						Name: "Uttarakhand",
						Subdivision: "state",
					},
					{
						StateCode: "WB",
						Name: "West Bengal",
						Subdivision: "state",
					},
				],
			},
			{
				TwoDigit: "ID",
				ThreeDigit: "IDN",
				Name: "Indonesia",
				Capital: "Jakarta",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "JW",
						Name: "Jawa",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Kalimantan",
						Subdivision: null,
					},
					{
						StateCode: "ML",
						Name: "Maluku",
						Subdivision: null,
					},
					{
						StateCode: "NU",
						Name: "Nusa Tenggara",
						Subdivision: null,
					},
					{
						StateCode: "PP",
						Name: "Papua",
						Subdivision: null,
					},
					{
						StateCode: "SL",
						Name: "Sulawesi",
						Subdivision: null,
					},
					{
						StateCode: "SM",
						Name: "Sumatera",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CI",
				ThreeDigit: "CIV",
				Name: "Ivory Coast",
				Capital: "Yamoussoukro",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "06",
						Name: "18 Montagnes",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Agnébi",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Bafing",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Bas-Sassandra",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Denguélé",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Fromager",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Haut-Sassandra",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Lacs",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Lagunes",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Marahoué",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Moyen-Cavally",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Moyen-Comoé",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Nzi-Comoé",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Savanes",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Sud-Bandama",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Sud-Comoé",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Vallée du Bandama",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Worodougou",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Zanzan",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IR",
				ThreeDigit: "IRN",
				Name: "Iran",
				Capital: "Tehran",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "32",
						Name: "Alborz",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Ardabīl",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Būshehr",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Chahār Maḩāll va Bakhtīārī",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Eşfahān",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Fārs",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Golestān",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Gīlān",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Hamadān",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Hormozgān",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Kermān",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Kermānshāh",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Khorāsān-e Janūbī",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Khorāsān-e Razavī",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Khorāsān-e Shemālī",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Khūzestān",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Kohgīlūyeh va Būyer Aḩmad",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Kordestān",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Lorestān",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Markazī",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Māzandarān",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Qazvīn",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Qom",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Semnān",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Sīstān va Balūchestān",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Tehrān",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Yazd",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Zanjān",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Āz̄arbāyjān-e Gharbī",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Āz̄arbāyjān-e Sharqī",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Īlām",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IQ",
				ThreeDigit: "IRQ",
				Name: "Iraq",
				Capital: "Baghdad",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "AN",
						Name: "Al Anbār",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Al Başrah",
						Subdivision: null,
					},
					{
						StateCode: "MU",
						Name: "Al Muthanná",
						Subdivision: null,
					},
					{
						StateCode: "QA",
						Name: "Al Qādisīyah",
						Subdivision: null,
					},
					{
						StateCode: "NA",
						Name: "An Najaf",
						Subdivision: null,
					},
					{
						StateCode: "AR",
						Name: "Arbīl",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "As Sulaymānīyah",
						Subdivision: null,
					},
					{
						StateCode: "TS",
						Name: "At Ta'mīm",
						Subdivision: null,
					},
					{
						StateCode: "BG",
						Name: "Baghdād",
						Subdivision: null,
					},
					{
						StateCode: "BB",
						Name: "Bābil",
						Subdivision: null,
					},
					{
						StateCode: "DA",
						Name: "Dahūk",
						Subdivision: null,
					},
					{
						StateCode: "DQ",
						Name: "Dhī Qār",
						Subdivision: null,
					},
					{
						StateCode: "DI",
						Name: "Diyālá",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Karbalā'",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Maysān",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Nīnawá",
						Subdivision: null,
					},
					{
						StateCode: "WA",
						Name: "Wāsiţ",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Şalāḩ ad Dīn",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IE",
				ThreeDigit: "IRL",
				Name: "Republic of Ireland",
				Capital: "Dublin",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "C",
						Name: "Connaught",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Leinster",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Munster",
						Subdivision: null,
					},
					{
						StateCode: "U",
						Name: "Ulster",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IM",
				ThreeDigit: "IMN",
				Name: "Isle of Man",
				Capital: "Douglas",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [],
			},
			{
				TwoDigit: "IL",
				ThreeDigit: "ISR",
				Name: "Israel",
				Capital: "Jerusalem",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "D",
						Name: "HaDarom",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "HaMerkaz",
						Subdivision: null,
					},
					{
						StateCode: "Z",
						Name: "HaTsafon",
						Subdivision: null,
					},
					{
						StateCode: "HA",
						Name: "H̱efa",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tel-Aviv",
						Subdivision: null,
					},
					{
						StateCode: "JM",
						Name: "Yerushalayim",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "IT",
				ThreeDigit: "ITA",
				Name: "Italy",
				Capital: "Rome",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "65",
						Name: "Abruzzo",
						Subdivision: null,
					},
					{
						StateCode: "77",
						Name: "Basilicata",
						Subdivision: null,
					},
					{
						StateCode: "78",
						Name: "Calabria",
						Subdivision: null,
					},
					{
						StateCode: "72",
						Name: "Campania",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Emilia-Romagna",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Friuli-Venezia Giulia",
						Subdivision: null,
					},
					{
						StateCode: "62",
						Name: "Lazio",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Liguria",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Lombardia",
						Subdivision: null,
					},
					{
						StateCode: "57",
						Name: "Marche",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Molise",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Piemonte",
						Subdivision: null,
					},
					{
						StateCode: "75",
						Name: "Puglia",
						Subdivision: null,
					},
					{
						StateCode: "88",
						Name: "Sardegna",
						Subdivision: null,
					},
					{
						StateCode: "82",
						Name: "Sicilia",
						Subdivision: null,
					},
					{
						StateCode: "52",
						Name: "Toscana",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Trentino-Alto Adige",
						Subdivision: null,
					},
					{
						StateCode: "55",
						Name: "Umbria",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Valle d'Aosta",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Veneto",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "JM",
				ThreeDigit: "JAM",
				Name: "Jamaica",
				Capital: "Kingston",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "13",
						Name: "Clarendon",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Hanover",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Kingston",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Manchester",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Portland",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Saint Andrew",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Saint Ann",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Saint Catherine",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Saint Elizabeth",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Saint James",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Saint Mary",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Saint Thomas",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Trelawny",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Westmoreland",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "JP",
				ThreeDigit: "JPN",
				Name: "Japan",
				Capital: "Tokyo",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [
					{
						StateCode: "23",
						Name: "Aiti",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Akita",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Aomori",
						Subdivision: null,
					},
					{
						StateCode: "38",
						Name: "Ehime",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Gihu",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Gunma",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Hirosima",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Hokkaidô",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Hukui",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Hukuoka",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Hukusima",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Hyôgo",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Ibaraki",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Isikawa",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Iwate",
						Subdivision: null,
					},
					{
						StateCode: "37",
						Name: "Kagawa",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Kagosima",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Kanagawa",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Kumamoto",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Kyôto",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Kôti",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Mie",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Miyagi",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Miyazaki",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Nagano",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Nagasaki",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Nara",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Niigata",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Okayama",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Okinawa",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Saga",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Saitama",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Siga",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Simane",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Sizuoka",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Tiba",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Tokusima",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Totigi",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Tottori",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Toyama",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Tôkyô",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Wakayama",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Yamagata",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Yamaguti",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Yamanasi",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Ôita",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Ôsaka",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "JE",
				ThreeDigit: "JEY",
				Name: "Jersey",
				Capital: "Saint Helier",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [],
			},
			{
				TwoDigit: "JO",
				ThreeDigit: "JOR",
				Name: "Jordan",
				Capital: "Amman",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "BA",
						Name: "Al Balqā'",
						Subdivision: null,
					},
					{
						StateCode: "AQ",
						Name: "Al ʽAqabah",
						Subdivision: null,
					},
					{
						StateCode: "AZ",
						Name: "Az Zarqā'",
						Subdivision: null,
					},
					{
						StateCode: "AT",
						Name: "Aţ Ţafīlah",
						Subdivision: null,
					},
					{
						StateCode: "IR",
						Name: "Irbid",
						Subdivision: null,
					},
					{
						StateCode: "JA",
						Name: "Jerash",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Karak",
						Subdivision: null,
					},
					{
						StateCode: "MN",
						Name: "Ma'ān",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Mafraq",
						Subdivision: null,
					},
					{
						StateCode: "MD",
						Name: "Mādabā",
						Subdivision: null,
					},
					{
						StateCode: "AJ",
						Name: "ʽAjlūn",
						Subdivision: null,
					},
					{
						StateCode: "AM",
						Name: "‘Ammān",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KZ",
				ThreeDigit: "KAZ",
				Name: "Kazakhstan",
				Capital: "Astana",
				Region: "Asia",
				Subregion: "Central Asia",
				States: [
					{
						StateCode: "ALA",
						Name: "Almaty",
						Subdivision: null,
					},
					{
						StateCode: "ALM",
						Name: "Almaty oblysy",
						Subdivision: null,
					},
					{
						StateCode: "AKM",
						Name: "Aqmola oblysy",
						Subdivision: null,
					},
					{
						StateCode: "AKT",
						Name: "Aqtöbe oblysy",
						Subdivision: null,
					},
					{
						StateCode: "AST",
						Name: "Astana",
						Subdivision: null,
					},
					{
						StateCode: "ATY",
						Name: "Atyraū oblysy",
						Subdivision: null,
					},
					{
						StateCode: "ZAP",
						Name: "Batys Qazaqstan oblysy",
						Subdivision: null,
					},
					{
						StateCode: "MAN",
						Name: "Mangghystaū oblysy",
						Subdivision: null,
					},
					{
						StateCode: "YUZ",
						Name: "Ongtüstik Qazaqstan oblysy",
						Subdivision: null,
					},
					{
						StateCode: "PAV",
						Name: "Pavlodar oblysy",
						Subdivision: null,
					},
					{
						StateCode: "KAR",
						Name: "Qaraghandy oblysy",
						Subdivision: null,
					},
					{
						StateCode: "KUS",
						Name: "Qostanay oblysy",
						Subdivision: null,
					},
					{
						StateCode: "KZY",
						Name: "Qyzylorda oblysy",
						Subdivision: null,
					},
					{
						StateCode: "VOS",
						Name: "Shyghys Qazaqstan oblysy",
						Subdivision: null,
					},
					{
						StateCode: "SEV",
						Name: "Soltüstik Qazaqstan oblysy",
						Subdivision: null,
					},
					{
						StateCode: "ZHA",
						Name: "Zhambyl oblysy",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KE",
				ThreeDigit: "KEN",
				Name: "Kenya",
				Capital: "Nairobi",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "200",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "300",
						Name: "Coast",
						Subdivision: null,
					},
					{
						StateCode: "400",
						Name: "Eastern",
						Subdivision: null,
					},
					{
						StateCode: "110",
						Name: "Nairobi",
						Subdivision: null,
					},
					{
						StateCode: "500",
						Name: "North-Eastern",
						Subdivision: null,
					},
					{
						StateCode: "600",
						Name: "Nyanza",
						Subdivision: null,
					},
					{
						StateCode: "700",
						Name: "Rift Valley",
						Subdivision: null,
					},
					{
						StateCode: "800",
						Name: "Western",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KI",
				ThreeDigit: "KIR",
				Name: "Kiribati",
				Capital: "South Tarawa",
				Region: "Oceania",
				Subregion: "Micronesia",
				States: [
					{
						StateCode: "G",
						Name: "Gilbert Islands",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Line Islands",
						Subdivision: null,
					},
					{
						StateCode: "P",
						Name: "Phoenix Islands",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KW",
				ThreeDigit: "KWT",
				Name: "Kuwait",
				Capital: "Kuwait City",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "AH",
						Name: "Al Aḩmadi",
						Subdivision: null,
					},
					{
						StateCode: "FA",
						Name: "Al Farwānīyah",
						Subdivision: null,
					},
					{
						StateCode: "JA",
						Name: "Al Jahrā’",
						Subdivision: null,
					},
					{
						StateCode: "KU",
						Name: "Al Kuwayt",
						Subdivision: null,
					},
					{
						StateCode: "MU",
						Name: "Mubārak al Kabīr",
						Subdivision: null,
					},
					{
						StateCode: "HA",
						Name: "Ḩawallī",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KG",
				ThreeDigit: "KGZ",
				Name: "Kyrgyzstan",
				Capital: "Bishkek",
				Region: "Asia",
				Subregion: "Central Asia",
				States: [
					{
						StateCode: "B",
						Name: "Batken",
						Subdivision: null,
					},
					{
						StateCode: "GB",
						Name: "Bishkek",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Chü",
						Subdivision: null,
					},
					{
						StateCode: "J",
						Name: "Jalal-Abad",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Naryn",
						Subdivision: null,
					},
					{
						StateCode: "O",
						Name: "Osh",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Talas",
						Subdivision: null,
					},
					{
						StateCode: "Y",
						Name: "Ysyk-Köl",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LA",
				ThreeDigit: "LAO",
				Name: "Laos",
				Capital: "Vientiane",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "AT",
						Name: "Attapu",
						Subdivision: null,
					},
					{
						StateCode: "BK",
						Name: "Bokèo",
						Subdivision: null,
					},
					{
						StateCode: "BL",
						Name: "Bolikhamxai",
						Subdivision: null,
					},
					{
						StateCode: "CH",
						Name: "Champasak",
						Subdivision: null,
					},
					{
						StateCode: "HO",
						Name: "Houaphan",
						Subdivision: null,
					},
					{
						StateCode: "KH",
						Name: "Khammouan",
						Subdivision: null,
					},
					{
						StateCode: "LM",
						Name: "Louang Namtha",
						Subdivision: null,
					},
					{
						StateCode: "LP",
						Name: "Louangphabang",
						Subdivision: null,
					},
					{
						StateCode: "OU",
						Name: "Oudômxai",
						Subdivision: null,
					},
					{
						StateCode: "PH",
						Name: "Phôngsali",
						Subdivision: null,
					},
					{
						StateCode: "SL",
						Name: "Salavan",
						Subdivision: null,
					},
					{
						StateCode: "SV",
						Name: "Savannakhét",
						Subdivision: null,
					},
					{
						StateCode: "VT",
						Name: "Vientiane",
						Subdivision: null,
					},
					{
						StateCode: "VI",
						Name: "Vientiane",
						Subdivision: null,
					},
					{
						StateCode: "XA",
						Name: "Xaignabouli",
						Subdivision: null,
					},
					{
						StateCode: "XN",
						Name: "Xaisômboun",
						Subdivision: null,
					},
					{
						StateCode: "XI",
						Name: "Xiangkhoang",
						Subdivision: null,
					},
					{
						StateCode: "XE",
						Name: "Xékong",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LV",
				ThreeDigit: "LVA",
				Name: "Latvia",
				Capital: "Riga",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "001",
						Name: "Aglonas novads",
						Subdivision: null,
					},
					{
						StateCode: "002",
						Name: "Aizkraukles novads",
						Subdivision: null,
					},
					{
						StateCode: "003",
						Name: "Aizputes novads",
						Subdivision: null,
					},
					{
						StateCode: "004",
						Name: "Aknīstes novads",
						Subdivision: null,
					},
					{
						StateCode: "005",
						Name: "Alojas novads",
						Subdivision: null,
					},
					{
						StateCode: "006",
						Name: "Alsungas novads",
						Subdivision: null,
					},
					{
						StateCode: "007",
						Name: "Alūksnes novads",
						Subdivision: null,
					},
					{
						StateCode: "008",
						Name: "Amatas novads",
						Subdivision: null,
					},
					{
						StateCode: "009",
						Name: "Apes novads",
						Subdivision: null,
					},
					{
						StateCode: "010",
						Name: "Auces novads",
						Subdivision: null,
					},
					{
						StateCode: "012",
						Name: "Babītes novads",
						Subdivision: null,
					},
					{
						StateCode: "013",
						Name: "Baldones novads",
						Subdivision: null,
					},
					{
						StateCode: "014",
						Name: "Baltinavas novads",
						Subdivision: null,
					},
					{
						StateCode: "015",
						Name: "Balvu novads",
						Subdivision: null,
					},
					{
						StateCode: "016",
						Name: "Bauskas novads",
						Subdivision: null,
					},
					{
						StateCode: "017",
						Name: "Beverīnas novads",
						Subdivision: null,
					},
					{
						StateCode: "018",
						Name: "Brocēnu novads",
						Subdivision: null,
					},
					{
						StateCode: "019",
						Name: "Burtnieku novads",
						Subdivision: null,
					},
					{
						StateCode: "020",
						Name: "Carnikavas novads",
						Subdivision: null,
					},
					{
						StateCode: "021",
						Name: "Cesvaines novads",
						Subdivision: null,
					},
					{
						StateCode: "023",
						Name: "Ciblas novads",
						Subdivision: null,
					},
					{
						StateCode: "022",
						Name: "Cēsu novads",
						Subdivision: null,
					},
					{
						StateCode: "024",
						Name: "Dagdas novads",
						Subdivision: null,
					},
					{
						StateCode: "DGV",
						Name: "Daugavpils",
						Subdivision: null,
					},
					{
						StateCode: "025",
						Name: "Daugavpils novads",
						Subdivision: null,
					},
					{
						StateCode: "026",
						Name: "Dobeles novads",
						Subdivision: null,
					},
					{
						StateCode: "027",
						Name: "Dundagas novads",
						Subdivision: null,
					},
					{
						StateCode: "028",
						Name: "Durbes novads",
						Subdivision: null,
					},
					{
						StateCode: "029",
						Name: "Engures novads",
						Subdivision: null,
					},
					{
						StateCode: "031",
						Name: "Garkalnes novads",
						Subdivision: null,
					},
					{
						StateCode: "032",
						Name: "Grobiņas novads",
						Subdivision: null,
					},
					{
						StateCode: "033",
						Name: "Gulbenes novads",
						Subdivision: null,
					},
					{
						StateCode: "034",
						Name: "Iecavas novads",
						Subdivision: null,
					},
					{
						StateCode: "035",
						Name: "Ikšķiles novads",
						Subdivision: null,
					},
					{
						StateCode: "036",
						Name: "Ilūkstes novads",
						Subdivision: null,
					},
					{
						StateCode: "037",
						Name: "Inčukalna novads",
						Subdivision: null,
					},
					{
						StateCode: "038",
						Name: "Jaunjelgavas novads",
						Subdivision: null,
					},
					{
						StateCode: "039",
						Name: "Jaunpiebalgas novads",
						Subdivision: null,
					},
					{
						StateCode: "040",
						Name: "Jaunpils novads",
						Subdivision: null,
					},
					{
						StateCode: "JEL",
						Name: "Jelgava",
						Subdivision: null,
					},
					{
						StateCode: "041",
						Name: "Jelgavas novads",
						Subdivision: null,
					},
					{
						StateCode: "JKB",
						Name: "Jēkabpils",
						Subdivision: null,
					},
					{
						StateCode: "042",
						Name: "Jēkabpils novads",
						Subdivision: null,
					},
					{
						StateCode: "JUR",
						Name: "Jūrmala",
						Subdivision: null,
					},
					{
						StateCode: "043",
						Name: "Kandavas novads",
						Subdivision: null,
					},
					{
						StateCode: "045",
						Name: "Kocēnu novads",
						Subdivision: null,
					},
					{
						StateCode: "046",
						Name: "Kokneses novads",
						Subdivision: null,
					},
					{
						StateCode: "048",
						Name: "Krimuldas novads",
						Subdivision: null,
					},
					{
						StateCode: "049",
						Name: "Krustpils novads",
						Subdivision: null,
					},
					{
						StateCode: "047",
						Name: "Krāslavas novads",
						Subdivision: null,
					},
					{
						StateCode: "050",
						Name: "Kuldīgas novads",
						Subdivision: null,
					},
					{
						StateCode: "044",
						Name: "Kārsavas novads",
						Subdivision: null,
					},
					{
						StateCode: "053",
						Name: "Lielvārdes novads",
						Subdivision: null,
					},
					{
						StateCode: "LPX",
						Name: "Liepāja",
						Subdivision: null,
					},
					{
						StateCode: "054",
						Name: "Limbažu novads",
						Subdivision: null,
					},
					{
						StateCode: "057",
						Name: "Lubānas novads",
						Subdivision: null,
					},
					{
						StateCode: "058",
						Name: "Ludzas novads",
						Subdivision: null,
					},
					{
						StateCode: "055",
						Name: "Līgatnes novads",
						Subdivision: null,
					},
					{
						StateCode: "056",
						Name: "Līvānu novads",
						Subdivision: null,
					},
					{
						StateCode: "059",
						Name: "Madonas novads",
						Subdivision: null,
					},
					{
						StateCode: "060",
						Name: "Mazsalacas novads",
						Subdivision: null,
					},
					{
						StateCode: "061",
						Name: "Mālpils novads",
						Subdivision: null,
					},
					{
						StateCode: "062",
						Name: "Mārupes novads",
						Subdivision: null,
					},
					{
						StateCode: "063",
						Name: "Mērsraga novads",
						Subdivision: null,
					},
					{
						StateCode: "064",
						Name: "Naukšēnu novads",
						Subdivision: null,
					},
					{
						StateCode: "065",
						Name: "Neretas novads",
						Subdivision: null,
					},
					{
						StateCode: "066",
						Name: "Nīcas novads",
						Subdivision: null,
					},
					{
						StateCode: "067",
						Name: "Ogres novads",
						Subdivision: null,
					},
					{
						StateCode: "068",
						Name: "Olaines novads",
						Subdivision: null,
					},
					{
						StateCode: "069",
						Name: "Ozolnieku novads",
						Subdivision: null,
					},
					{
						StateCode: "073",
						Name: "Preiļu novads",
						Subdivision: null,
					},
					{
						StateCode: "074",
						Name: "Priekules novads",
						Subdivision: null,
					},
					{
						StateCode: "075",
						Name: "Priekuļu novads",
						Subdivision: null,
					},
					{
						StateCode: "070",
						Name: "Pārgaujas novads",
						Subdivision: null,
					},
					{
						StateCode: "071",
						Name: "Pāvilostas novads",
						Subdivision: null,
					},
					{
						StateCode: "072",
						Name: "Pļaviņu novads",
						Subdivision: null,
					},
					{
						StateCode: "076",
						Name: "Raunas novads",
						Subdivision: null,
					},
					{
						StateCode: "078",
						Name: "Riebiņu novads",
						Subdivision: null,
					},
					{
						StateCode: "079",
						Name: "Rojas novads",
						Subdivision: null,
					},
					{
						StateCode: "080",
						Name: "Ropažu novads",
						Subdivision: null,
					},
					{
						StateCode: "081",
						Name: "Rucavas novads",
						Subdivision: null,
					},
					{
						StateCode: "082",
						Name: "Rugāju novads",
						Subdivision: null,
					},
					{
						StateCode: "083",
						Name: "Rundāles novads",
						Subdivision: null,
					},
					{
						StateCode: "REZ",
						Name: "Rēzekne",
						Subdivision: null,
					},
					{
						StateCode: "077",
						Name: "Rēzeknes novads",
						Subdivision: null,
					},
					{
						StateCode: "RIX",
						Name: "Rīga",
						Subdivision: null,
					},
					{
						StateCode: "084",
						Name: "Rūjienas novads",
						Subdivision: null,
					},
					{
						StateCode: "086",
						Name: "Salacgrīvas novads",
						Subdivision: null,
					},
					{
						StateCode: "085",
						Name: "Salas novads",
						Subdivision: null,
					},
					{
						StateCode: "087",
						Name: "Salaspils novads",
						Subdivision: null,
					},
					{
						StateCode: "088",
						Name: "Saldus novads",
						Subdivision: null,
					},
					{
						StateCode: "089",
						Name: "Saulkrastu novads",
						Subdivision: null,
					},
					{
						StateCode: "091",
						Name: "Siguldas novads",
						Subdivision: null,
					},
					{
						StateCode: "093",
						Name: "Skrundas novads",
						Subdivision: null,
					},
					{
						StateCode: "092",
						Name: "Skrīveru novads",
						Subdivision: null,
					},
					{
						StateCode: "094",
						Name: "Smiltenes novads",
						Subdivision: null,
					},
					{
						StateCode: "095",
						Name: "Stopiņu novads",
						Subdivision: null,
					},
					{
						StateCode: "096",
						Name: "Strenču novads",
						Subdivision: null,
					},
					{
						StateCode: "090",
						Name: "Sējas novads",
						Subdivision: null,
					},
					{
						StateCode: "097",
						Name: "Talsu novads",
						Subdivision: null,
					},
					{
						StateCode: "099",
						Name: "Tukuma novads",
						Subdivision: null,
					},
					{
						StateCode: "098",
						Name: "Tērvetes novads",
						Subdivision: null,
					},
					{
						StateCode: "100",
						Name: "Vaiņodes novads",
						Subdivision: null,
					},
					{
						StateCode: "101",
						Name: "Valkas novads",
						Subdivision: null,
					},
					{
						StateCode: "VMR",
						Name: "Valmiera",
						Subdivision: null,
					},
					{
						StateCode: "102",
						Name: "Varakļānu novads",
						Subdivision: null,
					},
					{
						StateCode: "104",
						Name: "Vecpiebalgas novads",
						Subdivision: null,
					},
					{
						StateCode: "105",
						Name: "Vecumnieku novads",
						Subdivision: null,
					},
					{
						StateCode: "VEN",
						Name: "Ventspils",
						Subdivision: null,
					},
					{
						StateCode: "106",
						Name: "Ventspils novads",
						Subdivision: null,
					},
					{
						StateCode: "107",
						Name: "Viesītes novads",
						Subdivision: null,
					},
					{
						StateCode: "108",
						Name: "Viļakas novads",
						Subdivision: null,
					},
					{
						StateCode: "109",
						Name: "Viļānu novads",
						Subdivision: null,
					},
					{
						StateCode: "103",
						Name: "Vārkavas novads",
						Subdivision: null,
					},
					{
						StateCode: "110",
						Name: "Zilupes novads",
						Subdivision: null,
					},
					{
						StateCode: "011",
						Name: "Ādažu novads",
						Subdivision: null,
					},
					{
						StateCode: "030",
						Name: "Ērgļu novads",
						Subdivision: null,
					},
					{
						StateCode: "051",
						Name: "Ķeguma novads",
						Subdivision: null,
					},
					{
						StateCode: "052",
						Name: "Ķekavas novads",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LB",
				ThreeDigit: "LBN",
				Name: "Lebanon",
				Capital: "Beirut",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "AK",
						Name: "Aakkâr",
						Subdivision: null,
					},
					{
						StateCode: "BH",
						Name: "Baalbek-Hermel",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Beyrouth",
						Subdivision: null,
					},
					{
						StateCode: "BI",
						Name: "Béqaa",
						Subdivision: null,
					},
					{
						StateCode: "AS",
						Name: "Liban-Nord",
						Subdivision: null,
					},
					{
						StateCode: "JA",
						Name: "Liban-Sud",
						Subdivision: null,
					},
					{
						StateCode: "JL",
						Name: "Mont-Liban",
						Subdivision: null,
					},
					{
						StateCode: "NA",
						Name: "Nabatîyé",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LS",
				ThreeDigit: "LSO",
				Name: "Lesotho",
				Capital: "Maseru",
				Region: "Africa",
				Subregion: "Southern Africa",
				States: [
					{
						StateCode: "D",
						Name: "Berea",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "Butha-Buthe",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Leribe",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Mafeteng",
						Subdivision: null,
					},
					{
						StateCode: "A",
						Name: "Maseru",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Mohale's Hoek",
						Subdivision: null,
					},
					{
						StateCode: "J",
						Name: "Mokhotlong",
						Subdivision: null,
					},
					{
						StateCode: "H",
						Name: "Qacha's Nek",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Quthing",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Thaba-Tseka",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LR",
				ThreeDigit: "LBR",
				Name: "Liberia",
				Capital: "Monrovia",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "BM",
						Name: "Bomi",
						Subdivision: null,
					},
					{
						StateCode: "BG",
						Name: "Bong",
						Subdivision: null,
					},
					{
						StateCode: "GP",
						Name: "Gbarpolu",
						Subdivision: null,
					},
					{
						StateCode: "GB",
						Name: "Grand Bassa",
						Subdivision: null,
					},
					{
						StateCode: "CM",
						Name: "Grand Cape Mount",
						Subdivision: null,
					},
					{
						StateCode: "GG",
						Name: "Grand Gedeh",
						Subdivision: null,
					},
					{
						StateCode: "GK",
						Name: "Grand Kru",
						Subdivision: null,
					},
					{
						StateCode: "LO",
						Name: "Lofa",
						Subdivision: null,
					},
					{
						StateCode: "MG",
						Name: "Margibi",
						Subdivision: null,
					},
					{
						StateCode: "MY",
						Name: "Maryland",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Montserrado",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Nimba",
						Subdivision: null,
					},
					{
						StateCode: "RG",
						Name: "River Gee",
						Subdivision: null,
					},
					{
						StateCode: "RI",
						Name: "Rivercess",
						Subdivision: null,
					},
					{
						StateCode: "SI",
						Name: "Sinoe",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LY",
				ThreeDigit: "LBY",
				Name: "Libya",
				Capital: "Tripoli",
				Region: "Africa",
				Subregion: "Northern Africa",
				States: [
					{
						StateCode: "BU",
						Name: "Al Buţnān",
						Subdivision: null,
					},
					{
						StateCode: "JA",
						Name: "Al Jabal al Akhḑar",
						Subdivision: null,
					},
					{
						StateCode: "JG",
						Name: "Al Jabal al Gharbī",
						Subdivision: null,
					},
					{
						StateCode: "JI",
						Name: "Al Jifārah",
						Subdivision: null,
					},
					{
						StateCode: "JU",
						Name: "Al Jufrah",
						Subdivision: null,
					},
					{
						StateCode: "KF",
						Name: "Al Kufrah",
						Subdivision: null,
					},
					{
						StateCode: "MJ",
						Name: "Al Marj",
						Subdivision: null,
					},
					{
						StateCode: "MB",
						Name: "Al Marqab",
						Subdivision: null,
					},
					{
						StateCode: "WA",
						Name: "Al Wāḩāt",
						Subdivision: null,
					},
					{
						StateCode: "NQ",
						Name: "An Nuqaţ al Khams",
						Subdivision: null,
					},
					{
						StateCode: "ZA",
						Name: "Az Zāwiyah",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Banghāzī",
						Subdivision: null,
					},
					{
						StateCode: "DR",
						Name: "Darnah",
						Subdivision: null,
					},
					{
						StateCode: "GT",
						Name: "Ghāt",
						Subdivision: null,
					},
					{
						StateCode: "MI",
						Name: "Mişrātah",
						Subdivision: null,
					},
					{
						StateCode: "MQ",
						Name: "Murzuq",
						Subdivision: null,
					},
					{
						StateCode: "NL",
						Name: "Nālūt",
						Subdivision: null,
					},
					{
						StateCode: "SB",
						Name: "Sabhā",
						Subdivision: null,
					},
					{
						StateCode: "SR",
						Name: "Surt",
						Subdivision: null,
					},
					{
						StateCode: "WD",
						Name: "Wādī al Ḩayāt",
						Subdivision: null,
					},
					{
						StateCode: "WS",
						Name: "Wādī ash Shāţiʾ",
						Subdivision: null,
					},
					{
						StateCode: "TB",
						Name: "Ţarābulus",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LI",
				ThreeDigit: "LIE",
				Name: "Liechtenstein",
				Capital: "Vaduz",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "01",
						Name: "Balzers",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Eschen",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Gamprin",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Mauren",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Planken",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Ruggell",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Schaan",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Schellenberg",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Triesen",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Triesenberg",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Vaduz",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LT",
				ThreeDigit: "LTU",
				Name: "Lithuania",
				Capital: "Vilnius",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "AL",
						Name: "Alytaus Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "KU",
						Name: "Kauno Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "KL",
						Name: "Klaipėdos Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "MR",
						Name: "Marijampolės Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "PN",
						Name: "Panevėžio Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tauragės Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "TE",
						Name: "Telšių Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "UT",
						Name: "Utenos Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "VL",
						Name: "Vilniaus Apskritis",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Šiaulių Apskritis",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LU",
				ThreeDigit: "LUX",
				Name: "Luxembourg",
				Capital: "Luxembourg",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "D",
						Name: "Diekirch",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Grevenmacher",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Luxembourg",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MO",
				ThreeDigit: "MAC",
				Name: "Macau",
				Capital: "",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [],
			},
			{
				TwoDigit: "MK",
				ThreeDigit: "MKD",
				Name: "Republic of Macedonia",
				Capital: "Skopje",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Aerodrom",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Aračinovo",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Berovo",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Bitola",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Bogdanci",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Bogovinje",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Bosilovo",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Brvenica",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Butel",
						Subdivision: null,
					},
					{
						StateCode: "77",
						Name: "Centar",
						Subdivision: null,
					},
					{
						StateCode: "78",
						Name: "Centar Župa",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Debar",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Debarca",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Delčevo",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Demir Hisar",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Demir Kapija",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Dojran",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Dolneni",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Drugovo",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Gazi Baba",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Gevgelija",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Gjorče Petrov",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Gostivar",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Gradsko",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Ilinden",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Jegunovce",
						Subdivision: null,
					},
					{
						StateCode: "37",
						Name: "Karbinci",
						Subdivision: null,
					},
					{
						StateCode: "38",
						Name: "Karpoš",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Kavadarci",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Kisela Voda",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Kičevo",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Konče",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Kočani",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Kratovo",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Kriva Palanka",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Krivogaštani",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Kruševo",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Kumanovo",
						Subdivision: null,
					},
					{
						StateCode: "48",
						Name: "Lipkovo",
						Subdivision: null,
					},
					{
						StateCode: "49",
						Name: "Lozovo",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "Makedonska Kamenica",
						Subdivision: null,
					},
					{
						StateCode: "52",
						Name: "Makedonski Brod",
						Subdivision: null,
					},
					{
						StateCode: "50",
						Name: "Mavrovo i Rostuša",
						Subdivision: null,
					},
					{
						StateCode: "53",
						Name: "Mogila",
						Subdivision: null,
					},
					{
						StateCode: "54",
						Name: "Negotino",
						Subdivision: null,
					},
					{
						StateCode: "55",
						Name: "Novaci",
						Subdivision: null,
					},
					{
						StateCode: "56",
						Name: "Novo Selo",
						Subdivision: null,
					},
					{
						StateCode: "58",
						Name: "Ohrid",
						Subdivision: null,
					},
					{
						StateCode: "57",
						Name: "Oslomej",
						Subdivision: null,
					},
					{
						StateCode: "60",
						Name: "Pehčevo",
						Subdivision: null,
					},
					{
						StateCode: "59",
						Name: "Petrovec",
						Subdivision: null,
					},
					{
						StateCode: "61",
						Name: "Plasnica",
						Subdivision: null,
					},
					{
						StateCode: "62",
						Name: "Prilep",
						Subdivision: null,
					},
					{
						StateCode: "63",
						Name: "Probištip",
						Subdivision: null,
					},
					{
						StateCode: "64",
						Name: "Radoviš",
						Subdivision: null,
					},
					{
						StateCode: "65",
						Name: "Rankovce",
						Subdivision: null,
					},
					{
						StateCode: "66",
						Name: "Resen",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Rosoman",
						Subdivision: null,
					},
					{
						StateCode: "68",
						Name: "Saraj",
						Subdivision: null,
					},
					{
						StateCode: "70",
						Name: "Sopište",
						Subdivision: null,
					},
					{
						StateCode: "71",
						Name: "Staro Nagoričane",
						Subdivision: null,
					},
					{
						StateCode: "72",
						Name: "Struga",
						Subdivision: null,
					},
					{
						StateCode: "73",
						Name: "Strumica",
						Subdivision: null,
					},
					{
						StateCode: "74",
						Name: "Studeničani",
						Subdivision: null,
					},
					{
						StateCode: "69",
						Name: "Sveti Nikole",
						Subdivision: null,
					},
					{
						StateCode: "75",
						Name: "Tearce",
						Subdivision: null,
					},
					{
						StateCode: "76",
						Name: "Tetovo",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Valandovo",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Vasilevo",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Veles",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Vevčani",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Vinica",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Vraneštica",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Vrapčište",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Zajas",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Zelenikovo",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Zrnovci",
						Subdivision: null,
					},
					{
						StateCode: "79",
						Name: "Čair",
						Subdivision: null,
					},
					{
						StateCode: "80",
						Name: "Čaška",
						Subdivision: null,
					},
					{
						StateCode: "81",
						Name: "Češinovo-Obleševo",
						Subdivision: null,
					},
					{
						StateCode: "82",
						Name: "Čučer Sandevo",
						Subdivision: null,
					},
					{
						StateCode: "83",
						Name: "Štip",
						Subdivision: null,
					},
					{
						StateCode: "84",
						Name: "Šuto Orizari",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Želino",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MG",
				ThreeDigit: "MDG",
				Name: "Madagascar",
				Capital: "Antananarivo",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "T",
						Name: "Antananarivo",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Antsiranana",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Fianarantsoa",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Mahajanga",
						Subdivision: null,
					},
					{
						StateCode: "A",
						Name: "Toamasina",
						Subdivision: null,
					},
					{
						StateCode: "U",
						Name: "Toliara",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MW",
				ThreeDigit: "MWI",
				Name: "Malawi",
				Capital: "Lilongwe",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "C",
						Name: "Central Region",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Northern Region",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Southern Region",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MY",
				ThreeDigit: "MYS",
				Name: "Malaysia",
				Capital: "Kuala Lumpur",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "14",
						Name: "Wilayah Persekutuan Kuala Lumpur",
						Subdivision: "federal territory",
					},
					{
						StateCode: "15",
						Name: "Wilayah Persekutuan Labuan",
						Subdivision: "federal territory",
					},
					{
						StateCode: "16",
						Name: "Wilayah Persekutuan Putrajaya",
						Subdivision: "federal territory",
					},
					{
						StateCode: "01",
						Name: "Johor",
						Subdivision: "state",
					},
					{
						StateCode: "02",
						Name: "Kedah",
						Subdivision: "state",
					},
					{
						StateCode: "03",
						Name: "Kelantan",
						Subdivision: "state",
					},
					{
						StateCode: "04",
						Name: "Melaka",
						Subdivision: "state",
					},
					{
						StateCode: "05",
						Name: "Negeri Sembilan",
						Subdivision: "state",
					},
					{
						StateCode: "06",
						Name: "Pahang",
						Subdivision: "state",
					},
					{
						StateCode: "08",
						Name: "Perak",
						Subdivision: "state",
					},
					{
						StateCode: "09",
						Name: "Perlis",
						Subdivision: "state",
					},
					{
						StateCode: "07",
						Name: "Pulau Pinang",
						Subdivision: "state",
					},
					{
						StateCode: "12",
						Name: "Sabah",
						Subdivision: "state",
					},
					{
						StateCode: "13",
						Name: "Sarawak",
						Subdivision: "state",
					},
					{
						StateCode: "10",
						Name: "Selangor",
						Subdivision: "state",
					},
					{
						StateCode: "11",
						Name: "Terengganu",
						Subdivision: "state",
					},
				],
			},
			{
				TwoDigit: "MV",
				ThreeDigit: "MDV",
				Name: "Maldives",
				Capital: "Malé",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "CE",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "MLE",
						Name: "Male",
						Subdivision: null,
					},
					{
						StateCode: "NO",
						Name: "North",
						Subdivision: null,
					},
					{
						StateCode: "NC",
						Name: "North Central",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "South",
						Subdivision: null,
					},
					{
						StateCode: "SC",
						Name: "South Central",
						Subdivision: null,
					},
					{
						StateCode: "UN",
						Name: "Upper North",
						Subdivision: null,
					},
					{
						StateCode: "US",
						Name: "Upper South",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ML",
				ThreeDigit: "MLI",
				Name: "Mali",
				Capital: "Bamako",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "BKO",
						Name: "Bamako",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "Gao",
						Subdivision: null,
					},
					{
						StateCode: "1",
						Name: "Kayes",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Kidal",
						Subdivision: null,
					},
					{
						StateCode: "2",
						Name: "Koulikoro",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Mopti",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Sikasso",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Ségou",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "Tombouctou",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MT",
				ThreeDigit: "MLT",
				Name: "Malta",
				Capital: "Valletta",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Attard",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Balzan",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Birgu",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Birkirkara",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Birżebbuġa",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Bormla",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Dingli",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Fgura",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Floriana",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Fontana",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Gudja",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Għajnsielem",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Għarb",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Għargħur",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Għasri",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Għaxaq",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Gżira",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Iklin",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Isla",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Kalkara",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Kerċem",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Kirkop",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Lija",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Luqa",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Marsa",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Marsaskala",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Marsaxlokk",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Mdina",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Mellieħa",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Mosta",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Mqabba",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Msida",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Mtarfa",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Munxar",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Mġarr",
						Subdivision: null,
					},
					{
						StateCode: "37",
						Name: "Nadur",
						Subdivision: null,
					},
					{
						StateCode: "38",
						Name: "Naxxar",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Paola",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Pembroke",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Pietà",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Qala",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Qormi",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Qrendi",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Rabat Għawdex",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Rabat Malta",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Safi",
						Subdivision: null,
					},
					{
						StateCode: "50",
						Name: "San Lawrenz",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "San Pawl il-Baħar",
						Subdivision: null,
					},
					{
						StateCode: "48",
						Name: "San Ġiljan",
						Subdivision: null,
					},
					{
						StateCode: "49",
						Name: "San Ġwann",
						Subdivision: null,
					},
					{
						StateCode: "52",
						Name: "Sannat",
						Subdivision: null,
					},
					{
						StateCode: "53",
						Name: "Santa Luċija",
						Subdivision: null,
					},
					{
						StateCode: "54",
						Name: "Santa Venera",
						Subdivision: null,
					},
					{
						StateCode: "55",
						Name: "Siġġiewi",
						Subdivision: null,
					},
					{
						StateCode: "56",
						Name: "Sliema",
						Subdivision: null,
					},
					{
						StateCode: "57",
						Name: "Swieqi",
						Subdivision: null,
					},
					{
						StateCode: "58",
						Name: "Ta' Xbiex",
						Subdivision: null,
					},
					{
						StateCode: "59",
						Name: "Tarxien",
						Subdivision: null,
					},
					{
						StateCode: "60",
						Name: "Valletta",
						Subdivision: null,
					},
					{
						StateCode: "61",
						Name: "Xagħra",
						Subdivision: null,
					},
					{
						StateCode: "62",
						Name: "Xewkija",
						Subdivision: null,
					},
					{
						StateCode: "63",
						Name: "Xgħajra",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Ħamrun",
						Subdivision: null,
					},
					{
						StateCode: "64",
						Name: "Żabbar",
						Subdivision: null,
					},
					{
						StateCode: "65",
						Name: "Żebbuġ Għawdex",
						Subdivision: null,
					},
					{
						StateCode: "66",
						Name: "Żebbuġ Malta",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Żejtun",
						Subdivision: null,
					},
					{
						StateCode: "68",
						Name: "Żurrieq",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MH",
				ThreeDigit: "MHL",
				Name: "Marshall Islands",
				Capital: "Majuro",
				Region: "Oceania",
				Subregion: "Micronesia",
				States: [
					{
						StateCode: "L",
						Name: "Ralik chain",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Ratak chain",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MQ",
				ThreeDigit: "MTQ",
				Name: "Martinique",
				Capital: "Fort-de-France",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "MR",
				ThreeDigit: "MRT",
				Name: "Mauritania",
				Capital: "Nouakchott",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "07",
						Name: "Adrar",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Assaba",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Brakna",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Dakhlet Nouâdhibou",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Gorgol",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Guidimaka",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Hodh ech Chargui",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Hodh el Gharbi",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Inchiri",
						Subdivision: null,
					},
					{
						StateCode: "NKC",
						Name: "Nouakchott",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Tagant",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Tiris Zemmour",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Trarza",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MU",
				ThreeDigit: "MUS",
				Name: "Mauritius",
				Capital: "Port Louis",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "AG",
						Name: "Agalega Islands",
						Subdivision: null,
					},
					{
						StateCode: "BR",
						Name: "Beau Bassin-Rose Hill",
						Subdivision: null,
					},
					{
						StateCode: "BL",
						Name: "Black River",
						Subdivision: null,
					},
					{
						StateCode: "CC",
						Name: "Cargados Carajos Shoals",
						Subdivision: null,
					},
					{
						StateCode: "CU",
						Name: "Curepipe",
						Subdivision: null,
					},
					{
						StateCode: "FL",
						Name: "Flacq",
						Subdivision: null,
					},
					{
						StateCode: "GP",
						Name: "Grand Port",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Moka",
						Subdivision: null,
					},
					{
						StateCode: "PA",
						Name: "Pamplemousses",
						Subdivision: null,
					},
					{
						StateCode: "PW",
						Name: "Plaines Wilhems",
						Subdivision: null,
					},
					{
						StateCode: "PL",
						Name: "Port Louis",
						Subdivision: null,
					},
					{
						StateCode: "PU",
						Name: "Port Louis",
						Subdivision: null,
					},
					{
						StateCode: "QB",
						Name: "Quatre Bornes",
						Subdivision: null,
					},
					{
						StateCode: "RR",
						Name: "Rivière du Rempart",
						Subdivision: null,
					},
					{
						StateCode: "RO",
						Name: "Rodrigues Island",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Savanne",
						Subdivision: null,
					},
					{
						StateCode: "VP",
						Name: "Vacoas-Phoenix",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "YT",
				ThreeDigit: "MYT",
				Name: "Mayotte",
				Capital: "Mamoudzou",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [],
			},
			{
				TwoDigit: "MX",
				ThreeDigit: "MEX",
				Name: "Mexico",
				Capital: "Mexico City",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "DIF",
						Name: "Distrito Federal",
						Subdivision: "federal district",
					},
					{
						StateCode: "AGU",
						Name: "Aguascalientes",
						Subdivision: "state",
					},
					{
						StateCode: "BCN",
						Name: "Baja California",
						Subdivision: "state",
					},
					{
						StateCode: "BCS",
						Name: "Baja California Sur",
						Subdivision: "state",
					},
					{
						StateCode: "CAM",
						Name: "Campeche",
						Subdivision: "state",
					},
					{
						StateCode: "CHP",
						Name: "Chiapas",
						Subdivision: "state",
					},
					{
						StateCode: "CHH",
						Name: "Chihuahua",
						Subdivision: "state",
					},
					{
						StateCode: "COA",
						Name: "Coahuila",
						Subdivision: "state",
					},
					{
						StateCode: "COL",
						Name: "Colima",
						Subdivision: "state",
					},
					{
						StateCode: "DUR",
						Name: "Durango",
						Subdivision: "state",
					},
					{
						StateCode: "GUA",
						Name: "Guanajuato",
						Subdivision: "state",
					},
					{
						StateCode: "GRO",
						Name: "Guerrero",
						Subdivision: "state",
					},
					{
						StateCode: "HID",
						Name: "Hidalgo",
						Subdivision: "state",
					},
					{
						StateCode: "JAL",
						Name: "Jalisco",
						Subdivision: "state",
					},
					{
						StateCode: "MIC",
						Name: "Michoacán",
						Subdivision: "state",
					},
					{
						StateCode: "MOR",
						Name: "Morelos",
						Subdivision: "state",
					},
					{
						StateCode: "MEX",
						Name: "México",
						Subdivision: "state",
					},
					{
						StateCode: "NAY",
						Name: "Nayarit",
						Subdivision: "state",
					},
					{
						StateCode: "NLE",
						Name: "Nuevo León",
						Subdivision: "state",
					},
					{
						StateCode: "OAX",
						Name: "Oaxaca",
						Subdivision: "state",
					},
					{
						StateCode: "PUE",
						Name: "Puebla",
						Subdivision: "state",
					},
					{
						StateCode: "QUE",
						Name: "Querétaro",
						Subdivision: "state",
					},
					{
						StateCode: "ROO",
						Name: "Quintana Roo",
						Subdivision: "state",
					},
					{
						StateCode: "SLP",
						Name: "San Luis Potosí",
						Subdivision: "state",
					},
					{
						StateCode: "SIN",
						Name: "Sinaloa",
						Subdivision: "state",
					},
					{
						StateCode: "SON",
						Name: "Sonora",
						Subdivision: "state",
					},
					{
						StateCode: "TAB",
						Name: "Tabasco",
						Subdivision: "state",
					},
					{
						StateCode: "TAM",
						Name: "Tamaulipas",
						Subdivision: "state",
					},
					{
						StateCode: "TLA",
						Name: "Tlaxcala",
						Subdivision: "state",
					},
					{
						StateCode: "VER",
						Name: "Veracruz",
						Subdivision: "state",
					},
					{
						StateCode: "YUC",
						Name: "Yucatán",
						Subdivision: "state",
					},
					{
						StateCode: "ZAC",
						Name: "Zacatecas",
						Subdivision: "state",
					},
				],
			},
			{
				TwoDigit: "FM",
				ThreeDigit: "FSM",
				Name: "Federated States of Micronesia",
				Capital: "Palikir",
				Region: "Oceania",
				Subregion: "Micronesia",
				States: [
					{
						StateCode: "TRK",
						Name: "Chuuk",
						Subdivision: null,
					},
					{
						StateCode: "KSA",
						Name: "Kosrae",
						Subdivision: null,
					},
					{
						StateCode: "PNI",
						Name: "Pohnpei",
						Subdivision: null,
					},
					{
						StateCode: "YAP",
						Name: "Yap",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MD",
				ThreeDigit: "MDA",
				Name: "Moldova",
				Capital: "Chișinău",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "AN",
						Name: "Anenii Noi",
						Subdivision: null,
					},
					{
						StateCode: "BS",
						Name: "Basarabeasca",
						Subdivision: null,
					},
					{
						StateCode: "BR",
						Name: "Briceni",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Bălţi",
						Subdivision: null,
					},
					{
						StateCode: "CA",
						Name: "Cahul",
						Subdivision: null,
					},
					{
						StateCode: "CT",
						Name: "Cantemir",
						Subdivision: null,
					},
					{
						StateCode: "CU",
						Name: "Chişinău",
						Subdivision: null,
					},
					{
						StateCode: "CM",
						Name: "Cimişlia",
						Subdivision: null,
					},
					{
						StateCode: "CR",
						Name: "Criuleni",
						Subdivision: null,
					},
					{
						StateCode: "CL",
						Name: "Călăraşi",
						Subdivision: null,
					},
					{
						StateCode: "CS",
						Name: "Căuşeni",
						Subdivision: null,
					},
					{
						StateCode: "DO",
						Name: "Donduşeni",
						Subdivision: null,
					},
					{
						StateCode: "DR",
						Name: "Drochia",
						Subdivision: null,
					},
					{
						StateCode: "DU",
						Name: "Dubăsari",
						Subdivision: null,
					},
					{
						StateCode: "ED",
						Name: "Edineţ",
						Subdivision: null,
					},
					{
						StateCode: "FL",
						Name: "Floreşti",
						Subdivision: null,
					},
					{
						StateCode: "FA",
						Name: "Făleşti",
						Subdivision: null,
					},
					{
						StateCode: "GL",
						Name: "Glodeni",
						Subdivision: null,
					},
					{
						StateCode: "GA",
						Name: "Găgăuzia, Unitatea teritorială autonomă",
						Subdivision: null,
					},
					{
						StateCode: "HI",
						Name: "Hînceşti",
						Subdivision: null,
					},
					{
						StateCode: "IA",
						Name: "Ialoveni",
						Subdivision: null,
					},
					{
						StateCode: "LE",
						Name: "Leova",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Nisporeni",
						Subdivision: null,
					},
					{
						StateCode: "OC",
						Name: "Ocniţa",
						Subdivision: null,
					},
					{
						StateCode: "OR",
						Name: "Orhei",
						Subdivision: null,
					},
					{
						StateCode: "RE",
						Name: "Rezina",
						Subdivision: null,
					},
					{
						StateCode: "RI",
						Name: "Rîşcani",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Soroca",
						Subdivision: null,
					},
					{
						StateCode: "ST",
						Name: "Străşeni",
						Subdivision: null,
					},
					{
						StateCode: "SN",
						Name: "Stînga Nistrului, unitatea teritorială din",
						Subdivision: null,
					},
					{
						StateCode: "SI",
						Name: "Sîngerei",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Taraclia",
						Subdivision: null,
					},
					{
						StateCode: "TE",
						Name: "Teleneşti",
						Subdivision: null,
					},
					{
						StateCode: "BD",
						Name: "Tighina",
						Subdivision: null,
					},
					{
						StateCode: "UN",
						Name: "Ungheni",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Şoldăneşti",
						Subdivision: null,
					},
					{
						StateCode: "SV",
						Name: "Ştefan Vodă",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MC",
				ThreeDigit: "MCO",
				Name: "Monaco",
				Capital: "Monaco",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "FO",
						Name: "Fontvieille",
						Subdivision: null,
					},
					{
						StateCode: "JE",
						Name: "Jardin Exotique",
						Subdivision: null,
					},
					{
						StateCode: "CL",
						Name: "La Colle",
						Subdivision: null,
					},
					{
						StateCode: "CO",
						Name: "La Condamine",
						Subdivision: null,
					},
					{
						StateCode: "GA",
						Name: "La Gare",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "La Source",
						Subdivision: null,
					},
					{
						StateCode: "LA",
						Name: "Larvotto",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Malbousquet",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Monaco-Ville",
						Subdivision: null,
					},
					{
						StateCode: "MG",
						Name: "Moneghetti",
						Subdivision: null,
					},
					{
						StateCode: "MC",
						Name: "Monte-Carlo",
						Subdivision: null,
					},
					{
						StateCode: "MU",
						Name: "Moulins",
						Subdivision: null,
					},
					{
						StateCode: "PH",
						Name: "Port-Hercule",
						Subdivision: null,
					},
					{
						StateCode: "SR",
						Name: "Saint-Roman",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Sainte-Dévote",
						Subdivision: null,
					},
					{
						StateCode: "SP",
						Name: "Spélugues",
						Subdivision: null,
					},
					{
						StateCode: "VR",
						Name: "Vallon de la Rousse",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MN",
				ThreeDigit: "MNG",
				Name: "Mongolia",
				Capital: "Ulan Bator",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [
					{
						StateCode: "073",
						Name: "Arhangay",
						Subdivision: null,
					},
					{
						StateCode: "071",
						Name: "Bayan-Ölgiy",
						Subdivision: null,
					},
					{
						StateCode: "069",
						Name: "Bayanhongor",
						Subdivision: null,
					},
					{
						StateCode: "067",
						Name: "Bulgan",
						Subdivision: null,
					},
					{
						StateCode: "037",
						Name: "Darhan uul",
						Subdivision: null,
					},
					{
						StateCode: "061",
						Name: "Dornod",
						Subdivision: null,
					},
					{
						StateCode: "063",
						Name: "Dornogovĭ",
						Subdivision: null,
					},
					{
						StateCode: "059",
						Name: "Dundgovĭ",
						Subdivision: null,
					},
					{
						StateCode: "057",
						Name: "Dzavhan",
						Subdivision: null,
					},
					{
						StateCode: "065",
						Name: "Govĭ-Altay",
						Subdivision: null,
					},
					{
						StateCode: "064",
						Name: "Govĭ-Sümber",
						Subdivision: null,
					},
					{
						StateCode: "039",
						Name: "Hentiy",
						Subdivision: null,
					},
					{
						StateCode: "043",
						Name: "Hovd",
						Subdivision: null,
					},
					{
						StateCode: "041",
						Name: "Hövsgöl",
						Subdivision: null,
					},
					{
						StateCode: "035",
						Name: "Orhon",
						Subdivision: null,
					},
					{
						StateCode: "049",
						Name: "Selenge",
						Subdivision: null,
					},
					{
						StateCode: "051",
						Name: "Sühbaatar",
						Subdivision: null,
					},
					{
						StateCode: "047",
						Name: "Töv",
						Subdivision: null,
					},
					{
						StateCode: "1",
						Name: "Ulaanbaatar",
						Subdivision: null,
					},
					{
						StateCode: "046",
						Name: "Uvs",
						Subdivision: null,
					},
					{
						StateCode: "053",
						Name: "Ömnögovĭ",
						Subdivision: null,
					},
					{
						StateCode: "055",
						Name: "Övörhangay",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ME",
				ThreeDigit: "MNE",
				Name: "Montenegro",
				Capital: "Podgorica",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Andrijevica",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Bar",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Berane",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Bijelo Polje",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Budva",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Cetinje",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Danilovgrad",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Gusinje",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Herceg-Novi",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Kolašin",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Kotor",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Mojkovac",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Nikšić",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Petnjica",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Plav",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Pljevlja",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Plužine",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Podgorica",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Rožaje",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Tivat",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Ulcinj",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Šavnik",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Žabljak",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MS",
				ThreeDigit: "MSR",
				Name: "Montserrat",
				Capital: "Plymouth",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "MA",
				ThreeDigit: "MAR",
				Name: "Morocco",
				Capital: "Rabat",
				Region: "Africa",
				Subregion: "Northern Africa",
				States: [
					{
						StateCode: "09",
						Name: "Chaouia-Ouardigha",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Doukhala-Abda",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Fès-Boulemane",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Gharb-Chrarda-Beni Hssen",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Grand Casablanca",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Guelmim-Es Smara",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "L'Oriental",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Laâyoune-Boujdour-Sakia el Hamra",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Marrakech-Tensift-Al Haouz",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Meknès-Tafilalet",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Oued ed Dahab-Lagouira",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Rabat-Salé-Zemmour-Zaer",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Souss-Massa-Drâa",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Tadla-Azilal",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Tanger-Tétouan",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Taza-Al Hoceima-Taounate",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MZ",
				ThreeDigit: "MOZ",
				Name: "Mozambique",
				Capital: "Maputo",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "P",
						Name: "Cabo Delgado",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Gaza",
						Subdivision: null,
					},
					{
						StateCode: "I",
						Name: "Inhambane",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "Manica",
						Subdivision: null,
					},
					{
						StateCode: "MPM",
						Name: "Maputo",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Maputo",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Nampula",
						Subdivision: null,
					},
					{
						StateCode: "A",
						Name: "Niassa",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Sofala",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Tete",
						Subdivision: null,
					},
					{
						StateCode: "Q",
						Name: "Zambézia",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MM",
				ThreeDigit: "MMR",
				Name: "Myanmar",
				Capital: "Naypyidaw",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "07",
						Name: "Ayeyarwady",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Bago",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Chin",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Kachin",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Kayah",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Kayin",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Magway",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Mandalay",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Mon",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Rakhine",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Sagaing",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Shan",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Tanintharyi",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Yangon",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "NA",
				ThreeDigit: "NAM",
				Name: "Namibia",
				Capital: "Windhoek",
				Region: "Africa",
				Subregion: "Southern Africa",
				States: [
					{
						StateCode: "ER",
						Name: "Erongo",
						Subdivision: null,
					},
					{
						StateCode: "HA",
						Name: "Hardap",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Karas",
						Subdivision: null,
					},
					{
						StateCode: "KE",
						Name: "Kavango East",
						Subdivision: null,
					},
					{
						StateCode: "KW",
						Name: "Kavango West",
						Subdivision: null,
					},
					{
						StateCode: "KH",
						Name: "Khomas",
						Subdivision: null,
					},
					{
						StateCode: "KU",
						Name: "Kunene",
						Subdivision: null,
					},
					{
						StateCode: "OW",
						Name: "Ohangwena",
						Subdivision: null,
					},
					{
						StateCode: "OH",
						Name: "Omaheke",
						Subdivision: null,
					},
					{
						StateCode: "OS",
						Name: "Omusati",
						Subdivision: null,
					},
					{
						StateCode: "ON",
						Name: "Oshana",
						Subdivision: null,
					},
					{
						StateCode: "OT",
						Name: "Oshikoto",
						Subdivision: null,
					},
					{
						StateCode: "OD",
						Name: "Otjozondjupa",
						Subdivision: null,
					},
					{
						StateCode: "CA",
						Name: "Zambezi",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "NR",
				ThreeDigit: "NRU",
				Name: "Nauru",
				Capital: "Yaren",
				Region: "Oceania",
				Subregion: "Micronesia",
				States: [
					{
						StateCode: "01",
						Name: "Aiwo",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Anabar",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Anetan",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Anibare",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Baiti",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Boe",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Buada",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Denigomodu",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Ewa",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Ijuw",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Meneng",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Nibok",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Uaboe",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Yaren",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "NP",
				ThreeDigit: "NPL",
				Name: "Nepal",
				Capital: "Kathmandu",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "2",
						Name: "Madhya Pashchimanchal",
						Subdivision: null,
					},
					{
						StateCode: "1",
						Name: "Madhyamanchal",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Pashchimanchal",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Purwanchal",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Sudur Pashchimanchal",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "NL",
				ThreeDigit: "NLD",
				Name: "Netherlands",
				Capital: "Amsterdam",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "DR",
						Name: "Drenthe",
						Subdivision: "Province",
					},
					{
						StateCode: "FL",
						Name: "Flevoland",
						Subdivision: "Province",
					},
					{
						StateCode: "FR",
						Name: "Fryslân",
						Subdivision: "Province",
					},
					{
						StateCode: "GE",
						Name: "Gelderland",
						Subdivision: "Province",
					},
					{
						StateCode: "GR",
						Name: "Groningen",
						Subdivision: "Province",
					},
					{
						StateCode: "LI",
						Name: "Limburg",
						Subdivision: "Province",
					},
					{
						StateCode: "NB",
						Name: "Noord-Brabant",
						Subdivision: "Province",
					},
					{
						StateCode: "NH",
						Name: "Noord-Holland",
						Subdivision: "Province",
					},
					{
						StateCode: "OV",
						Name: "Overijssel",
						Subdivision: "Province",
					},
					{
						StateCode: "UT",
						Name: "Utrecht",
						Subdivision: "Province",
					},
					{
						StateCode: "ZE",
						Name: "Zeeland",
						Subdivision: "Province",
					},
					{
						StateCode: "ZH",
						Name: "Zuid-Holland",
						Subdivision: "Province",
					},
					{
						StateCode: "AW",
						Name: "Aruba",
						Subdivision: "country",
					},
					{
						StateCode: "CW",
						Name: "Curaçao",
						Subdivision: "country",
					},
					{
						StateCode: "SX",
						Name: "Sint Maarten",
						Subdivision: "country",
					},
					{
						StateCode: "BQ1",
						Name: "Bonaire",
						Subdivision: "special municipality",
					},
					{
						StateCode: "BQ2",
						Name: "Saba",
						Subdivision: "special municipality",
					},
					{
						StateCode: "BQ3",
						Name: "Sint Eustatius",
						Subdivision: "special municipality",
					},
				],
			},
			{
				TwoDigit: "NC",
				ThreeDigit: "NCL",
				Name: "New Caledonia",
				Capital: "Nouméa",
				Region: "Oceania",
				Subregion: "Melanesia",
				States: [],
			},
			{
				TwoDigit: "NZ",
				ThreeDigit: "NZL",
				Name: "New Zealand",
				Capital: "Wellington",
				Region: "Oceania",
				Subregion: "Australia and New Zealand",
				States: [
					{
						StateCode: "N",
						Name: "North Island",
						Subdivision: "Island",
					},
					{
						StateCode: "S",
						Name: "South Island",
						Subdivision: "Island",
					},
					{
						StateCode: "AUK",
						Name: "Auckland",
						Subdivision: "regional council",
					},
					{
						StateCode: "BOP",
						Name: "Bay of Plenty",
						Subdivision: "regional council",
					},
					{
						StateCode: "CAN",
						Name: "Canterbury",
						Subdivision: "regional council",
					},
					{
						StateCode: "HKB",
						Name: "Hawke's Bay",
						Subdivision: "regional council",
					},
					{
						StateCode: "MWT",
						Name: "Manawatu-Wanganui",
						Subdivision: "regional council",
					},
					{
						StateCode: "NTL",
						Name: "Northland",
						Subdivision: "regional council",
					},
					{
						StateCode: "OTA",
						Name: "Otago",
						Subdivision: "regional council",
					},
					{
						StateCode: "STL",
						Name: "Southland",
						Subdivision: "regional council",
					},
					{
						StateCode: "TKI",
						Name: "Taranaki",
						Subdivision: "regional council",
					},
					{
						StateCode: "WKO",
						Name: "Waikato",
						Subdivision: "regional council",
					},
					{
						StateCode: "WGN",
						Name: "Wellington",
						Subdivision: "regional council",
					},
					{
						StateCode: "WTC",
						Name: "West Coast",
						Subdivision: "regional council",
					},
					{
						StateCode: "CIT",
						Name: "Chatham Islands Territory",
						Subdivision: "special island authority",
					},
					{
						StateCode: "GIS",
						Name: "Gisborne District",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "MBH",
						Name: "Marlborough District",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NSN",
						Name: "Nelson City",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "TAS",
						Name: "Tasman District",
						Subdivision: "unitary authority",
					},
				],
			},
			{
				TwoDigit: "NI",
				ThreeDigit: "NIC",
				Name: "Nicaragua",
				Capital: "Managua",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "AN",
						Name: "Atlántico Norte",
						Subdivision: null,
					},
					{
						StateCode: "AS",
						Name: "Atlántico Sur",
						Subdivision: null,
					},
					{
						StateCode: "BO",
						Name: "Boaco",
						Subdivision: null,
					},
					{
						StateCode: "CA",
						Name: "Carazo",
						Subdivision: null,
					},
					{
						StateCode: "CI",
						Name: "Chinandega",
						Subdivision: null,
					},
					{
						StateCode: "CO",
						Name: "Chontales",
						Subdivision: null,
					},
					{
						StateCode: "ES",
						Name: "Estelí",
						Subdivision: null,
					},
					{
						StateCode: "GR",
						Name: "Granada",
						Subdivision: null,
					},
					{
						StateCode: "JI",
						Name: "Jinotega",
						Subdivision: null,
					},
					{
						StateCode: "LE",
						Name: "León",
						Subdivision: null,
					},
					{
						StateCode: "MD",
						Name: "Madriz",
						Subdivision: null,
					},
					{
						StateCode: "MN",
						Name: "Managua",
						Subdivision: null,
					},
					{
						StateCode: "MS",
						Name: "Masaya",
						Subdivision: null,
					},
					{
						StateCode: "MT",
						Name: "Matagalpa",
						Subdivision: null,
					},
					{
						StateCode: "NS",
						Name: "Nueva Segovia",
						Subdivision: null,
					},
					{
						StateCode: "RI",
						Name: "Rivas",
						Subdivision: null,
					},
					{
						StateCode: "SJ",
						Name: "Río San Juan",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "NE",
				ThreeDigit: "NER",
				Name: "Niger",
				Capital: "Niamey",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "1",
						Name: "Agadez",
						Subdivision: null,
					},
					{
						StateCode: "2",
						Name: "Diffa",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Dosso",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Maradi",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Niamey",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Tahoua",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "Tillabéri",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "Zinder",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "NG",
				ThreeDigit: "NGA",
				Name: "Nigeria",
				Capital: "Abuja",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "AB",
						Name: "Abia",
						Subdivision: null,
					},
					{
						StateCode: "FC",
						Name: "Abuja Federal Capital Territory",
						Subdivision: null,
					},
					{
						StateCode: "AD",
						Name: "Adamawa",
						Subdivision: null,
					},
					{
						StateCode: "AK",
						Name: "Akwa Ibom",
						Subdivision: null,
					},
					{
						StateCode: "AN",
						Name: "Anambra",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Bauchi",
						Subdivision: null,
					},
					{
						StateCode: "BY",
						Name: "Bayelsa",
						Subdivision: null,
					},
					{
						StateCode: "BE",
						Name: "Benue",
						Subdivision: null,
					},
					{
						StateCode: "BO",
						Name: "Borno",
						Subdivision: null,
					},
					{
						StateCode: "CR",
						Name: "Cross River",
						Subdivision: null,
					},
					{
						StateCode: "DE",
						Name: "Delta",
						Subdivision: null,
					},
					{
						StateCode: "EB",
						Name: "Ebonyi",
						Subdivision: null,
					},
					{
						StateCode: "ED",
						Name: "Edo",
						Subdivision: null,
					},
					{
						StateCode: "EK",
						Name: "Ekiti",
						Subdivision: null,
					},
					{
						StateCode: "EN",
						Name: "Enugu",
						Subdivision: null,
					},
					{
						StateCode: "GO",
						Name: "Gombe",
						Subdivision: null,
					},
					{
						StateCode: "IM",
						Name: "Imo",
						Subdivision: null,
					},
					{
						StateCode: "JI",
						Name: "Jigawa",
						Subdivision: null,
					},
					{
						StateCode: "KD",
						Name: "Kaduna",
						Subdivision: null,
					},
					{
						StateCode: "KN",
						Name: "Kano",
						Subdivision: null,
					},
					{
						StateCode: "KT",
						Name: "Katsina",
						Subdivision: null,
					},
					{
						StateCode: "KE",
						Name: "Kebbi",
						Subdivision: null,
					},
					{
						StateCode: "KO",
						Name: "Kogi",
						Subdivision: null,
					},
					{
						StateCode: "KW",
						Name: "Kwara",
						Subdivision: null,
					},
					{
						StateCode: "LA",
						Name: "Lagos",
						Subdivision: null,
					},
					{
						StateCode: "NA",
						Name: "Nassarawa",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Niger",
						Subdivision: null,
					},
					{
						StateCode: "OG",
						Name: "Ogun",
						Subdivision: null,
					},
					{
						StateCode: "ON",
						Name: "Ondo",
						Subdivision: null,
					},
					{
						StateCode: "OS",
						Name: "Osun",
						Subdivision: null,
					},
					{
						StateCode: "OY",
						Name: "Oyo",
						Subdivision: null,
					},
					{
						StateCode: "PL",
						Name: "Plateau",
						Subdivision: null,
					},
					{
						StateCode: "RI",
						Name: "Rivers",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Sokoto",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Taraba",
						Subdivision: null,
					},
					{
						StateCode: "YO",
						Name: "Yobe",
						Subdivision: null,
					},
					{
						StateCode: "ZA",
						Name: "Zamfara",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "NU",
				ThreeDigit: "NIU",
				Name: "Niue",
				Capital: "Alofi",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [],
			},
			{
				TwoDigit: "NF",
				ThreeDigit: "NFK",
				Name: "Norfolk Island",
				Capital: "Kingston",
				Region: "Oceania",
				Subregion: "Australia and New Zealand",
				States: [],
			},
			{
				TwoDigit: "KP",
				ThreeDigit: "PRK",
				Name: "North Korea",
				Capital: "Pyongyang",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [
					{
						StateCode: "04",
						Name: "Chagang",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Kangwon",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "North Hamgyong",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "North Hwanghae",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "North Pyongan",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Pyongyang",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Rason",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Ryanggang",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "South Hamgyong",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "South Hwanghae",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "South Pyongan",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MP",
				ThreeDigit: "MNP",
				Name: "Northern Mariana Islands",
				Capital: "Saipan",
				Region: "Oceania",
				Subregion: "Micronesia",
				States: [],
			},
			{
				TwoDigit: "NO",
				ThreeDigit: "NOR",
				Name: "Norway",
				Capital: "Oslo",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "02",
						Name: "Akershus",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Aust-Agder",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Buskerud",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Finnmark",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Hedmark",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Hordaland",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Jan Mayen",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Møre og Romsdal",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Nord-Trøndelag",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Nordland",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Oppland",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Oslo",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Rogaland",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Sogn og Fjordane",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Svalbard",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Sør-Trøndelag",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Telemark",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Troms",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Vest-Agder",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Vestfold",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Østfold",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "OM",
				ThreeDigit: "OMN",
				Name: "Oman",
				Capital: "Muscat",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "DA",
						Name: "Ad Dākhilīyah",
						Subdivision: null,
					},
					{
						StateCode: "BU",
						Name: "Al Buraymī",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Al Bāţinah",
						Subdivision: null,
					},
					{
						StateCode: "WU",
						Name: "Al Wusţá",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Ash Sharqīyah",
						Subdivision: null,
					},
					{
						StateCode: "ZA",
						Name: "Az̧ Z̧āhirah",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Masqaţ",
						Subdivision: null,
					},
					{
						StateCode: "MU",
						Name: "Musandam",
						Subdivision: null,
					},
					{
						StateCode: "ZU",
						Name: "Z̧ufār",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PK",
				ThreeDigit: "PAK",
				Name: "Pakistan",
				Capital: "Islamabad",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "JK",
						Name: "Azad Kashmir",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Balochistan",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Federally Administered Tribal Areas",
						Subdivision: null,
					},
					{
						StateCode: "GB",
						Name: "Gilgit-Baltistan",
						Subdivision: null,
					},
					{
						StateCode: "IS",
						Name: "Islamabad",
						Subdivision: null,
					},
					{
						StateCode: "KP",
						Name: "Khyber Pakhtunkhwa",
						Subdivision: null,
					},
					{
						StateCode: "PB",
						Name: "Punjab",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Sindh",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PW",
				ThreeDigit: "PLW",
				Name: "Palau",
				Capital: "Ngerulmud",
				Region: "Oceania",
				Subregion: "Micronesia",
				States: [
					{
						StateCode: "002",
						Name: "Aimeliik",
						Subdivision: null,
					},
					{
						StateCode: "004",
						Name: "Airai",
						Subdivision: null,
					},
					{
						StateCode: "010",
						Name: "Angaur",
						Subdivision: null,
					},
					{
						StateCode: "050",
						Name: "Hatobohei",
						Subdivision: null,
					},
					{
						StateCode: "100",
						Name: "Kayangel",
						Subdivision: null,
					},
					{
						StateCode: "150",
						Name: "Koror",
						Subdivision: null,
					},
					{
						StateCode: "212",
						Name: "Melekeok",
						Subdivision: null,
					},
					{
						StateCode: "214",
						Name: "Ngaraard",
						Subdivision: null,
					},
					{
						StateCode: "218",
						Name: "Ngarchelong",
						Subdivision: null,
					},
					{
						StateCode: "222",
						Name: "Ngardmau",
						Subdivision: null,
					},
					{
						StateCode: "224",
						Name: "Ngatpang",
						Subdivision: null,
					},
					{
						StateCode: "226",
						Name: "Ngchesar",
						Subdivision: null,
					},
					{
						StateCode: "227",
						Name: "Ngeremlengui",
						Subdivision: null,
					},
					{
						StateCode: "228",
						Name: "Ngiwal",
						Subdivision: null,
					},
					{
						StateCode: "350",
						Name: "Peleliu",
						Subdivision: null,
					},
					{
						StateCode: "370",
						Name: "Sonsorol",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PS",
				ThreeDigit: "PSE",
				Name: "Palestine",
				Capital: "Ramallah",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "BTH",
						Name: "Bethlehem",
						Subdivision: null,
					},
					{
						StateCode: "DEB",
						Name: "Deir El Balah",
						Subdivision: null,
					},
					{
						StateCode: "GZA",
						Name: "Gaza",
						Subdivision: null,
					},
					{
						StateCode: "HBN",
						Name: "Hebron",
						Subdivision: null,
					},
					{
						StateCode: "JEN",
						Name: "Jenin",
						Subdivision: null,
					},
					{
						StateCode: "JRH",
						Name: "Jericho – Al Aghwar",
						Subdivision: null,
					},
					{
						StateCode: "JEM",
						Name: "Jerusalem",
						Subdivision: null,
					},
					{
						StateCode: "KYS",
						Name: "Khan Yunis",
						Subdivision: null,
					},
					{
						StateCode: "NBS",
						Name: "Nablus",
						Subdivision: null,
					},
					{
						StateCode: "NGZ",
						Name: "North Gaza",
						Subdivision: null,
					},
					{
						StateCode: "QQA",
						Name: "Qalqilya",
						Subdivision: null,
					},
					{
						StateCode: "RFH",
						Name: "Rafah",
						Subdivision: null,
					},
					{
						StateCode: "RBH",
						Name: "Ramallah",
						Subdivision: null,
					},
					{
						StateCode: "SLT",
						Name: "Salfit",
						Subdivision: null,
					},
					{
						StateCode: "TBS",
						Name: "Tubas",
						Subdivision: null,
					},
					{
						StateCode: "TKM",
						Name: "Tulkarm",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PA",
				ThreeDigit: "PAN",
				Name: "Panama",
				Capital: "Panama City",
				Region: "Americas",
				Subregion: "Central America",
				States: [
					{
						StateCode: "1",
						Name: "Bocas del Toro",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Chiriquí",
						Subdivision: null,
					},
					{
						StateCode: "2",
						Name: "Coclé",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Colón",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Darién",
						Subdivision: null,
					},
					{
						StateCode: "EM",
						Name: "Emberá",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "Herrera",
						Subdivision: null,
					},
					{
						StateCode: "KY",
						Name: "Kuna Yala",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "Los Santos",
						Subdivision: null,
					},
					{
						StateCode: "NB",
						Name: "Ngöbe-Buglé",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Panamá",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Panamá Oeste",
						Subdivision: null,
					},
					{
						StateCode: "9",
						Name: "Veraguas",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PG",
				ThreeDigit: "PNG",
				Name: "Papua New Guinea",
				Capital: "Port Moresby",
				Region: "Oceania",
				Subregion: "Melanesia",
				States: [
					{
						StateCode: "NSB",
						Name: "Bougainville",
						Subdivision: null,
					},
					{
						StateCode: "CPM",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "CPK",
						Name: "Chimbu",
						Subdivision: null,
					},
					{
						StateCode: "EBR",
						Name: "East New Britain",
						Subdivision: null,
					},
					{
						StateCode: "ESW",
						Name: "East Sepik",
						Subdivision: null,
					},
					{
						StateCode: "EHG",
						Name: "Eastern Highlands",
						Subdivision: null,
					},
					{
						StateCode: "EPW",
						Name: "Enga",
						Subdivision: null,
					},
					{
						StateCode: "GPK",
						Name: "Gulf",
						Subdivision: null,
					},
					{
						StateCode: "MPM",
						Name: "Madang",
						Subdivision: null,
					},
					{
						StateCode: "MRL",
						Name: "Manus",
						Subdivision: null,
					},
					{
						StateCode: "MBA",
						Name: "Milne Bay",
						Subdivision: null,
					},
					{
						StateCode: "MPL",
						Name: "Morobe",
						Subdivision: null,
					},
					{
						StateCode: "NCD",
						Name: "National Capital District",
						Subdivision: null,
					},
					{
						StateCode: "NIK",
						Name: "New Ireland",
						Subdivision: null,
					},
					{
						StateCode: "NPP",
						Name: "Northern",
						Subdivision: null,
					},
					{
						StateCode: "SAN",
						Name: "Sandaun",
						Subdivision: null,
					},
					{
						StateCode: "SHM",
						Name: "Southern Highlands",
						Subdivision: null,
					},
					{
						StateCode: "WBK",
						Name: "West New Britain",
						Subdivision: null,
					},
					{
						StateCode: "WPD",
						Name: "Western",
						Subdivision: null,
					},
					{
						StateCode: "WHM",
						Name: "Western Highlands",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PY",
				ThreeDigit: "PRY",
				Name: "Paraguay",
				Capital: "Asunción",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "16",
						Name: "Alto Paraguay",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Alto Paraná",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Amambay",
						Subdivision: null,
					},
					{
						StateCode: "ASU",
						Name: "Asunción",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Boquerón",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Caaguazú",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "Caazapá",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Canindeyú",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "1",
						Name: "Concepción",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Cordillera",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Guairá",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "Itapúa",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Misiones",
						Subdivision: null,
					},
					{
						StateCode: "9",
						Name: "Paraguarí",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Presidente Hayes",
						Subdivision: null,
					},
					{
						StateCode: "2",
						Name: "San Pedro",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Ñeembucú",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PE",
				ThreeDigit: "PER",
				Name: "Peru",
				Capital: "Lima",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "AMA",
						Name: "Amazonas",
						Subdivision: null,
					},
					{
						StateCode: "ANC",
						Name: "Ancash",
						Subdivision: null,
					},
					{
						StateCode: "APU",
						Name: "Apurímac",
						Subdivision: null,
					},
					{
						StateCode: "ARE",
						Name: "Arequipa",
						Subdivision: null,
					},
					{
						StateCode: "AYA",
						Name: "Ayacucho",
						Subdivision: null,
					},
					{
						StateCode: "CAJ",
						Name: "Cajamarca",
						Subdivision: null,
					},
					{
						StateCode: "CUS",
						Name: "Cusco",
						Subdivision: null,
					},
					{
						StateCode: "CAL",
						Name: "El Callao",
						Subdivision: null,
					},
					{
						StateCode: "HUV",
						Name: "Huancavelica",
						Subdivision: null,
					},
					{
						StateCode: "HUC",
						Name: "Huánuco",
						Subdivision: null,
					},
					{
						StateCode: "ICA",
						Name: "Ica",
						Subdivision: null,
					},
					{
						StateCode: "JUN",
						Name: "Junín",
						Subdivision: null,
					},
					{
						StateCode: "LAL",
						Name: "La Libertad",
						Subdivision: null,
					},
					{
						StateCode: "LAM",
						Name: "Lambayeque",
						Subdivision: null,
					},
					{
						StateCode: "LIM",
						Name: "Lima",
						Subdivision: null,
					},
					{
						StateCode: "LOR",
						Name: "Loreto",
						Subdivision: null,
					},
					{
						StateCode: "MDD",
						Name: "Madre de Dios",
						Subdivision: null,
					},
					{
						StateCode: "MOQ",
						Name: "Moquegua",
						Subdivision: null,
					},
					{
						StateCode: "LMA",
						Name: "Municipalidad Metropolitana de Lima",
						Subdivision: null,
					},
					{
						StateCode: "PAS",
						Name: "Pasco",
						Subdivision: null,
					},
					{
						StateCode: "PIU",
						Name: "Piura",
						Subdivision: null,
					},
					{
						StateCode: "PUN",
						Name: "Puno",
						Subdivision: null,
					},
					{
						StateCode: "SAM",
						Name: "San Martín",
						Subdivision: null,
					},
					{
						StateCode: "TAC",
						Name: "Tacna",
						Subdivision: null,
					},
					{
						StateCode: "TUM",
						Name: "Tumbes",
						Subdivision: null,
					},
					{
						StateCode: "UCA",
						Name: "Ucayali",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PH",
				ThreeDigit: "PHL",
				Name: "Philippines",
				Capital: "Manila",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "14",
						Name: "Autonomous Region in Muslim Mindanao",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Bicol",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Cagayan Valley",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Calabarzon",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Caraga",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Central Luzon",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Central Visayas",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Cordillera Administrative Region",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Davao",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Eastern Visayas",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Ilocos",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Mimaropa",
						Subdivision: null,
					},
					{
						StateCode: "00",
						Name: "National Capital Region",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Northern Mindanao",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Soccsksargen",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Western Visayas",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Zamboanga Peninsula",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PN",
				ThreeDigit: "PCN",
				Name: "Pitcairn Islands",
				Capital: "Adamstown",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [],
			},
			{
				TwoDigit: "PL",
				ThreeDigit: "POL",
				Name: "Poland",
				Capital: "Warsaw",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "DS",
						Name: "Dolnośląskie",
						Subdivision: null,
					},
					{
						StateCode: "KP",
						Name: "Kujawsko-pomorskie",
						Subdivision: null,
					},
					{
						StateCode: "LU",
						Name: "Lubelskie",
						Subdivision: null,
					},
					{
						StateCode: "LB",
						Name: "Lubuskie",
						Subdivision: null,
					},
					{
						StateCode: "MZ",
						Name: "Mazowieckie",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Małopolskie",
						Subdivision: null,
					},
					{
						StateCode: "OP",
						Name: "Opolskie",
						Subdivision: null,
					},
					{
						StateCode: "PK",
						Name: "Podkarpackie",
						Subdivision: null,
					},
					{
						StateCode: "PD",
						Name: "Podlaskie",
						Subdivision: null,
					},
					{
						StateCode: "PM",
						Name: "Pomorskie",
						Subdivision: null,
					},
					{
						StateCode: "WN",
						Name: "Warmińsko-mazurskie",
						Subdivision: null,
					},
					{
						StateCode: "WP",
						Name: "Wielkopolskie",
						Subdivision: null,
					},
					{
						StateCode: "ZP",
						Name: "Zachodniopomorskie",
						Subdivision: null,
					},
					{
						StateCode: "LD",
						Name: "Łódzkie",
						Subdivision: null,
					},
					{
						StateCode: "SL",
						Name: "Śląskie",
						Subdivision: null,
					},
					{
						StateCode: "SK",
						Name: "Świętokrzyskie",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PT",
				ThreeDigit: "PRT",
				Name: "Portugal",
				Capital: "Lisbon",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Aveiro",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Beja",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Braga",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Bragança",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Castelo Branco",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Coimbra",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Faro",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Guarda",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Leiria",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Lisboa",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Portalegre",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Porto",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Região Autónoma da Madeira",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Região Autónoma dos Açores",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Santarém",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Setúbal",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Viana do Castelo",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Vila Real",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Viseu",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Évora",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "PR",
				ThreeDigit: "PRI",
				Name: "Puerto Rico",
				Capital: "San Juan",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "QA",
				ThreeDigit: "QAT",
				Name: "Qatar",
				Capital: "Doha",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "DA",
						Name: "Ad Dawḩah",
						Subdivision: null,
					},
					{
						StateCode: "KH",
						Name: "Al Khawr wa adh Dhakhīrah",
						Subdivision: null,
					},
					{
						StateCode: "WA",
						Name: "Al Wakrah",
						Subdivision: null,
					},
					{
						StateCode: "RA",
						Name: "Ar Rayyān",
						Subdivision: null,
					},
					{
						StateCode: "MS",
						Name: "Ash Shamāl",
						Subdivision: null,
					},
					{
						StateCode: "ZA",
						Name: "Az̧ Za̧`āyin",
						Subdivision: null,
					},
					{
						StateCode: "US",
						Name: "Umm Şalāl",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "XK",
				ThreeDigit: "KOS",
				Name: "Republic of Kosovo",
				Capital: "Pristina",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [],
			},
			{
				TwoDigit: "RE",
				ThreeDigit: "REU",
				Name: "Réunion",
				Capital: "Saint-Denis",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [],
			},
			{
				TwoDigit: "RO",
				ThreeDigit: "ROU",
				Name: "Romania",
				Capital: "Bucharest",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "AB",
						Name: "Alba",
						Subdivision: null,
					},
					{
						StateCode: "AR",
						Name: "Arad",
						Subdivision: null,
					},
					{
						StateCode: "AG",
						Name: "Argeș",
						Subdivision: null,
					},
					{
						StateCode: "BC",
						Name: "Bacău",
						Subdivision: null,
					},
					{
						StateCode: "BH",
						Name: "Bihor",
						Subdivision: null,
					},
					{
						StateCode: "BN",
						Name: "Bistrița-Năsăud",
						Subdivision: null,
					},
					{
						StateCode: "BT",
						Name: "Botoșani",
						Subdivision: null,
					},
					{
						StateCode: "BV",
						Name: "Brașov",
						Subdivision: null,
					},
					{
						StateCode: "BR",
						Name: "Brăila",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "București",
						Subdivision: null,
					},
					{
						StateCode: "BZ",
						Name: "Buzău",
						Subdivision: null,
					},
					{
						StateCode: "CS",
						Name: "Caraș-Severin",
						Subdivision: null,
					},
					{
						StateCode: "CJ",
						Name: "Cluj",
						Subdivision: null,
					},
					{
						StateCode: "CT",
						Name: "Constanța",
						Subdivision: null,
					},
					{
						StateCode: "CV",
						Name: "Covasna",
						Subdivision: null,
					},
					{
						StateCode: "CL",
						Name: "Călărași",
						Subdivision: null,
					},
					{
						StateCode: "DJ",
						Name: "Dolj",
						Subdivision: null,
					},
					{
						StateCode: "DB",
						Name: "Dâmbovița",
						Subdivision: null,
					},
					{
						StateCode: "GL",
						Name: "Galați",
						Subdivision: null,
					},
					{
						StateCode: "GR",
						Name: "Giurgiu",
						Subdivision: null,
					},
					{
						StateCode: "GJ",
						Name: "Gorj",
						Subdivision: null,
					},
					{
						StateCode: "HR",
						Name: "Harghita",
						Subdivision: null,
					},
					{
						StateCode: "HD",
						Name: "Hunedoara",
						Subdivision: null,
					},
					{
						StateCode: "IL",
						Name: "Ialomița",
						Subdivision: null,
					},
					{
						StateCode: "IS",
						Name: "Iași",
						Subdivision: null,
					},
					{
						StateCode: "IF",
						Name: "Ilfov",
						Subdivision: null,
					},
					{
						StateCode: "MM",
						Name: "Maramureș",
						Subdivision: null,
					},
					{
						StateCode: "MH",
						Name: "Mehedinți",
						Subdivision: null,
					},
					{
						StateCode: "MS",
						Name: "Mureș",
						Subdivision: null,
					},
					{
						StateCode: "NT",
						Name: "Neamț",
						Subdivision: null,
					},
					{
						StateCode: "OT",
						Name: "Olt",
						Subdivision: null,
					},
					{
						StateCode: "PH",
						Name: "Prahova",
						Subdivision: null,
					},
					{
						StateCode: "SM",
						Name: "Satu Mare",
						Subdivision: null,
					},
					{
						StateCode: "SB",
						Name: "Sibiu",
						Subdivision: null,
					},
					{
						StateCode: "SV",
						Name: "Suceava",
						Subdivision: null,
					},
					{
						StateCode: "SJ",
						Name: "Sălaj",
						Subdivision: null,
					},
					{
						StateCode: "TR",
						Name: "Teleorman",
						Subdivision: null,
					},
					{
						StateCode: "TM",
						Name: "Timiș",
						Subdivision: null,
					},
					{
						StateCode: "TL",
						Name: "Tulcea",
						Subdivision: null,
					},
					{
						StateCode: "VS",
						Name: "Vaslui",
						Subdivision: null,
					},
					{
						StateCode: "VN",
						Name: "Vrancea",
						Subdivision: null,
					},
					{
						StateCode: "VL",
						Name: "Vâlcea",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "RU",
				ThreeDigit: "RUS",
				Name: "Russia",
				Capital: "Moscow",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "AMU",
						Name: "Amurskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "ARK",
						Name: "Arkhangel'skaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "AST",
						Name: "Astrakhanskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "BEL",
						Name: "Belgorodskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "BRY",
						Name: "Bryanskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "CHE",
						Name: "Chelyabinskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "IRK",
						Name: "Irkutskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "IVA",
						Name: "Ivanovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "KGD",
						Name: "Kaliningradskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "KLU",
						Name: "Kaluzhskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "KEM",
						Name: "Kemerovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "KIR",
						Name: "Kirovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "KOS",
						Name: "Kostromskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "KGN",
						Name: "Kurganskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "KRS",
						Name: "Kurskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "LEN",
						Name: "Leningradskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "LIP",
						Name: "Lipetskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "MAG",
						Name: "Magadanskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "MOS",
						Name: "Moskovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "MUR",
						Name: "Murmanskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "NIZ",
						Name: "Nizhegorodskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "NGR",
						Name: "Novgorodskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "NVS",
						Name: "Novosibirskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "OMS",
						Name: "Omskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "ORE",
						Name: "Orenburgskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "ORL",
						Name: "Orlovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "PNZ",
						Name: "Penzenskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "PSK",
						Name: "Pskovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "ROS",
						Name: "Rostovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "RYA",
						Name: "Ryazanskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "SAK",
						Name: "Sakhalinskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "SAM",
						Name: "Samarskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "SAR",
						Name: "Saratovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "SMO",
						Name: "Smolenskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "SVE",
						Name: "Sverdlovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "TAM",
						Name: "Tambovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "TOM",
						Name: "Tomskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "TUL",
						Name: "Tul'skaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "TVE",
						Name: "Tverskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "TYU",
						Name: "Tyumenskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "ULY",
						Name: "Ul'yanovskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "VLA",
						Name: "Vladimirskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "VGG",
						Name: "Volgogradskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "VLG",
						Name: "Vologodskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "VOR",
						Name: "Voronezhskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "YAR",
						Name: "Yaroslavskaya oblast'",
						Subdivision: "administrative region",
					},
					{
						StateCode: "ALT",
						Name: "Altayskiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "KAM",
						Name: "Kamchatskiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "KHA",
						Name: "Khabarovskiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "KDA",
						Name: "Krasnodarskiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "KYA",
						Name: "Krasnoyarskiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "PER",
						Name: "Permskiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "PRI",
						Name: "Primorskiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "STA",
						Name: "Stavropol'skiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "ZAB",
						Name: "Zabaykal'skiy kray",
						Subdivision: "administrative territory",
					},
					{
						StateCode: "MOW",
						Name: "Moskva",
						Subdivision: "autonomous city",
					},
					{
						StateCode: "SPE",
						Name: "Sankt-Peterburg",
						Subdivision: "autonomous city",
					},
					{
						StateCode: "CHU",
						Name: "Chukotskiy avtonomnyy okrug",
						Subdivision: "autonomous district",
					},
					{
						StateCode: "KHM",
						Name: "Khanty-Mansiyskiy avtonomnyy okrug-Yugra",
						Subdivision: "autonomous district",
					},
					{
						StateCode: "NEN",
						Name: "Nenetskiy avtonomnyy okrug",
						Subdivision: "autonomous district",
					},
					{
						StateCode: "YAN",
						Name: "Yamalo-Nenetskiy avtonomnyy okrug",
						Subdivision: "autonomous district",
					},
					{
						StateCode: "YEV",
						Name: "Yevreyskaya avtonomnaya oblast'",
						Subdivision: "autonomous region",
					},
					{
						StateCode: "AD",
						Name: "Adygeya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "AL",
						Name: "Altay, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "BA",
						Name: "Bashkortostan, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "BU",
						Name: "Buryatiya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "CE",
						Name: "Chechenskaya Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "CU",
						Name: "Chuvashskaya Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "DA",
						Name: "Dagestan, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "IN",
						Name: "Ingushetiya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "KB",
						Name: "Kabardino-Balkarskaya Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "KL",
						Name: "Kalmykiya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "KC",
						Name: "Karachayevo-Cherkesskaya Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "KR",
						Name: "Kareliya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "KK",
						Name: "Khakasiya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "KO",
						Name: "Komi, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "ME",
						Name: "Mariy El, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "MO",
						Name: "Mordoviya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "SA",
						Name: "Sakha, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "SE",
						Name: "Severnaya Osetiya-Alaniya, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "TA",
						Name: "Tatarstan, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "TY",
						Name: "Tyva, Respublika",
						Subdivision: "republic",
					},
					{
						StateCode: "UD",
						Name: "Udmurtskaya Respublika",
						Subdivision: "republic",
					},
				],
			},
			{
				TwoDigit: "RW",
				ThreeDigit: "RWA",
				Name: "Rwanda",
				Capital: "Kigali",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "02",
						Name: "Est",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Nord",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Ouest",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Sud",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Ville de Kigali",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "BL",
				ThreeDigit: "BLM",
				Name: "Saint Barthélemy",
				Capital: "Gustavia",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "SH",
				ThreeDigit: "SHN",
				Name: "Saint Helena",
				Capital: "Jamestown",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "AC",
						Name: "Ascension",
						Subdivision: null,
					},
					{
						StateCode: "HL",
						Name: "Saint Helena",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tristan da Cunha",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "KN",
				ThreeDigit: "KNA",
				Name: "Saint Kitts and Nevis",
				Capital: "Basseterre",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "N",
						Name: "Nevis",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Saint Kitts",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "LC",
				ThreeDigit: "LCA",
				Name: "Saint Lucia",
				Capital: "Castries",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "01",
						Name: "Anse la Raye",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Castries",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Choiseul",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Dauphin",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Dennery",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Gros Islet",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Laborie",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Micoud",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Praslin",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Soufrière",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Vieux Fort",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "MF",
				ThreeDigit: "MAF",
				Name: "Saint Martin",
				Capital: "Marigot",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "PM",
				ThreeDigit: "SPM",
				Name: "Saint Pierre and Miquelon",
				Capital: "Saint-Pierre",
				Region: "Americas",
				Subregion: "Northern America",
				States: [],
			},
			{
				TwoDigit: "VC",
				ThreeDigit: "VCT",
				Name: "Saint Vincent and the Grenadines",
				Capital: "Kingstown",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "01",
						Name: "Charlotte",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Grenadines",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Saint Andrew",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Saint David",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Saint George",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Saint Patrick",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "WS",
				ThreeDigit: "WSM",
				Name: "Samoa",
				Capital: "Apia",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [
					{
						StateCode: "AA",
						Name: "A'ana",
						Subdivision: null,
					},
					{
						StateCode: "AL",
						Name: "Aiga-i-le-Tai",
						Subdivision: null,
					},
					{
						StateCode: "AT",
						Name: "Atua",
						Subdivision: null,
					},
					{
						StateCode: "FA",
						Name: "Fa'asaleleaga",
						Subdivision: null,
					},
					{
						StateCode: "GE",
						Name: "Gaga'emauga",
						Subdivision: null,
					},
					{
						StateCode: "GI",
						Name: "Gagaifomauga",
						Subdivision: null,
					},
					{
						StateCode: "PA",
						Name: "Palauli",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Satupa'itea",
						Subdivision: null,
					},
					{
						StateCode: "TU",
						Name: "Tuamasaga",
						Subdivision: null,
					},
					{
						StateCode: "VF",
						Name: "Va'a-o-Fonoti",
						Subdivision: null,
					},
					{
						StateCode: "VS",
						Name: "Vaisigano",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SM",
				ThreeDigit: "SMR",
				Name: "San Marino",
				Capital: "City of San Marino",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "01",
						Name: "Acquaviva",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Borgo Maggiore",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Chiesanuova",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Domagnano",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Faetano",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Fiorentino",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Montegiardino",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "San Marino",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Serravalle",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ST",
				ThreeDigit: "STP",
				Name: "São Tomé and Príncipe",
				Capital: "São Tomé",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "P",
						Name: "Príncipe",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "São Tomé",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SA",
				ThreeDigit: "SAU",
				Name: "Saudi Arabia",
				Capital: "Riyadh",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "11",
						Name: "Al Bāḩah",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Al Jawf",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Al Madīnah",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Al Qaşīm",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Al Ḩudūd ash Shamālīyah",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Ar Riyāḑ",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Ash Sharqīyah",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Jīzān",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Makkah",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Najrān",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Tabūk",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "ٰĀsīr",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Ḩā'il",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SN",
				ThreeDigit: "SEN",
				Name: "Senegal",
				Capital: "Dakar",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "DK",
						Name: "Dakar",
						Subdivision: null,
					},
					{
						StateCode: "DB",
						Name: "Diourbel",
						Subdivision: null,
					},
					{
						StateCode: "FK",
						Name: "Fatick",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Kaffrine",
						Subdivision: null,
					},
					{
						StateCode: "KL",
						Name: "Kaolack",
						Subdivision: null,
					},
					{
						StateCode: "KD",
						Name: "Kolda",
						Subdivision: null,
					},
					{
						StateCode: "KE",
						Name: "Kédougou",
						Subdivision: null,
					},
					{
						StateCode: "LG",
						Name: "Louga",
						Subdivision: null,
					},
					{
						StateCode: "MT",
						Name: "Matam",
						Subdivision: null,
					},
					{
						StateCode: "SL",
						Name: "Saint-Louis",
						Subdivision: null,
					},
					{
						StateCode: "SE",
						Name: "Sédhiou",
						Subdivision: null,
					},
					{
						StateCode: "TC",
						Name: "Tambacounda",
						Subdivision: null,
					},
					{
						StateCode: "TH",
						Name: "Thiès",
						Subdivision: null,
					},
					{
						StateCode: "ZG",
						Name: "Ziguinchor",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "RS",
				ThreeDigit: "SRB",
				Name: "Serbia",
				Capital: "Belgrade",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "KM",
						Name: "Kosovo-Metohija",
						Subdivision: null,
					},
					{
						StateCode: "VO",
						Name: "Vojvodina",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SC",
				ThreeDigit: "SYC",
				Name: "Seychelles",
				Capital: "Victoria",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "02",
						Name: "Anse Boileau",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Anse Etoile",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Anse Royale",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Anse aux Pins",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Au Cap",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Baie Lazare",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Baie Sainte Anne",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Beau Vallon",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Bel Air",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Bel Ombre",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Cascade",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "English River",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Glacis",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Grand Anse Mahe",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Grand Anse Praslin",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "La Digue",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Les Mamelles",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Mont Buxton",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Mont Fleuri",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Plaisance",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Pointe Larue",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Port Glaud",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Roche Caiman",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Saint Louis",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Takamaka",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SL",
				ThreeDigit: "SLE",
				Name: "Sierra Leone",
				Capital: "Freetown",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "E",
						Name: "Eastern",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Northern",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Southern",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Western Area",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SG",
				ThreeDigit: "SGP",
				Name: "Singapore",
				Capital: "Singapore",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "01",
						Name: "Central Singapore",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "North East",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "North West",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "South East",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "South West",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SX",
				ThreeDigit: "SXM",
				Name: "Sint Maarten",
				Capital: "Philipsburg",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "SK",
				ThreeDigit: "SVK",
				Name: "Slovakia",
				Capital: "Bratislava",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "BC",
						Name: "Banskobystrický kraj",
						Subdivision: null,
					},
					{
						StateCode: "BL",
						Name: "Bratislavský kraj",
						Subdivision: null,
					},
					{
						StateCode: "KI",
						Name: "Košický kraj",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Nitriansky kraj",
						Subdivision: null,
					},
					{
						StateCode: "PV",
						Name: "Prešovský kraj",
						Subdivision: null,
					},
					{
						StateCode: "TC",
						Name: "Trenčiansky kraj",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Trnavský kraj",
						Subdivision: null,
					},
					{
						StateCode: "ZI",
						Name: "Žilinský kraj",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SI",
				ThreeDigit: "SVN",
				Name: "Slovenia",
				Capital: "Ljubljana",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "001",
						Name: "Ajdovščina",
						Subdivision: null,
					},
					{
						StateCode: "195",
						Name: "Apače",
						Subdivision: null,
					},
					{
						StateCode: "002",
						Name: "Beltinci",
						Subdivision: null,
					},
					{
						StateCode: "148",
						Name: "Benedikt",
						Subdivision: null,
					},
					{
						StateCode: "149",
						Name: "Bistrica ob Sotli",
						Subdivision: null,
					},
					{
						StateCode: "003",
						Name: "Bled",
						Subdivision: null,
					},
					{
						StateCode: "150",
						Name: "Bloke",
						Subdivision: null,
					},
					{
						StateCode: "004",
						Name: "Bohinj",
						Subdivision: null,
					},
					{
						StateCode: "005",
						Name: "Borovnica",
						Subdivision: null,
					},
					{
						StateCode: "006",
						Name: "Bovec",
						Subdivision: null,
					},
					{
						StateCode: "151",
						Name: "Braslovče",
						Subdivision: null,
					},
					{
						StateCode: "007",
						Name: "Brda",
						Subdivision: null,
					},
					{
						StateCode: "008",
						Name: "Brezovica",
						Subdivision: null,
					},
					{
						StateCode: "009",
						Name: "Brežice",
						Subdivision: null,
					},
					{
						StateCode: "152",
						Name: "Cankova",
						Subdivision: null,
					},
					{
						StateCode: "011",
						Name: "Celje",
						Subdivision: null,
					},
					{
						StateCode: "012",
						Name: "Cerklje na Gorenjskem",
						Subdivision: null,
					},
					{
						StateCode: "013",
						Name: "Cerknica",
						Subdivision: null,
					},
					{
						StateCode: "014",
						Name: "Cerkno",
						Subdivision: null,
					},
					{
						StateCode: "153",
						Name: "Cerkvenjak",
						Subdivision: null,
					},
					{
						StateCode: "196",
						Name: "Cirkulane",
						Subdivision: null,
					},
					{
						StateCode: "018",
						Name: "Destrnik",
						Subdivision: null,
					},
					{
						StateCode: "019",
						Name: "Divača",
						Subdivision: null,
					},
					{
						StateCode: "154",
						Name: "Dobje",
						Subdivision: null,
					},
					{
						StateCode: "020",
						Name: "Dobrepolje",
						Subdivision: null,
					},
					{
						StateCode: "155",
						Name: "Dobrna",
						Subdivision: null,
					},
					{
						StateCode: "021",
						Name: "Dobrova–Polhov Gradec",
						Subdivision: null,
					},
					{
						StateCode: "156",
						Name: "Dobrovnik",
						Subdivision: null,
					},
					{
						StateCode: "022",
						Name: "Dol pri Ljubljani",
						Subdivision: null,
					},
					{
						StateCode: "157",
						Name: "Dolenjske Toplice",
						Subdivision: null,
					},
					{
						StateCode: "023",
						Name: "Domžale",
						Subdivision: null,
					},
					{
						StateCode: "024",
						Name: "Dornava",
						Subdivision: null,
					},
					{
						StateCode: "025",
						Name: "Dravograd",
						Subdivision: null,
					},
					{
						StateCode: "026",
						Name: "Duplek",
						Subdivision: null,
					},
					{
						StateCode: "027",
						Name: "Gorenja vas–Poljane",
						Subdivision: null,
					},
					{
						StateCode: "028",
						Name: "Gorišnica",
						Subdivision: null,
					},
					{
						StateCode: "207",
						Name: "Gorje",
						Subdivision: null,
					},
					{
						StateCode: "029",
						Name: "Gornja Radgona",
						Subdivision: null,
					},
					{
						StateCode: "030",
						Name: "Gornji Grad",
						Subdivision: null,
					},
					{
						StateCode: "031",
						Name: "Gornji Petrovci",
						Subdivision: null,
					},
					{
						StateCode: "158",
						Name: "Grad",
						Subdivision: null,
					},
					{
						StateCode: "032",
						Name: "Grosuplje",
						Subdivision: null,
					},
					{
						StateCode: "159",
						Name: "Hajdina",
						Subdivision: null,
					},
					{
						StateCode: "161",
						Name: "Hodoš",
						Subdivision: null,
					},
					{
						StateCode: "162",
						Name: "Horjul",
						Subdivision: null,
					},
					{
						StateCode: "160",
						Name: "Hoče–Slivnica",
						Subdivision: null,
					},
					{
						StateCode: "034",
						Name: "Hrastnik",
						Subdivision: null,
					},
					{
						StateCode: "035",
						Name: "Hrpelje-Kozina",
						Subdivision: null,
					},
					{
						StateCode: "036",
						Name: "Idrija",
						Subdivision: null,
					},
					{
						StateCode: "037",
						Name: "Ig",
						Subdivision: null,
					},
					{
						StateCode: "038",
						Name: "Ilirska Bistrica",
						Subdivision: null,
					},
					{
						StateCode: "039",
						Name: "Ivančna Gorica",
						Subdivision: null,
					},
					{
						StateCode: "040",
						Name: "Izola",
						Subdivision: null,
					},
					{
						StateCode: "041",
						Name: "Jesenice",
						Subdivision: null,
					},
					{
						StateCode: "163",
						Name: "Jezersko",
						Subdivision: null,
					},
					{
						StateCode: "042",
						Name: "Juršinci",
						Subdivision: null,
					},
					{
						StateCode: "043",
						Name: "Kamnik",
						Subdivision: null,
					},
					{
						StateCode: "044",
						Name: "Kanal",
						Subdivision: null,
					},
					{
						StateCode: "045",
						Name: "Kidričevo",
						Subdivision: null,
					},
					{
						StateCode: "046",
						Name: "Kobarid",
						Subdivision: null,
					},
					{
						StateCode: "047",
						Name: "Kobilje",
						Subdivision: null,
					},
					{
						StateCode: "049",
						Name: "Komen",
						Subdivision: null,
					},
					{
						StateCode: "164",
						Name: "Komenda",
						Subdivision: null,
					},
					{
						StateCode: "050",
						Name: "Koper",
						Subdivision: null,
					},
					{
						StateCode: "197",
						Name: "Kosanjevica na Krki",
						Subdivision: null,
					},
					{
						StateCode: "165",
						Name: "Kostel",
						Subdivision: null,
					},
					{
						StateCode: "051",
						Name: "Kozje",
						Subdivision: null,
					},
					{
						StateCode: "048",
						Name: "Kočevje",
						Subdivision: null,
					},
					{
						StateCode: "052",
						Name: "Kranj",
						Subdivision: null,
					},
					{
						StateCode: "053",
						Name: "Kranjska Gora",
						Subdivision: null,
					},
					{
						StateCode: "166",
						Name: "Križevci",
						Subdivision: null,
					},
					{
						StateCode: "054",
						Name: "Krško",
						Subdivision: null,
					},
					{
						StateCode: "055",
						Name: "Kungota",
						Subdivision: null,
					},
					{
						StateCode: "056",
						Name: "Kuzma",
						Subdivision: null,
					},
					{
						StateCode: "057",
						Name: "Laško",
						Subdivision: null,
					},
					{
						StateCode: "058",
						Name: "Lenart",
						Subdivision: null,
					},
					{
						StateCode: "059",
						Name: "Lendava",
						Subdivision: null,
					},
					{
						StateCode: "060",
						Name: "Litija",
						Subdivision: null,
					},
					{
						StateCode: "061",
						Name: "Ljubljana",
						Subdivision: null,
					},
					{
						StateCode: "062",
						Name: "Ljubno",
						Subdivision: null,
					},
					{
						StateCode: "063",
						Name: "Ljutomer",
						Subdivision: null,
					},
					{
						StateCode: "208",
						Name: "Log-Dragomer",
						Subdivision: null,
					},
					{
						StateCode: "064",
						Name: "Logatec",
						Subdivision: null,
					},
					{
						StateCode: "167",
						Name: "Lovrenc na Pohorju",
						Subdivision: null,
					},
					{
						StateCode: "065",
						Name: "Loška Dolina",
						Subdivision: null,
					},
					{
						StateCode: "066",
						Name: "Loški Potok",
						Subdivision: null,
					},
					{
						StateCode: "068",
						Name: "Lukovica",
						Subdivision: null,
					},
					{
						StateCode: "067",
						Name: "Luče",
						Subdivision: null,
					},
					{
						StateCode: "069",
						Name: "Majšperk",
						Subdivision: null,
					},
					{
						StateCode: "198",
						Name: "Makole",
						Subdivision: null,
					},
					{
						StateCode: "070",
						Name: "Maribor",
						Subdivision: null,
					},
					{
						StateCode: "168",
						Name: "Markovci",
						Subdivision: null,
					},
					{
						StateCode: "071",
						Name: "Medvode",
						Subdivision: null,
					},
					{
						StateCode: "072",
						Name: "Mengeš",
						Subdivision: null,
					},
					{
						StateCode: "073",
						Name: "Metlika",
						Subdivision: null,
					},
					{
						StateCode: "074",
						Name: "Mežica",
						Subdivision: null,
					},
					{
						StateCode: "169",
						Name: "Miklavž na Dravskem Polju",
						Subdivision: null,
					},
					{
						StateCode: "075",
						Name: "Miren–Kostanjevica",
						Subdivision: null,
					},
					{
						StateCode: "170",
						Name: "Mirna Peč",
						Subdivision: null,
					},
					{
						StateCode: "076",
						Name: "Mislinja",
						Subdivision: null,
					},
					{
						StateCode: "199",
						Name: "Mokronog–Trebelno",
						Subdivision: null,
					},
					{
						StateCode: "078",
						Name: "Moravske Toplice",
						Subdivision: null,
					},
					{
						StateCode: "077",
						Name: "Moravče",
						Subdivision: null,
					},
					{
						StateCode: "079",
						Name: "Mozirje",
						Subdivision: null,
					},
					{
						StateCode: "080",
						Name: "Murska Sobota",
						Subdivision: null,
					},
					{
						StateCode: "081",
						Name: "Muta",
						Subdivision: null,
					},
					{
						StateCode: "082",
						Name: "Naklo",
						Subdivision: null,
					},
					{
						StateCode: "083",
						Name: "Nazarje",
						Subdivision: null,
					},
					{
						StateCode: "084",
						Name: "Nova Gorica",
						Subdivision: null,
					},
					{
						StateCode: "085",
						Name: "Novo Mesto",
						Subdivision: null,
					},
					{
						StateCode: "086",
						Name: "Odranci",
						Subdivision: null,
					},
					{
						StateCode: "171",
						Name: "Oplotnica",
						Subdivision: null,
					},
					{
						StateCode: "087",
						Name: "Ormož",
						Subdivision: null,
					},
					{
						StateCode: "088",
						Name: "Osilnica",
						Subdivision: null,
					},
					{
						StateCode: "089",
						Name: "Pesnica",
						Subdivision: null,
					},
					{
						StateCode: "090",
						Name: "Piran",
						Subdivision: null,
					},
					{
						StateCode: "091",
						Name: "Pivka",
						Subdivision: null,
					},
					{
						StateCode: "172",
						Name: "Podlehnik",
						Subdivision: null,
					},
					{
						StateCode: "093",
						Name: "Podvelka",
						Subdivision: null,
					},
					{
						StateCode: "092",
						Name: "Podčetrtek",
						Subdivision: null,
					},
					{
						StateCode: "200",
						Name: "Poljčane",
						Subdivision: null,
					},
					{
						StateCode: "173",
						Name: "Polzela",
						Subdivision: null,
					},
					{
						StateCode: "094",
						Name: "Postojna",
						Subdivision: null,
					},
					{
						StateCode: "174",
						Name: "Prebold",
						Subdivision: null,
					},
					{
						StateCode: "095",
						Name: "Preddvor",
						Subdivision: null,
					},
					{
						StateCode: "175",
						Name: "Prevalje",
						Subdivision: null,
					},
					{
						StateCode: "096",
						Name: "Ptuj",
						Subdivision: null,
					},
					{
						StateCode: "097",
						Name: "Puconci",
						Subdivision: null,
					},
					{
						StateCode: "100",
						Name: "Radenci",
						Subdivision: null,
					},
					{
						StateCode: "099",
						Name: "Radeče",
						Subdivision: null,
					},
					{
						StateCode: "101",
						Name: "Radlje ob Dravi",
						Subdivision: null,
					},
					{
						StateCode: "102",
						Name: "Radovljica",
						Subdivision: null,
					},
					{
						StateCode: "103",
						Name: "Ravne na Koroškem",
						Subdivision: null,
					},
					{
						StateCode: "176",
						Name: "Razkrižje",
						Subdivision: null,
					},
					{
						StateCode: "098",
						Name: "Rače–Fram",
						Subdivision: null,
					},
					{
						StateCode: "201",
						Name: "Renče-Vogrsko",
						Subdivision: null,
					},
					{
						StateCode: "209",
						Name: "Rečica ob Savinji",
						Subdivision: null,
					},
					{
						StateCode: "104",
						Name: "Ribnica",
						Subdivision: null,
					},
					{
						StateCode: "177",
						Name: "Ribnica na Pohorju",
						Subdivision: null,
					},
					{
						StateCode: "107",
						Name: "Rogatec",
						Subdivision: null,
					},
					{
						StateCode: "106",
						Name: "Rogaška Slatina",
						Subdivision: null,
					},
					{
						StateCode: "105",
						Name: "Rogašovci",
						Subdivision: null,
					},
					{
						StateCode: "108",
						Name: "Ruše",
						Subdivision: null,
					},
					{
						StateCode: "178",
						Name: "Selnica ob Dravi",
						Subdivision: null,
					},
					{
						StateCode: "109",
						Name: "Semič",
						Subdivision: null,
					},
					{
						StateCode: "110",
						Name: "Sevnica",
						Subdivision: null,
					},
					{
						StateCode: "111",
						Name: "Sežana",
						Subdivision: null,
					},
					{
						StateCode: "112",
						Name: "Slovenj Gradec",
						Subdivision: null,
					},
					{
						StateCode: "113",
						Name: "Slovenska Bistrica",
						Subdivision: null,
					},
					{
						StateCode: "114",
						Name: "Slovenske Konjice",
						Subdivision: null,
					},
					{
						StateCode: "179",
						Name: "Sodražica",
						Subdivision: null,
					},
					{
						StateCode: "180",
						Name: "Solčava",
						Subdivision: null,
					},
					{
						StateCode: "202",
						Name: "Središče ob Dravi",
						Subdivision: null,
					},
					{
						StateCode: "115",
						Name: "Starše",
						Subdivision: null,
					},
					{
						StateCode: "203",
						Name: "Straža",
						Subdivision: null,
					},
					{
						StateCode: "181",
						Name: "Sveta Ana",
						Subdivision: null,
					},
					{
						StateCode: "204",
						Name: "Sveta Trojica v Slovenskih Goricah",
						Subdivision: null,
					},
					{
						StateCode: "182",
						Name: "Sveti Andraž v Slovenskih Goricah",
						Subdivision: null,
					},
					{
						StateCode: "116",
						Name: "Sveti Jurij",
						Subdivision: null,
					},
					{
						StateCode: "210",
						Name: "Sveti Jurij v Slovenskih Goricah",
						Subdivision: null,
					},
					{
						StateCode: "205",
						Name: "Sveti Tomaž",
						Subdivision: null,
					},
					{
						StateCode: "184",
						Name: "Tabor",
						Subdivision: null,
					},
					{
						StateCode: "010",
						Name: "Tišina",
						Subdivision: null,
					},
					{
						StateCode: "128",
						Name: "Tolmin",
						Subdivision: null,
					},
					{
						StateCode: "129",
						Name: "Trbovlje",
						Subdivision: null,
					},
					{
						StateCode: "130",
						Name: "Trebnje",
						Subdivision: null,
					},
					{
						StateCode: "185",
						Name: "Trnovska Vas",
						Subdivision: null,
					},
					{
						StateCode: "186",
						Name: "Trzin",
						Subdivision: null,
					},
					{
						StateCode: "131",
						Name: "Tržič",
						Subdivision: null,
					},
					{
						StateCode: "132",
						Name: "Turnišče",
						Subdivision: null,
					},
					{
						StateCode: "133",
						Name: "Velenje",
						Subdivision: null,
					},
					{
						StateCode: "187",
						Name: "Velika Polana",
						Subdivision: null,
					},
					{
						StateCode: "134",
						Name: "Velike Lašče",
						Subdivision: null,
					},
					{
						StateCode: "188",
						Name: "Veržej",
						Subdivision: null,
					},
					{
						StateCode: "135",
						Name: "Videm",
						Subdivision: null,
					},
					{
						StateCode: "136",
						Name: "Vipava",
						Subdivision: null,
					},
					{
						StateCode: "137",
						Name: "Vitanje",
						Subdivision: null,
					},
					{
						StateCode: "138",
						Name: "Vodice",
						Subdivision: null,
					},
					{
						StateCode: "139",
						Name: "Vojnik",
						Subdivision: null,
					},
					{
						StateCode: "189",
						Name: "Vransko",
						Subdivision: null,
					},
					{
						StateCode: "140",
						Name: "Vrhnika",
						Subdivision: null,
					},
					{
						StateCode: "141",
						Name: "Vuzenica",
						Subdivision: null,
					},
					{
						StateCode: "142",
						Name: "Zagorje ob Savi",
						Subdivision: null,
					},
					{
						StateCode: "143",
						Name: "Zavrč",
						Subdivision: null,
					},
					{
						StateCode: "144",
						Name: "Zreče",
						Subdivision: null,
					},
					{
						StateCode: "015",
						Name: "Črenšovci",
						Subdivision: null,
					},
					{
						StateCode: "016",
						Name: "Črna na Koroškem",
						Subdivision: null,
					},
					{
						StateCode: "017",
						Name: "Črnomelj",
						Subdivision: null,
					},
					{
						StateCode: "033",
						Name: "Šalovci",
						Subdivision: null,
					},
					{
						StateCode: "183",
						Name: "Šempeter–Vrtojba",
						Subdivision: null,
					},
					{
						StateCode: "118",
						Name: "Šentilj",
						Subdivision: null,
					},
					{
						StateCode: "119",
						Name: "Šentjernej",
						Subdivision: null,
					},
					{
						StateCode: "120",
						Name: "Šentjur",
						Subdivision: null,
					},
					{
						StateCode: "211",
						Name: "Šentrupert",
						Subdivision: null,
					},
					{
						StateCode: "117",
						Name: "Šenčur",
						Subdivision: null,
					},
					{
						StateCode: "121",
						Name: "Škocjan",
						Subdivision: null,
					},
					{
						StateCode: "122",
						Name: "Škofja Loka",
						Subdivision: null,
					},
					{
						StateCode: "123",
						Name: "Škofljica",
						Subdivision: null,
					},
					{
						StateCode: "124",
						Name: "Šmarje pri Jelšah",
						Subdivision: null,
					},
					{
						StateCode: "206",
						Name: "Šmarješke Toplice",
						Subdivision: null,
					},
					{
						StateCode: "125",
						Name: "Šmartno ob Paki",
						Subdivision: null,
					},
					{
						StateCode: "194",
						Name: "Šmartno pri Litiji",
						Subdivision: null,
					},
					{
						StateCode: "126",
						Name: "Šoštanj",
						Subdivision: null,
					},
					{
						StateCode: "127",
						Name: "Štore",
						Subdivision: null,
					},
					{
						StateCode: "190",
						Name: "Žalec",
						Subdivision: null,
					},
					{
						StateCode: "146",
						Name: "Železniki",
						Subdivision: null,
					},
					{
						StateCode: "191",
						Name: "Žetale",
						Subdivision: null,
					},
					{
						StateCode: "147",
						Name: "Žiri",
						Subdivision: null,
					},
					{
						StateCode: "192",
						Name: "Žirovnica",
						Subdivision: null,
					},
					{
						StateCode: "193",
						Name: "Žužemberk",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SB",
				ThreeDigit: "SLB",
				Name: "Solomon Islands",
				Capital: "Honiara",
				Region: "Oceania",
				Subregion: "Melanesia",
				States: [
					{
						StateCode: "CT",
						Name: "Capital Territory",
						Subdivision: null,
					},
					{
						StateCode: "CE",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "CH",
						Name: "Choiseul",
						Subdivision: null,
					},
					{
						StateCode: "GU",
						Name: "Guadalcanal",
						Subdivision: null,
					},
					{
						StateCode: "IS",
						Name: "Isabel",
						Subdivision: null,
					},
					{
						StateCode: "MK",
						Name: "Makira-Ulawa",
						Subdivision: null,
					},
					{
						StateCode: "ML",
						Name: "Malaita",
						Subdivision: null,
					},
					{
						StateCode: "RB",
						Name: "Rennell and Bellona",
						Subdivision: null,
					},
					{
						StateCode: "TE",
						Name: "Temotu",
						Subdivision: null,
					},
					{
						StateCode: "WE",
						Name: "Western",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SO",
				ThreeDigit: "SOM",
				Name: "Somalia",
				Capital: "Mogadishu",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "AW",
						Name: "Awdal",
						Subdivision: null,
					},
					{
						StateCode: "BK",
						Name: "Bakool",
						Subdivision: null,
					},
					{
						StateCode: "BN",
						Name: "Banaadir",
						Subdivision: null,
					},
					{
						StateCode: "BR",
						Name: "Bari",
						Subdivision: null,
					},
					{
						StateCode: "BY",
						Name: "Bay",
						Subdivision: null,
					},
					{
						StateCode: "GA",
						Name: "Galguduud",
						Subdivision: null,
					},
					{
						StateCode: "GE",
						Name: "Gedo",
						Subdivision: null,
					},
					{
						StateCode: "HI",
						Name: "Hiiraan",
						Subdivision: null,
					},
					{
						StateCode: "JD",
						Name: "Jubbada Dhexe",
						Subdivision: null,
					},
					{
						StateCode: "JH",
						Name: "Jubbada Hoose",
						Subdivision: null,
					},
					{
						StateCode: "MU",
						Name: "Mudug",
						Subdivision: null,
					},
					{
						StateCode: "NU",
						Name: "Nugaal",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Sanaag",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Shabeellaha Dhexe",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Shabeellaha Hoose",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Sool",
						Subdivision: null,
					},
					{
						StateCode: "TO",
						Name: "Togdheer",
						Subdivision: null,
					},
					{
						StateCode: "WO",
						Name: "Woqooyi Galbeed",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ZA",
				ThreeDigit: "ZAF",
				Name: "South Africa",
				Capital: "Pretoria",
				Region: "Africa",
				Subregion: "Southern Africa",
				States: [
					{
						StateCode: "EC",
						Name: "Eastern Cape",
						Subdivision: null,
					},
					{
						StateCode: "FS",
						Name: "Free State",
						Subdivision: null,
					},
					{
						StateCode: "GT",
						Name: "Gauteng",
						Subdivision: null,
					},
					{
						StateCode: "NL",
						Name: "KwaZulu-Natal",
						Subdivision: null,
					},
					{
						StateCode: "LP",
						Name: "Limpopo",
						Subdivision: null,
					},
					{
						StateCode: "MP",
						Name: "Mpumalanga",
						Subdivision: null,
					},
					{
						StateCode: "NW",
						Name: "North West",
						Subdivision: null,
					},
					{
						StateCode: "NC",
						Name: "Northern Cape",
						Subdivision: null,
					},
					{
						StateCode: "WC",
						Name: "Western Cape",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GS",
				ThreeDigit: "SGS",
				Name: "South Georgia",
				Capital: "King Edward Point",
				Region: "Americas",
				Subregion: "South America",
				States: [],
			},
			{
				TwoDigit: "KR",
				ThreeDigit: "KOR",
				Name: "South Korea",
				Capital: "Seoul",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [
					{
						StateCode: "26",
						Name: "Busan-gwangyeoksi",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Chungcheongbuk-do",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Chungcheongnam-do",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Daegu-gwangyeoksi",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Daejeon-gwangyeoksi",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Gangwon-do",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Gwangju-gwangyeoksi",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Gyeonggi-do",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Gyeongsangbuk-do",
						Subdivision: null,
					},
					{
						StateCode: "48",
						Name: "Gyeongsangnam-do",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Incheon-gwangyeoksi",
						Subdivision: null,
					},
					{
						StateCode: "49",
						Name: "Jeju-teukbyeoljachido",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Jeollabuk-do",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Jeollanam-do",
						Subdivision: null,
					},
					{
						StateCode: "50",
						Name: "Sejong",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Seoul-teukbyeolsi",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Ulsan-gwangyeoksi",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SS",
				ThreeDigit: "SSD",
				Name: "South Sudan",
				Capital: "Juba",
				Region: "Africa",
				Subregion: "Middle Africa",
				States: [
					{
						StateCode: "EC",
						Name: "Central Equatoria",
						Subdivision: null,
					},
					{
						StateCode: "EE",
						Name: "Eastern Equatoria",
						Subdivision: null,
					},
					{
						StateCode: "JG",
						Name: "Jonglei",
						Subdivision: null,
					},
					{
						StateCode: "LK",
						Name: "Lakes",
						Subdivision: null,
					},
					{
						StateCode: "BN",
						Name: "Northern Bahr el Ghazal",
						Subdivision: null,
					},
					{
						StateCode: "UY",
						Name: "Unity",
						Subdivision: null,
					},
					{
						StateCode: "NU",
						Name: "Upper Nile",
						Subdivision: null,
					},
					{
						StateCode: "WR",
						Name: "Warrap",
						Subdivision: null,
					},
					{
						StateCode: "BW",
						Name: "Western Bahr el Ghazal",
						Subdivision: null,
					},
					{
						StateCode: "EW",
						Name: "Western Equatoria",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ES",
				ThreeDigit: "ESP",
				Name: "Spain",
				Capital: "Madrid",
				Region: "Europe",
				Subregion: "Southern Europe",
				States: [
					{
						StateCode: "C",
						Name: "A Coruña",
						Subdivision: "Province",
					},
					{
						StateCode: "AB",
						Name: "Albacete",
						Subdivision: "Province",
					},
					{
						StateCode: "A",
						Name: "Alicante",
						Subdivision: "Province",
					},
					{
						StateCode: "AL",
						Name: "Almería",
						Subdivision: "Province",
					},
					{
						StateCode: "O",
						Name: "Asturias",
						Subdivision: "Province",
					},
					{
						StateCode: "BA",
						Name: "Badajoz",
						Subdivision: "Province",
					},
					{
						StateCode: "PM",
						Name: "Balears",
						Subdivision: "Province",
					},
					{
						StateCode: "B",
						Name: "Barcelona",
						Subdivision: "Province",
					},
					{
						StateCode: "BU",
						Name: "Burgos",
						Subdivision: "Province",
					},
					{
						StateCode: "S",
						Name: "Cantabria",
						Subdivision: "Province",
					},
					{
						StateCode: "CS",
						Name: "Castellón",
						Subdivision: "Province",
					},
					{
						StateCode: "CR",
						Name: "Ciudad Real",
						Subdivision: "Province",
					},
					{
						StateCode: "CU",
						Name: "Cuenca",
						Subdivision: "Province",
					},
					{
						StateCode: "CC",
						Name: "Cáceres",
						Subdivision: "Province",
					},
					{
						StateCode: "CA",
						Name: "Cádiz",
						Subdivision: "Province",
					},
					{
						StateCode: "CO",
						Name: "Córdoba",
						Subdivision: "Province",
					},
					{
						StateCode: "GI",
						Name: "Girona",
						Subdivision: "Province",
					},
					{
						StateCode: "GR",
						Name: "Granada",
						Subdivision: "Province",
					},
					{
						StateCode: "GU",
						Name: "Guadalajara",
						Subdivision: "Province",
					},
					{
						StateCode: "SS",
						Name: "Guipúzcoa",
						Subdivision: "Province",
					},
					{
						StateCode: "H",
						Name: "Huelva",
						Subdivision: "Province",
					},
					{
						StateCode: "HU",
						Name: "Huesca",
						Subdivision: "Province",
					},
					{
						StateCode: "J",
						Name: "Jaén",
						Subdivision: "Province",
					},
					{
						StateCode: "LO",
						Name: "La Rioja",
						Subdivision: "Province",
					},
					{
						StateCode: "GC",
						Name: "Las Palmas",
						Subdivision: "Province",
					},
					{
						StateCode: "LE",
						Name: "León",
						Subdivision: "Province",
					},
					{
						StateCode: "L",
						Name: "Lleida",
						Subdivision: "Province",
					},
					{
						StateCode: "LU",
						Name: "Lugo",
						Subdivision: "Province",
					},
					{
						StateCode: "M",
						Name: "Madrid",
						Subdivision: "Province",
					},
					{
						StateCode: "MU",
						Name: "Murcia",
						Subdivision: "Province",
					},
					{
						StateCode: "MA",
						Name: "Málaga",
						Subdivision: "Province",
					},
					{
						StateCode: "NA",
						Name: "Navarra",
						Subdivision: "Province",
					},
					{
						StateCode: "OR",
						Name: "Ourense",
						Subdivision: "Province",
					},
					{
						StateCode: "P",
						Name: "Palencia",
						Subdivision: "Province",
					},
					{
						StateCode: "PO",
						Name: "Pontevedra",
						Subdivision: "Province",
					},
					{
						StateCode: "SA",
						Name: "Salamanca",
						Subdivision: "Province",
					},
					{
						StateCode: "TF",
						Name: "Santa Cruz de Tenerife",
						Subdivision: "Province",
					},
					{
						StateCode: "SG",
						Name: "Segovia",
						Subdivision: "Province",
					},
					{
						StateCode: "SE",
						Name: "Sevilla",
						Subdivision: "Province",
					},
					{
						StateCode: "SO",
						Name: "Soria",
						Subdivision: "Province",
					},
					{
						StateCode: "T",
						Name: "Tarragona",
						Subdivision: "Province",
					},
					{
						StateCode: "TE",
						Name: "Teruel",
						Subdivision: "Province",
					},
					{
						StateCode: "TO",
						Name: "Toledo",
						Subdivision: "Province",
					},
					{
						StateCode: "V",
						Name: "Valencia",
						Subdivision: "Province",
					},
					{
						StateCode: "VA",
						Name: "Valladolid",
						Subdivision: "Province",
					},
					{
						StateCode: "BI",
						Name: "Vizcaya",
						Subdivision: "Province",
					},
					{
						StateCode: "ZA",
						Name: "Zamora",
						Subdivision: "Province",
					},
					{
						StateCode: "Z",
						Name: "Zaragoza",
						Subdivision: "Province",
					},
					{
						StateCode: "VI",
						Name: "Álava",
						Subdivision: "Province",
					},
					{
						StateCode: "AV",
						Name: "Ávila",
						Subdivision: "Province",
					},
					{
						StateCode: "CE",
						Name: "Ceuta",
						Subdivision: "autonomous city in North Africa",
					},
					{
						StateCode: "ML",
						Name: "Melilla",
						Subdivision: "autonomous city in North Africa",
					},
					{
						StateCode: "AN",
						Name: "Andalucía",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "AR",
						Name: "Aragón",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "AS",
						Name: "Asturias, Principado de",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "CN",
						Name: "Canarias",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "CB",
						Name: "Cantabria",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "CL",
						Name: "Castilla y León",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "CM",
						Name: "Castilla-La Mancha",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "CT",
						Name: "Catalunya",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "EX",
						Name: "Extremadura",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "GA",
						Name: "Galicia",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "IB",
						Name: "Illes Balears",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "RI",
						Name: "La Rioja",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "MD",
						Name: "Madrid, Comunidad de",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "MC",
						Name: "Murcia, Región de",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "NC",
						Name: "Navarra, Comunidad Foral de",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "PV",
						Name: "País Vasco",
						Subdivision: "autonomous community",
					},
					{
						StateCode: "VC",
						Name: "Valenciana, Comunidad",
						Subdivision: "autonomous community",
					},
				],
			},
			{
				TwoDigit: "LK",
				ThreeDigit: "LKA",
				Name: "Sri Lanka",
				Capital: "Colombo",
				Region: "Asia",
				Subregion: "Southern Asia",
				States: [
					{
						StateCode: "2",
						Name: "Central Province",
						Subdivision: null,
					},
					{
						StateCode: "5",
						Name: "Eastern Province",
						Subdivision: null,
					},
					{
						StateCode: "7",
						Name: "North Central Province",
						Subdivision: null,
					},
					{
						StateCode: "6",
						Name: "North Western Province",
						Subdivision: null,
					},
					{
						StateCode: "4",
						Name: "Northern Province",
						Subdivision: null,
					},
					{
						StateCode: "9",
						Name: "Sabaragamuwa Province",
						Subdivision: null,
					},
					{
						StateCode: "3",
						Name: "Southern Province",
						Subdivision: null,
					},
					{
						StateCode: "8",
						Name: "Uva Province",
						Subdivision: null,
					},
					{
						StateCode: "1",
						Name: "Western Province",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SD",
				ThreeDigit: "SDN",
				Name: "Sudan",
				Capital: "Khartoum",
				Region: "Africa",
				Subregion: "Northern Africa",
				States: [
					{
						StateCode: "RS",
						Name: "Al Baḩr al Aḩmar",
						Subdivision: null,
					},
					{
						StateCode: "GZ",
						Name: "Al Jazīrah",
						Subdivision: null,
					},
					{
						StateCode: "KH",
						Name: "Al Kharţūm",
						Subdivision: null,
					},
					{
						StateCode: "GD",
						Name: "Al Qaḑārif",
						Subdivision: null,
					},
					{
						StateCode: "NR",
						Name: "An Nīl",
						Subdivision: null,
					},
					{
						StateCode: "NW",
						Name: "An Nīl al Abyaḑ",
						Subdivision: null,
					},
					{
						StateCode: "NB",
						Name: "An Nīl al Azraq",
						Subdivision: null,
					},
					{
						StateCode: "NO",
						Name: "Ash Shamālīyah",
						Subdivision: null,
					},
					{
						StateCode: "DW",
						Name: "Gharb Dārfūr",
						Subdivision: null,
					},
					{
						StateCode: "DS",
						Name: "Janūb Dārfūr",
						Subdivision: null,
					},
					{
						StateCode: "KS",
						Name: "Janūb Kurdufān",
						Subdivision: null,
					},
					{
						StateCode: "KA",
						Name: "Kassalā",
						Subdivision: null,
					},
					{
						StateCode: "DN",
						Name: "Shamāl Dārfūr",
						Subdivision: null,
					},
					{
						StateCode: "KN",
						Name: "Shamāl Kurdufān",
						Subdivision: null,
					},
					{
						StateCode: "DE",
						Name: "Sharq Dārfūr",
						Subdivision: null,
					},
					{
						StateCode: "SI",
						Name: "Sinnār",
						Subdivision: null,
					},
					{
						StateCode: "DC",
						Name: "Zalingei",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SR",
				ThreeDigit: "SUR",
				Name: "Suriname",
				Capital: "Paramaribo",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "BR",
						Name: "Brokopondo",
						Subdivision: null,
					},
					{
						StateCode: "CM",
						Name: "Commewijne",
						Subdivision: null,
					},
					{
						StateCode: "CR",
						Name: "Coronie",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Marowijne",
						Subdivision: null,
					},
					{
						StateCode: "NI",
						Name: "Nickerie",
						Subdivision: null,
					},
					{
						StateCode: "PR",
						Name: "Para",
						Subdivision: null,
					},
					{
						StateCode: "PM",
						Name: "Paramaribo",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Saramacca",
						Subdivision: null,
					},
					{
						StateCode: "SI",
						Name: "Sipaliwini",
						Subdivision: null,
					},
					{
						StateCode: "WA",
						Name: "Wanica",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SJ",
				ThreeDigit: "SJM",
				Name: "Svalbard and Jan Mayen",
				Capital: "Longyearbyen",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [],
			},
			{
				TwoDigit: "SZ",
				ThreeDigit: "SWZ",
				Name: "Swaziland",
				Capital: "Lobamba",
				Region: "Africa",
				Subregion: "Southern Africa",
				States: [
					{
						StateCode: "HH",
						Name: "Hhohho",
						Subdivision: null,
					},
					{
						StateCode: "LU",
						Name: "Lubombo",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Manzini",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Shiselweni",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SE",
				ThreeDigit: "SWE",
				Name: "Sweden",
				Capital: "Stockholm",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "K",
						Name: "Blekinge län",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Dalarnas län",
						Subdivision: null,
					},
					{
						StateCode: "I",
						Name: "Gotlands län",
						Subdivision: null,
					},
					{
						StateCode: "X",
						Name: "Gävleborgs län",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Hallands län",
						Subdivision: null,
					},
					{
						StateCode: "Z",
						Name: "Jämtlands län",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Jönköpings län",
						Subdivision: null,
					},
					{
						StateCode: "H",
						Name: "Kalmar län",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Kronobergs län",
						Subdivision: null,
					},
					{
						StateCode: "BD",
						Name: "Norrbottens län",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Skåne län",
						Subdivision: null,
					},
					{
						StateCode: "AB",
						Name: "Stockholms län",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Södermanlands län",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Uppsala län",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Värmlands län",
						Subdivision: null,
					},
					{
						StateCode: "AC",
						Name: "Västerbottens län",
						Subdivision: null,
					},
					{
						StateCode: "Y",
						Name: "Västernorrlands län",
						Subdivision: null,
					},
					{
						StateCode: "U",
						Name: "Västmanlands län",
						Subdivision: null,
					},
					{
						StateCode: "O",
						Name: "Västra Götalands län",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Örebro län",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Östergötlands län",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "CH",
				ThreeDigit: "CHE",
				Name: "Switzerland",
				Capital: "Bern",
				Region: "Europe",
				Subregion: "Western Europe",
				States: [
					{
						StateCode: "AG",
						Name: "Aargau",
						Subdivision: null,
					},
					{
						StateCode: "AR",
						Name: "Appenzell Ausserrhoden",
						Subdivision: null,
					},
					{
						StateCode: "AI",
						Name: "Appenzell Innerrhoden",
						Subdivision: null,
					},
					{
						StateCode: "BL",
						Name: "Basel-Landschaft",
						Subdivision: null,
					},
					{
						StateCode: "BS",
						Name: "Basel-Stadt",
						Subdivision: null,
					},
					{
						StateCode: "BE",
						Name: "Bern",
						Subdivision: null,
					},
					{
						StateCode: "FR",
						Name: "Fribourg",
						Subdivision: null,
					},
					{
						StateCode: "GE",
						Name: "Genève",
						Subdivision: null,
					},
					{
						StateCode: "GL",
						Name: "Glarus",
						Subdivision: null,
					},
					{
						StateCode: "GR",
						Name: "Graubünden",
						Subdivision: null,
					},
					{
						StateCode: "JU",
						Name: "Jura",
						Subdivision: null,
					},
					{
						StateCode: "LU",
						Name: "Luzern",
						Subdivision: null,
					},
					{
						StateCode: "NE",
						Name: "Neuchâtel",
						Subdivision: null,
					},
					{
						StateCode: "NW",
						Name: "Nidwalden",
						Subdivision: null,
					},
					{
						StateCode: "OW",
						Name: "Obwalden",
						Subdivision: null,
					},
					{
						StateCode: "SG",
						Name: "Sankt Gallen",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Schaffhausen",
						Subdivision: null,
					},
					{
						StateCode: "SZ",
						Name: "Schwyz",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Solothurn",
						Subdivision: null,
					},
					{
						StateCode: "TG",
						Name: "Thurgau",
						Subdivision: null,
					},
					{
						StateCode: "TI",
						Name: "Ticino",
						Subdivision: null,
					},
					{
						StateCode: "UR",
						Name: "Uri",
						Subdivision: null,
					},
					{
						StateCode: "VS",
						Name: "Valais",
						Subdivision: null,
					},
					{
						StateCode: "VD",
						Name: "Vaud",
						Subdivision: null,
					},
					{
						StateCode: "ZG",
						Name: "Zug",
						Subdivision: null,
					},
					{
						StateCode: "ZH",
						Name: "Zürich",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "SY",
				ThreeDigit: "SYR",
				Name: "Syria",
				Capital: "Damascus",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "LA",
						Name: "Al Lādhiqīyah",
						Subdivision: null,
					},
					{
						StateCode: "QU",
						Name: "Al Qunayţirah",
						Subdivision: null,
					},
					{
						StateCode: "HA",
						Name: "Al Ḩasakah",
						Subdivision: null,
					},
					{
						StateCode: "RA",
						Name: "Ar Raqqah",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "As Suwaydā'",
						Subdivision: null,
					},
					{
						StateCode: "DR",
						Name: "Darٰā",
						Subdivision: null,
					},
					{
						StateCode: "DY",
						Name: "Dayr az Zawr",
						Subdivision: null,
					},
					{
						StateCode: "DI",
						Name: "Dimashq",
						Subdivision: null,
					},
					{
						StateCode: "ID",
						Name: "Idlib",
						Subdivision: null,
					},
					{
						StateCode: "RD",
						Name: "Rīf Dimashq",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Ţarţūs",
						Subdivision: null,
					},
					{
						StateCode: "HL",
						Name: "Ḩalab",
						Subdivision: null,
					},
					{
						StateCode: "HM",
						Name: "Ḩamāh",
						Subdivision: null,
					},
					{
						StateCode: "HI",
						Name: "Ḩimş",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TW",
				ThreeDigit: "TWN",
				Name: "Taiwan",
				Capital: "Taipei",
				Region: "Asia",
				Subregion: "Eastern Asia",
				States: [
					{
						StateCode: "CHA",
						Name: "Changhua",
						Subdivision: null,
					},
					{
						StateCode: "CYQ",
						Name: "Chiayi",
						Subdivision: null,
					},
					{
						StateCode: "CYI",
						Name: "Chiayi",
						Subdivision: null,
					},
					{
						StateCode: "HSZ",
						Name: "Hsinchu",
						Subdivision: null,
					},
					{
						StateCode: "HSQ",
						Name: "Hsinchu",
						Subdivision: null,
					},
					{
						StateCode: "HUA",
						Name: "Hualien",
						Subdivision: null,
					},
					{
						StateCode: "ILA",
						Name: "Ilan",
						Subdivision: null,
					},
					{
						StateCode: "KHQ",
						Name: "Kaohsiung",
						Subdivision: null,
					},
					{
						StateCode: "KHH",
						Name: "Kaohsiung",
						Subdivision: null,
					},
					{
						StateCode: "KEE",
						Name: "Keelung",
						Subdivision: null,
					},
					{
						StateCode: "MIA",
						Name: "Miaoli",
						Subdivision: null,
					},
					{
						StateCode: "NAN",
						Name: "Nantou",
						Subdivision: null,
					},
					{
						StateCode: "PEN",
						Name: "Penghu",
						Subdivision: null,
					},
					{
						StateCode: "PIF",
						Name: "Pingtung",
						Subdivision: null,
					},
					{
						StateCode: "TXG",
						Name: "Taichung",
						Subdivision: null,
					},
					{
						StateCode: "TXQ",
						Name: "Taichung",
						Subdivision: null,
					},
					{
						StateCode: "TNN",
						Name: "Tainan",
						Subdivision: null,
					},
					{
						StateCode: "TNQ",
						Name: "Tainan",
						Subdivision: null,
					},
					{
						StateCode: "TPE",
						Name: "Taipei",
						Subdivision: null,
					},
					{
						StateCode: "TPQ",
						Name: "Taipei",
						Subdivision: null,
					},
					{
						StateCode: "TTT",
						Name: "Taitung",
						Subdivision: null,
					},
					{
						StateCode: "TAO",
						Name: "Taoyuan",
						Subdivision: null,
					},
					{
						StateCode: "YUN",
						Name: "Yunlin",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TJ",
				ThreeDigit: "TJK",
				Name: "Tajikistan",
				Capital: "Dushanbe",
				Region: "Asia",
				Subregion: "Central Asia",
				States: [
					{
						StateCode: "DU",
						Name: "Dushanbe",
						Subdivision: null,
					},
					{
						StateCode: "KT",
						Name: "Khatlon",
						Subdivision: null,
					},
					{
						StateCode: "GB",
						Name: "Kŭhistoni Badakhshon",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "Sughd",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TZ",
				ThreeDigit: "TZA",
				Name: "Tanzania",
				Capital: "Dodoma",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "01",
						Name: "Arusha",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Dar es Salaam",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Dodoma",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Iringa",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Kagera",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Kaskazini Pemba",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Kaskazini Unguja",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Kigoma",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Kilimanjaro",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Kusini Pemba",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Kusini Unguja",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Lindi",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Manyara",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Mara",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Mbeya",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Mjini Magharibi",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Morogoro",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Mtwara",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Mwanza",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Pwani",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Rukwa",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Ruvuma",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Shinyanga",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Singida",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Tabora",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Tanga",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TH",
				ThreeDigit: "THA",
				Name: "Thailand",
				Capital: "Bangkok",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "37",
						Name: "Amnat Charoen",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Ang Thong",
						Subdivision: null,
					},
					{
						StateCode: "38",
						Name: "Bueng Kan",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Buri Ram",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Chachoengsao",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Chai Nat",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Chaiyaphum",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Chanthaburi",
						Subdivision: null,
					},
					{
						StateCode: "50",
						Name: "Chiang Mai",
						Subdivision: null,
					},
					{
						StateCode: "57",
						Name: "Chiang Rai",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Chon Buri",
						Subdivision: null,
					},
					{
						StateCode: "86",
						Name: "Chumphon",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Kalasin",
						Subdivision: null,
					},
					{
						StateCode: "62",
						Name: "Kamphaeng Phet",
						Subdivision: null,
					},
					{
						StateCode: "71",
						Name: "Kanchanaburi",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Khon Kaen",
						Subdivision: null,
					},
					{
						StateCode: "81",
						Name: "Krabi",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Krung Thep Maha Nakhon",
						Subdivision: null,
					},
					{
						StateCode: "52",
						Name: "Lampang",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "Lamphun",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Loei",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Lop Buri",
						Subdivision: null,
					},
					{
						StateCode: "58",
						Name: "Mae Hong Son",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Maha Sarakham",
						Subdivision: null,
					},
					{
						StateCode: "49",
						Name: "Mukdahan",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Nakhon Nayok",
						Subdivision: null,
					},
					{
						StateCode: "73",
						Name: "Nakhon Pathom",
						Subdivision: null,
					},
					{
						StateCode: "48",
						Name: "Nakhon Phanom",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Nakhon Ratchasima",
						Subdivision: null,
					},
					{
						StateCode: "60",
						Name: "Nakhon Sawan",
						Subdivision: null,
					},
					{
						StateCode: "80",
						Name: "Nakhon Si Thammarat",
						Subdivision: null,
					},
					{
						StateCode: "55",
						Name: "Nan",
						Subdivision: null,
					},
					{
						StateCode: "96",
						Name: "Narathiwat",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Nong Bua Lam Phu",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Nong Khai",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Nonthaburi",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Pathum Thani",
						Subdivision: null,
					},
					{
						StateCode: "94",
						Name: "Pattani",
						Subdivision: null,
					},
					{
						StateCode: "82",
						Name: "Phangnga",
						Subdivision: null,
					},
					{
						StateCode: "93",
						Name: "Phatthalung",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Phatthaya",
						Subdivision: null,
					},
					{
						StateCode: "56",
						Name: "Phayao",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Phetchabun",
						Subdivision: null,
					},
					{
						StateCode: "76",
						Name: "Phetchaburi",
						Subdivision: null,
					},
					{
						StateCode: "66",
						Name: "Phichit",
						Subdivision: null,
					},
					{
						StateCode: "65",
						Name: "Phitsanulok",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Phra Nakhon Si Ayutthaya",
						Subdivision: null,
					},
					{
						StateCode: "54",
						Name: "Phrae",
						Subdivision: null,
					},
					{
						StateCode: "83",
						Name: "Phuket",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Prachin Buri",
						Subdivision: null,
					},
					{
						StateCode: "77",
						Name: "Prachuap Khiri Khan",
						Subdivision: null,
					},
					{
						StateCode: "85",
						Name: "Ranong",
						Subdivision: null,
					},
					{
						StateCode: "70",
						Name: "Ratchaburi",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Rayong",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Roi Et",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Sa Kaeo",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Sakon Nakhon",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Samut Prakan",
						Subdivision: null,
					},
					{
						StateCode: "74",
						Name: "Samut Sakhon",
						Subdivision: null,
					},
					{
						StateCode: "75",
						Name: "Samut Songkhram",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Saraburi",
						Subdivision: null,
					},
					{
						StateCode: "91",
						Name: "Satun",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Si Sa Ket",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Sing Buri",
						Subdivision: null,
					},
					{
						StateCode: "90",
						Name: "Songkhla",
						Subdivision: null,
					},
					{
						StateCode: "64",
						Name: "Sukhothai",
						Subdivision: null,
					},
					{
						StateCode: "72",
						Name: "Suphan Buri",
						Subdivision: null,
					},
					{
						StateCode: "84",
						Name: "Surat Thani",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Surin",
						Subdivision: null,
					},
					{
						StateCode: "63",
						Name: "Tak",
						Subdivision: null,
					},
					{
						StateCode: "92",
						Name: "Trang",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Trat",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Ubon Ratchathani",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Udon Thani",
						Subdivision: null,
					},
					{
						StateCode: "61",
						Name: "Uthai Thani",
						Subdivision: null,
					},
					{
						StateCode: "53",
						Name: "Uttaradit",
						Subdivision: null,
					},
					{
						StateCode: "95",
						Name: "Yala",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Yasothon",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TL",
				ThreeDigit: "TLS",
				Name: "East Timor",
				Capital: "Dili",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "AL",
						Name: "Aileu",
						Subdivision: null,
					},
					{
						StateCode: "AN",
						Name: "Ainaro",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Baucau",
						Subdivision: null,
					},
					{
						StateCode: "BO",
						Name: "Bobonaro",
						Subdivision: null,
					},
					{
						StateCode: "CO",
						Name: "Cova Lima",
						Subdivision: null,
					},
					{
						StateCode: "DI",
						Name: "Díli",
						Subdivision: null,
					},
					{
						StateCode: "ER",
						Name: "Ermera",
						Subdivision: null,
					},
					{
						StateCode: "LA",
						Name: "Lautem",
						Subdivision: null,
					},
					{
						StateCode: "LI",
						Name: "Liquiça",
						Subdivision: null,
					},
					{
						StateCode: "MT",
						Name: "Manatuto",
						Subdivision: null,
					},
					{
						StateCode: "MF",
						Name: "Manufahi",
						Subdivision: null,
					},
					{
						StateCode: "OE",
						Name: "Oecussi",
						Subdivision: null,
					},
					{
						StateCode: "VI",
						Name: "Viqueque",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TG",
				ThreeDigit: "TGO",
				Name: "Togo",
				Capital: "Lomé",
				Region: "Africa",
				Subregion: "Western Africa",
				States: [
					{
						StateCode: "C",
						Name: "Centre",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Kara",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Maritime",
						Subdivision: null,
					},
					{
						StateCode: "P",
						Name: "Plateaux",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Savannes",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TK",
				ThreeDigit: "TKL",
				Name: "Tokelau",
				Capital: "Fakaofo",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [],
			},
			{
				TwoDigit: "TO",
				ThreeDigit: "TON",
				Name: "Tonga",
				Capital: "Nuku'alofa",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [
					{
						StateCode: "01",
						Name: "'Eua",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Ha'apai",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Niuas",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Tongatapu",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Vava'u",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TT",
				ThreeDigit: "TTO",
				Name: "Trinidad and Tobago",
				Capital: "Port of Spain",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [
					{
						StateCode: "ARI",
						Name: "Arima",
						Subdivision: null,
					},
					{
						StateCode: "CHA",
						Name: "Chaguanas",
						Subdivision: null,
					},
					{
						StateCode: "CTT",
						Name: "Couva-Tabaquite-Talparo",
						Subdivision: null,
					},
					{
						StateCode: "DMN",
						Name: "Diego Martin",
						Subdivision: null,
					},
					{
						StateCode: "ETO",
						Name: "Eastern Tobago",
						Subdivision: null,
					},
					{
						StateCode: "PED",
						Name: "Penal-Debe",
						Subdivision: null,
					},
					{
						StateCode: "PTF",
						Name: "Point Fortin",
						Subdivision: null,
					},
					{
						StateCode: "POS",
						Name: "Port of Spain",
						Subdivision: null,
					},
					{
						StateCode: "PRT",
						Name: "Princes Town",
						Subdivision: null,
					},
					{
						StateCode: "RCM",
						Name: "Rio Claro-Mayaro",
						Subdivision: null,
					},
					{
						StateCode: "SFO",
						Name: "San Fernando",
						Subdivision: null,
					},
					{
						StateCode: "SJL",
						Name: "San Juan-Laventille",
						Subdivision: null,
					},
					{
						StateCode: "SGE",
						Name: "Sangre Grande",
						Subdivision: null,
					},
					{
						StateCode: "SIP",
						Name: "Siparia",
						Subdivision: null,
					},
					{
						StateCode: "TUP",
						Name: "Tunapuna-Piarco",
						Subdivision: null,
					},
					{
						StateCode: "WTO",
						Name: "Western Tobago",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TN",
				ThreeDigit: "TUN",
				Name: "Tunisia",
				Capital: "Tunis",
				Region: "Africa",
				Subregion: "Northern Africa",
				States: [
					{
						StateCode: "12",
						Name: "Ariana",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Ben Arous",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Bizerte",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Béja",
						Subdivision: null,
					},
					{
						StateCode: "81",
						Name: "Gabès",
						Subdivision: null,
					},
					{
						StateCode: "71",
						Name: "Gafsa",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Jendouba",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Kairouan",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Kasserine",
						Subdivision: null,
					},
					{
						StateCode: "73",
						Name: "Kebili",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "La Manouba",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Le Kef",
						Subdivision: null,
					},
					{
						StateCode: "53",
						Name: "Mahdia",
						Subdivision: null,
					},
					{
						StateCode: "82",
						Name: "Medenine",
						Subdivision: null,
					},
					{
						StateCode: "52",
						Name: "Monastir",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Nabeul",
						Subdivision: null,
					},
					{
						StateCode: "61",
						Name: "Sfax",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Sidi Bouzid",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Siliana",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "Sousse",
						Subdivision: null,
					},
					{
						StateCode: "83",
						Name: "Tataouine",
						Subdivision: null,
					},
					{
						StateCode: "72",
						Name: "Tozeur",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Tunis",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Zaghouan",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TR",
				ThreeDigit: "TUR",
				Name: "Turkey",
				Capital: "Ankara",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "01",
						Name: "Adana",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Adıyaman",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Afyonkarahisar",
						Subdivision: null,
					},
					{
						StateCode: "68",
						Name: "Aksaray",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Amasya",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Ankara",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Antalya",
						Subdivision: null,
					},
					{
						StateCode: "75",
						Name: "Ardahan",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Artvin",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Aydın",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Ağrı",
						Subdivision: null,
					},
					{
						StateCode: "10",
						Name: "Balıkesir",
						Subdivision: null,
					},
					{
						StateCode: "74",
						Name: "Bartın",
						Subdivision: null,
					},
					{
						StateCode: "72",
						Name: "Batman",
						Subdivision: null,
					},
					{
						StateCode: "69",
						Name: "Bayburt",
						Subdivision: null,
					},
					{
						StateCode: "11",
						Name: "Bilecik",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Bingöl",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Bitlis",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Bolu",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Burdur",
						Subdivision: null,
					},
					{
						StateCode: "16",
						Name: "Bursa",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Denizli",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Diyarbakır",
						Subdivision: null,
					},
					{
						StateCode: "81",
						Name: "Düzce",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Edirne",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Elazığ",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Erzincan",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Erzurum",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Eskişehir",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Gaziantep",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Giresun",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Gümüşhane",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Hakkâri",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Hatay",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Isparta",
						Subdivision: null,
					},
					{
						StateCode: "76",
						Name: "Iğdır",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Kahramanmaraş",
						Subdivision: null,
					},
					{
						StateCode: "78",
						Name: "Karabük",
						Subdivision: null,
					},
					{
						StateCode: "70",
						Name: "Karaman",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Kars",
						Subdivision: null,
					},
					{
						StateCode: "37",
						Name: "Kastamonu",
						Subdivision: null,
					},
					{
						StateCode: "38",
						Name: "Kayseri",
						Subdivision: null,
					},
					{
						StateCode: "79",
						Name: "Kilis",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Kocaeli",
						Subdivision: null,
					},
					{
						StateCode: "42",
						Name: "Konya",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Kütahya",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Kırklareli",
						Subdivision: null,
					},
					{
						StateCode: "71",
						Name: "Kırıkkale",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Kırşehir",
						Subdivision: null,
					},
					{
						StateCode: "44",
						Name: "Malatya",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Manisa",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Mardin",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Mersin",
						Subdivision: null,
					},
					{
						StateCode: "48",
						Name: "Muğla",
						Subdivision: null,
					},
					{
						StateCode: "49",
						Name: "Muş",
						Subdivision: null,
					},
					{
						StateCode: "50",
						Name: "Nevşehir",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "Niğde",
						Subdivision: null,
					},
					{
						StateCode: "52",
						Name: "Ordu",
						Subdivision: null,
					},
					{
						StateCode: "80",
						Name: "Osmaniye",
						Subdivision: null,
					},
					{
						StateCode: "53",
						Name: "Rize",
						Subdivision: null,
					},
					{
						StateCode: "54",
						Name: "Sakarya",
						Subdivision: null,
					},
					{
						StateCode: "55",
						Name: "Samsun",
						Subdivision: null,
					},
					{
						StateCode: "56",
						Name: "Siirt",
						Subdivision: null,
					},
					{
						StateCode: "57",
						Name: "Sinop",
						Subdivision: null,
					},
					{
						StateCode: "58",
						Name: "Sivas",
						Subdivision: null,
					},
					{
						StateCode: "59",
						Name: "Tekirdağ",
						Subdivision: null,
					},
					{
						StateCode: "60",
						Name: "Tokat",
						Subdivision: null,
					},
					{
						StateCode: "61",
						Name: "Trabzon",
						Subdivision: null,
					},
					{
						StateCode: "62",
						Name: "Tunceli",
						Subdivision: null,
					},
					{
						StateCode: "64",
						Name: "Uşak",
						Subdivision: null,
					},
					{
						StateCode: "65",
						Name: "Van",
						Subdivision: null,
					},
					{
						StateCode: "77",
						Name: "Yalova",
						Subdivision: null,
					},
					{
						StateCode: "66",
						Name: "Yozgat",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Zonguldak",
						Subdivision: null,
					},
					{
						StateCode: "17",
						Name: "Çanakkale",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Çankırı",
						Subdivision: null,
					},
					{
						StateCode: "19",
						Name: "Çorum",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "İstanbul",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "İzmir",
						Subdivision: null,
					},
					{
						StateCode: "63",
						Name: "Şanlıurfa",
						Subdivision: null,
					},
					{
						StateCode: "73",
						Name: "Şırnak",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TM",
				ThreeDigit: "TKM",
				Name: "Turkmenistan",
				Capital: "Ashgabat",
				Region: "Asia",
				Subregion: "Central Asia",
				States: [
					{
						StateCode: "A",
						Name: "Ahal",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Aşgabat",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "Balkan",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Daşoguz",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Lebap",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Mary",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "TC",
				ThreeDigit: "TCA",
				Name: "Turks and Caicos Islands",
				Capital: "Cockburn Town",
				Region: "Americas",
				Subregion: "Caribbean",
				States: [],
			},
			{
				TwoDigit: "TV",
				ThreeDigit: "TUV",
				Name: "Tuvalu",
				Capital: "Funafuti",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [
					{
						StateCode: "FUN",
						Name: "Funafuti",
						Subdivision: null,
					},
					{
						StateCode: "NMG",
						Name: "Nanumanga",
						Subdivision: null,
					},
					{
						StateCode: "NMA",
						Name: "Nanumea",
						Subdivision: null,
					},
					{
						StateCode: "NIT",
						Name: "Niutao",
						Subdivision: null,
					},
					{
						StateCode: "NUI",
						Name: "Nui",
						Subdivision: null,
					},
					{
						StateCode: "NKF",
						Name: "Nukufetau",
						Subdivision: null,
					},
					{
						StateCode: "NKL",
						Name: "Nukulaelae",
						Subdivision: null,
					},
					{
						StateCode: "VAI",
						Name: "Vaitupu",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "UG",
				ThreeDigit: "UGA",
				Name: "Uganda",
				Capital: "Kampala",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "C",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Eastern",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Northern",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Western",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "UA",
				ThreeDigit: "UKR",
				Name: "Ukraine",
				Capital: "Kiev",
				Region: "Europe",
				Subregion: "Eastern Europe",
				States: [
					{
						StateCode: "43",
						Name: "Avtonomna Respublika Krym",
						Subdivision: null,
					},
					{
						StateCode: "71",
						Name: "Cherkas'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "74",
						Name: "Chernihivs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "77",
						Name: "Chernivets'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "12",
						Name: "Dnipropetrovs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Donets'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Ivano-Frankivs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "63",
						Name: "Kharkivs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "65",
						Name: "Khersons'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "68",
						Name: "Khmel'nyts'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Kirovohrads'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Kyïv",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Kyïvs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "L'vivs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Luhans'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "48",
						Name: "Mykolaïvs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "Odes'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "53",
						Name: "Poltavs'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "56",
						Name: "Rivnens'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Sevastopol'",
						Subdivision: null,
					},
					{
						StateCode: "59",
						Name: "Sums'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "61",
						Name: "Ternopil's'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Vinnyts'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Volyns'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Zakarpats'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Zaporiz'ka Oblast'",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Zhytomyrs'ka Oblast'",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "AE",
				ThreeDigit: "ARE",
				Name: "United Arab Emirates",
				Capital: "Abu Dhabi",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "AJ",
						Name: "'Ajmān",
						Subdivision: null,
					},
					{
						StateCode: "AZ",
						Name: "Abū Z̧aby",
						Subdivision: null,
					},
					{
						StateCode: "FU",
						Name: "Al Fujayrah",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Ash Shāriqah",
						Subdivision: null,
					},
					{
						StateCode: "DU",
						Name: "Dubayy",
						Subdivision: null,
					},
					{
						StateCode: "RK",
						Name: "Ra's al Khaymah",
						Subdivision: null,
					},
					{
						StateCode: "UQ",
						Name: "Umm al Qaywayn",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "GB",
				ThreeDigit: "GBR",
				Name: "United Kingdom",
				Capital: "London",
				Region: "Europe",
				Subregion: "Northern Europe",
				States: [
					{
						StateCode: "BDG",
						Name: "Barking and Dagenham",
						Subdivision: "London borough",
					},
					{
						StateCode: "BNE",
						Name: "Barnet",
						Subdivision: "London borough",
					},
					{
						StateCode: "BEX",
						Name: "Bexley",
						Subdivision: "London borough",
					},
					{
						StateCode: "BEN",
						Name: "Brent",
						Subdivision: "London borough",
					},
					{
						StateCode: "BRY",
						Name: "Bromley",
						Subdivision: "London borough",
					},
					{
						StateCode: "CMD",
						Name: "Camden",
						Subdivision: "London borough",
					},
					{
						StateCode: "CRY",
						Name: "Croydon",
						Subdivision: "London borough",
					},
					{
						StateCode: "EAL",
						Name: "Ealing",
						Subdivision: "London borough",
					},
					{
						StateCode: "ENF",
						Name: "Enfield",
						Subdivision: "London borough",
					},
					{
						StateCode: "GRE",
						Name: "Greenwich",
						Subdivision: "London borough",
					},
					{
						StateCode: "HCK",
						Name: "Hackney",
						Subdivision: "London borough",
					},
					{
						StateCode: "HMF",
						Name: "Hammersmith and Fulham",
						Subdivision: "London borough",
					},
					{
						StateCode: "HRY",
						Name: "Haringey",
						Subdivision: "London borough",
					},
					{
						StateCode: "HRW",
						Name: "Harrow",
						Subdivision: "London borough",
					},
					{
						StateCode: "HAV",
						Name: "Havering",
						Subdivision: "London borough",
					},
					{
						StateCode: "HIL",
						Name: "Hillingdon",
						Subdivision: "London borough",
					},
					{
						StateCode: "HNS",
						Name: "Hounslow",
						Subdivision: "London borough",
					},
					{
						StateCode: "ISL",
						Name: "Islington",
						Subdivision: "London borough",
					},
					{
						StateCode: "KEC",
						Name: "Kensington and Chelsea",
						Subdivision: "London borough",
					},
					{
						StateCode: "KTT",
						Name: "Kingston upon Thames",
						Subdivision: "London borough",
					},
					{
						StateCode: "LBH",
						Name: "Lambeth",
						Subdivision: "London borough",
					},
					{
						StateCode: "LEW",
						Name: "Lewisham",
						Subdivision: "London borough",
					},
					{
						StateCode: "MRT",
						Name: "Merton",
						Subdivision: "London borough",
					},
					{
						StateCode: "NWM",
						Name: "Newham",
						Subdivision: "London borough",
					},
					{
						StateCode: "RDB",
						Name: "Redbridge",
						Subdivision: "London borough",
					},
					{
						StateCode: "RIC",
						Name: "Richmond upon Thames",
						Subdivision: "London borough",
					},
					{
						StateCode: "SWK",
						Name: "Southwark",
						Subdivision: "London borough",
					},
					{
						StateCode: "STN",
						Name: "Sutton",
						Subdivision: "London borough",
					},
					{
						StateCode: "TWH",
						Name: "Tower Hamlets",
						Subdivision: "London borough",
					},
					{
						StateCode: "WFT",
						Name: "Waltham Forest",
						Subdivision: "London borough",
					},
					{
						StateCode: "WND",
						Name: "Wandsworth",
						Subdivision: "London borough",
					},
					{
						StateCode: "WSM",
						Name: "Westminster",
						Subdivision: "London borough",
					},
					{
						StateCode: "EAW",
						Name: "England and Wales",
						Subdivision: "Nation",
					},
					{
						StateCode: "GBN",
						Name: "Great Britain",
						Subdivision: "Nation",
					},
					{
						StateCode: "UKM",
						Name: "United Kingdom",
						Subdivision: "Nation",
					},
					{
						StateCode: "LND",
						Name: "London, City of",
						Subdivision: "city corporation",
					},
					{
						StateCode: "ABE",
						Name: "Aberdeen City",
						Subdivision: "council area",
					},
					{
						StateCode: "ABD",
						Name: "Aberdeenshire",
						Subdivision: "council area",
					},
					{
						StateCode: "ANS",
						Name: "Angus",
						Subdivision: "council area",
					},
					{
						StateCode: "AGB",
						Name: "Argyll and Bute",
						Subdivision: "council area",
					},
					{
						StateCode: "CLK",
						Name: "Clackmannanshire",
						Subdivision: "council area",
					},
					{
						StateCode: "DGY",
						Name: "Dumfries and Galloway",
						Subdivision: "council area",
					},
					{
						StateCode: "DND",
						Name: "Dundee City",
						Subdivision: "council area",
					},
					{
						StateCode: "EAY",
						Name: "East Ayrshire",
						Subdivision: "council area",
					},
					{
						StateCode: "EDU",
						Name: "East Dunbartonshire",
						Subdivision: "council area",
					},
					{
						StateCode: "ELN",
						Name: "East Lothian",
						Subdivision: "council area",
					},
					{
						StateCode: "ERW",
						Name: "East Renfrewshire",
						Subdivision: "council area",
					},
					{
						StateCode: "EDH",
						Name: "Edinburgh, City of",
						Subdivision: "council area",
					},
					{
						StateCode: "ELS",
						Name: "Eilean Siar",
						Subdivision: "council area",
					},
					{
						StateCode: "FAL",
						Name: "Falkirk",
						Subdivision: "council area",
					},
					{
						StateCode: "FIF",
						Name: "Fife",
						Subdivision: "council area",
					},
					{
						StateCode: "GLG",
						Name: "Glasgow City",
						Subdivision: "council area",
					},
					{
						StateCode: "HLD",
						Name: "Highland",
						Subdivision: "council area",
					},
					{
						StateCode: "IVC",
						Name: "Inverclyde",
						Subdivision: "council area",
					},
					{
						StateCode: "MLN",
						Name: "Midlothian",
						Subdivision: "council area",
					},
					{
						StateCode: "MRY",
						Name: "Moray",
						Subdivision: "council area",
					},
					{
						StateCode: "NAY",
						Name: "North Ayrshire",
						Subdivision: "council area",
					},
					{
						StateCode: "NLK",
						Name: "North Lanarkshire",
						Subdivision: "council area",
					},
					{
						StateCode: "ORK",
						Name: "Orkney Islands",
						Subdivision: "council area",
					},
					{
						StateCode: "PKN",
						Name: "Perth and Kinross",
						Subdivision: "council area",
					},
					{
						StateCode: "RFW",
						Name: "Renfrewshire",
						Subdivision: "council area",
					},
					{
						StateCode: "SCB",
						Name: "Scottish Borders, The",
						Subdivision: "council area",
					},
					{
						StateCode: "ZET",
						Name: "Shetland Islands",
						Subdivision: "council area",
					},
					{
						StateCode: "SAY",
						Name: "South Ayrshire",
						Subdivision: "council area",
					},
					{
						StateCode: "SLK",
						Name: "South Lanarkshire",
						Subdivision: "council area",
					},
					{
						StateCode: "STG",
						Name: "Stirling",
						Subdivision: "council area",
					},
					{
						StateCode: "WDU",
						Name: "West Dunbartonshire",
						Subdivision: "council area",
					},
					{
						StateCode: "WLN",
						Name: "West Lothian",
						Subdivision: "council area",
					},
					{
						StateCode: "ENG",
						Name: "England",
						Subdivision: "country",
					},
					{
						StateCode: "SCT",
						Name: "Scotland",
						Subdivision: "country",
					},
					{
						StateCode: "WLS",
						Name: "Wales",
						Subdivision: "country",
					},
					{
						StateCode: "ANT",
						Name: "Antrim",
						Subdivision: "district council area",
					},
					{
						StateCode: "ARD",
						Name: "Ards",
						Subdivision: "district council area",
					},
					{
						StateCode: "ARM",
						Name: "Armagh",
						Subdivision: "district council area",
					},
					{
						StateCode: "BLA",
						Name: "Ballymena",
						Subdivision: "district council area",
					},
					{
						StateCode: "BLY",
						Name: "Ballymoney",
						Subdivision: "district council area",
					},
					{
						StateCode: "BNB",
						Name: "Banbridge",
						Subdivision: "district council area",
					},
					{
						StateCode: "BFS",
						Name: "Belfast",
						Subdivision: "district council area",
					},
					{
						StateCode: "CKF",
						Name: "Carrickfergus",
						Subdivision: "district council area",
					},
					{
						StateCode: "CSR",
						Name: "Castlereagh",
						Subdivision: "district council area",
					},
					{
						StateCode: "CLR",
						Name: "Coleraine",
						Subdivision: "district council area",
					},
					{
						StateCode: "CKT",
						Name: "Cookstown",
						Subdivision: "district council area",
					},
					{
						StateCode: "CGV",
						Name: "Craigavon",
						Subdivision: "district council area",
					},
					{
						StateCode: "DRY",
						Name: "Derry",
						Subdivision: "district council area",
					},
					{
						StateCode: "DOW",
						Name: "Down",
						Subdivision: "district council area",
					},
					{
						StateCode: "DGN",
						Name: "Dungannon and South Tyrone",
						Subdivision: "district council area",
					},
					{
						StateCode: "FER",
						Name: "Fermanagh",
						Subdivision: "district council area",
					},
					{
						StateCode: "LRN",
						Name: "Larne",
						Subdivision: "district council area",
					},
					{
						StateCode: "LMV",
						Name: "Limavady",
						Subdivision: "district council area",
					},
					{
						StateCode: "LSB",
						Name: "Lisburn",
						Subdivision: "district council area",
					},
					{
						StateCode: "MFT",
						Name: "Magherafelt",
						Subdivision: "district council area",
					},
					{
						StateCode: "MYL",
						Name: "Moyle",
						Subdivision: "district council area",
					},
					{
						StateCode: "NYM",
						Name: "Newry and Mourne District",
						Subdivision: "district council area",
					},
					{
						StateCode: "NTA",
						Name: "Newtownabbey",
						Subdivision: "district council area",
					},
					{
						StateCode: "NDN",
						Name: "North Down",
						Subdivision: "district council area",
					},
					{
						StateCode: "OMH",
						Name: "Omagh",
						Subdivision: "district council area",
					},
					{
						StateCode: "STB",
						Name: "Strabane",
						Subdivision: "district council area",
					},
					{
						StateCode: "BNS",
						Name: "Barnsley",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "BIR",
						Name: "Birmingham",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "BOL",
						Name: "Bolton",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "BRD",
						Name: "Bradford",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "BUR",
						Name: "Bury",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "CLD",
						Name: "Calderdale",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "COV",
						Name: "Coventry",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "DNC",
						Name: "Doncaster",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "DUD",
						Name: "Dudley",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "GAT",
						Name: "Gateshead",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "KIR",
						Name: "Kirklees",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "KWL",
						Name: "Knowsley",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "LDS",
						Name: "Leeds",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "LIV",
						Name: "Liverpool",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "MAN",
						Name: "Manchester",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "NET",
						Name: "Newcastle upon Tyne",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "NTY",
						Name: "North Tyneside",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "OLD",
						Name: "Oldham",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "RCH",
						Name: "Rochdale",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "ROT",
						Name: "Rotherham",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SLF",
						Name: "Salford",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SAW",
						Name: "Sandwell",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SFT",
						Name: "Sefton",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SHF",
						Name: "Sheffield",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SOL",
						Name: "Solihull",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "STY",
						Name: "South Tyneside",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SHN",
						Name: "St. Helens",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SKP",
						Name: "Stockport",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "SND",
						Name: "Sunderland",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "TAM",
						Name: "Tameside",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "TRF",
						Name: "Trafford",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "WKF",
						Name: "Wakefield",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "WLL",
						Name: "Walsall",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "WGN",
						Name: "Wigan",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "WRL",
						Name: "Wirral",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "WLV",
						Name: "Wolverhampton",
						Subdivision: "metropolitan district",
					},
					{
						StateCode: "NIR",
						Name: "Northern Ireland",
						Subdivision: "province",
					},
					{
						StateCode: "BKM",
						Name: "Buckinghamshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "CAM",
						Name: "Cambridgeshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "CMA",
						Name: "Cumbria",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "DBY",
						Name: "Derbyshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "DEV",
						Name: "Devon",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "DOR",
						Name: "Dorset",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "ESX",
						Name: "East Sussex",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "ESS",
						Name: "Essex",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "GLS",
						Name: "Gloucestershire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "HAM",
						Name: "Hampshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "HRT",
						Name: "Hertfordshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "KEN",
						Name: "Kent",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "LAN",
						Name: "Lancashire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "LEC",
						Name: "Leicestershire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "LIN",
						Name: "Lincolnshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "NFK",
						Name: "Norfolk",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "NYK",
						Name: "North Yorkshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "NTH",
						Name: "Northamptonshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "NTT",
						Name: "Nottinghamshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "OXF",
						Name: "Oxfordshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "SOM",
						Name: "Somerset",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "STS",
						Name: "Staffordshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "SFK",
						Name: "Suffolk",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "SRY",
						Name: "Surrey",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "WAR",
						Name: "Warwickshire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "WSX",
						Name: "West Sussex",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "WOR",
						Name: "Worcestershire",
						Subdivision: "two-tier county",
					},
					{
						StateCode: "BAS",
						Name: "Bath and North East Somerset",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BDF",
						Name: "Bedford",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BBD",
						Name: "Blackburn with Darwen",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BPL",
						Name: "Blackpool",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BGW",
						Name: "Blaenau Gwent",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BMH",
						Name: "Bournemouth",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BRC",
						Name: "Bracknell Forest",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BGE",
						Name: "Bridgend",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BNH",
						Name: "Brighton and Hove",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "BST",
						Name: "Bristol, City of",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CAY",
						Name: "Caerphilly",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CRF",
						Name: "Cardiff",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CMN",
						Name: "Carmarthenshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CBF",
						Name: "Central Bedfordshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CGN",
						Name: "Ceredigion",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CHE",
						Name: "Cheshire East",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CHW",
						Name: "Cheshire West and Chester",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CWY",
						Name: "Conwy",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "CON",
						Name: "Cornwall",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "DAL",
						Name: "Darlington",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "DEN",
						Name: "Denbighshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "DER",
						Name: "Derby",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "DUR",
						Name: "Durham, County",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "ERY",
						Name: "East Riding of Yorkshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "FLN",
						Name: "Flintshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "GWN",
						Name: "Gwynedd",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "HAL",
						Name: "Halton",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "HPL",
						Name: "Hartlepool",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "HEF",
						Name: "Herefordshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "AGY",
						Name: "Isle of Anglesey",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "IOW",
						Name: "Isle of Wight",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "IOS",
						Name: "Isles of Scilly",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "KHL",
						Name: "Kingston upon Hull",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "LCE",
						Name: "Leicester",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "LUT",
						Name: "Luton",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "MDW",
						Name: "Medway",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "MTY",
						Name: "Merthyr Tydfil",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "MDB",
						Name: "Middlesbrough",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "MIK",
						Name: "Milton Keynes",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "MON",
						Name: "Monmouthshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NTL",
						Name: "Neath Port Talbot",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NWP",
						Name: "Newport",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NEL",
						Name: "North East Lincolnshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NLN",
						Name: "North Lincolnshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NSM",
						Name: "North Somerset",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NBL",
						Name: "Northumberland",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "NGM",
						Name: "Nottingham",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "PEM",
						Name: "Pembrokeshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "PTE",
						Name: "Peterborough",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "PLY",
						Name: "Plymouth",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "POL",
						Name: "Poole",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "POR",
						Name: "Portsmouth",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "POW",
						Name: "Powys",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "RDG",
						Name: "Reading",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "RCC",
						Name: "Redcar and Cleveland",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "RCT",
						Name: "Rhondda, Cynon, Taff",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "RUT",
						Name: "Rutland",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "SHR",
						Name: "Shropshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "SLG",
						Name: "Slough",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "SGC",
						Name: "South Gloucestershire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "STH",
						Name: "Southampton",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "SOS",
						Name: "Southend-on-Sea",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "STT",
						Name: "Stockton-on-Tees",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "STE",
						Name: "Stoke-on-Trent",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "SWA",
						Name: "Swansea",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "SWD",
						Name: "Swindon",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "TFW",
						Name: "Telford and Wrekin",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "THR",
						Name: "Thurrock",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "TOB",
						Name: "Torbay",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "TOF",
						Name: "Torfaen",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "VGL",
						Name: "Vale of Glamorgan, The",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "WRT",
						Name: "Warrington",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "WBK",
						Name: "West Berkshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "WIL",
						Name: "Wiltshire",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "WNM",
						Name: "Windsor and Maidenhead",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "WOK",
						Name: "Wokingham",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "WRX",
						Name: "Wrexham",
						Subdivision: "unitary authority",
					},
					{
						StateCode: "YOR",
						Name: "York",
						Subdivision: "unitary authority",
					},
				],
			},
			{
				TwoDigit: "UY",
				ThreeDigit: "URY",
				Name: "Uruguay",
				Capital: "Montevideo",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "AR",
						Name: "Artigas",
						Subdivision: null,
					},
					{
						StateCode: "CA",
						Name: "Canelones",
						Subdivision: null,
					},
					{
						StateCode: "CL",
						Name: "Cerro Largo",
						Subdivision: null,
					},
					{
						StateCode: "CO",
						Name: "Colonia",
						Subdivision: null,
					},
					{
						StateCode: "DU",
						Name: "Durazno",
						Subdivision: null,
					},
					{
						StateCode: "FS",
						Name: "Flores",
						Subdivision: null,
					},
					{
						StateCode: "FD",
						Name: "Florida",
						Subdivision: null,
					},
					{
						StateCode: "LA",
						Name: "Lavalleja",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Maldonado",
						Subdivision: null,
					},
					{
						StateCode: "MO",
						Name: "Montevideo",
						Subdivision: null,
					},
					{
						StateCode: "PA",
						Name: "Paysandú",
						Subdivision: null,
					},
					{
						StateCode: "RV",
						Name: "Rivera",
						Subdivision: null,
					},
					{
						StateCode: "RO",
						Name: "Rocha",
						Subdivision: null,
					},
					{
						StateCode: "RN",
						Name: "Río Negro",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Salto",
						Subdivision: null,
					},
					{
						StateCode: "SJ",
						Name: "San José",
						Subdivision: null,
					},
					{
						StateCode: "SO",
						Name: "Soriano",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tacuarembó",
						Subdivision: null,
					},
					{
						StateCode: "TT",
						Name: "Treinta y Tres",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "UZ",
				ThreeDigit: "UZB",
				Name: "Uzbekistan",
				Capital: "Tashkent",
				Region: "Asia",
				Subregion: "Central Asia",
				States: [
					{
						StateCode: "AN",
						Name: "Andijon",
						Subdivision: null,
					},
					{
						StateCode: "BU",
						Name: "Buxoro",
						Subdivision: null,
					},
					{
						StateCode: "FA",
						Name: "Farg‘ona",
						Subdivision: null,
					},
					{
						StateCode: "JI",
						Name: "Jizzax",
						Subdivision: null,
					},
					{
						StateCode: "NG",
						Name: "Namangan",
						Subdivision: null,
					},
					{
						StateCode: "NW",
						Name: "Navoiy",
						Subdivision: null,
					},
					{
						StateCode: "QA",
						Name: "Qashqadaryo",
						Subdivision: null,
					},
					{
						StateCode: "QR",
						Name: "Qoraqalpog‘iston Respublikasi",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Samarqand",
						Subdivision: null,
					},
					{
						StateCode: "SI",
						Name: "Sirdaryo",
						Subdivision: null,
					},
					{
						StateCode: "SU",
						Name: "Surxondaryo",
						Subdivision: null,
					},
					{
						StateCode: "TO",
						Name: "Toshkent",
						Subdivision: null,
					},
					{
						StateCode: "TK",
						Name: "Toshkent",
						Subdivision: null,
					},
					{
						StateCode: "XO",
						Name: "Xorazm",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "VU",
				ThreeDigit: "VUT",
				Name: "Vanuatu",
				Capital: "Port Vila",
				Region: "Oceania",
				Subregion: "Melanesia",
				States: [
					{
						StateCode: "MAP",
						Name: "Malampa",
						Subdivision: null,
					},
					{
						StateCode: "PAM",
						Name: "Pénama",
						Subdivision: null,
					},
					{
						StateCode: "SAM",
						Name: "Sanma",
						Subdivision: null,
					},
					{
						StateCode: "SEE",
						Name: "Shéfa",
						Subdivision: null,
					},
					{
						StateCode: "TAE",
						Name: "Taféa",
						Subdivision: null,
					},
					{
						StateCode: "TOB",
						Name: "Torba",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "VE",
				ThreeDigit: "VEN",
				Name: "Venezuela",
				Capital: "Caracas",
				Region: "Americas",
				Subregion: "South America",
				States: [
					{
						StateCode: "Z",
						Name: "Amazonas",
						Subdivision: null,
					},
					{
						StateCode: "B",
						Name: "Anzoátegui",
						Subdivision: null,
					},
					{
						StateCode: "C",
						Name: "Apure",
						Subdivision: null,
					},
					{
						StateCode: "D",
						Name: "Aragua",
						Subdivision: null,
					},
					{
						StateCode: "E",
						Name: "Barinas",
						Subdivision: null,
					},
					{
						StateCode: "F",
						Name: "Bolívar",
						Subdivision: null,
					},
					{
						StateCode: "G",
						Name: "Carabobo",
						Subdivision: null,
					},
					{
						StateCode: "H",
						Name: "Cojedes",
						Subdivision: null,
					},
					{
						StateCode: "Y",
						Name: "Delta Amacuro",
						Subdivision: null,
					},
					{
						StateCode: "W",
						Name: "Dependencias Federales",
						Subdivision: null,
					},
					{
						StateCode: "A",
						Name: "Distrito Capital",
						Subdivision: null,
					},
					{
						StateCode: "I",
						Name: "Falcón",
						Subdivision: null,
					},
					{
						StateCode: "J",
						Name: "Guárico",
						Subdivision: null,
					},
					{
						StateCode: "K",
						Name: "Lara",
						Subdivision: null,
					},
					{
						StateCode: "M",
						Name: "Miranda",
						Subdivision: null,
					},
					{
						StateCode: "N",
						Name: "Monagas",
						Subdivision: null,
					},
					{
						StateCode: "L",
						Name: "Mérida",
						Subdivision: null,
					},
					{
						StateCode: "O",
						Name: "Nueva Esparta",
						Subdivision: null,
					},
					{
						StateCode: "P",
						Name: "Portuguesa",
						Subdivision: null,
					},
					{
						StateCode: "R",
						Name: "Sucre",
						Subdivision: null,
					},
					{
						StateCode: "T",
						Name: "Trujillo",
						Subdivision: null,
					},
					{
						StateCode: "S",
						Name: "Táchira",
						Subdivision: null,
					},
					{
						StateCode: "X",
						Name: "Vargas",
						Subdivision: null,
					},
					{
						StateCode: "U",
						Name: "Yaracuy",
						Subdivision: null,
					},
					{
						StateCode: "V",
						Name: "Zulia",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "VN",
				ThreeDigit: "VNM",
				Name: "Vietnam",
				Capital: "Hanoi",
				Region: "Asia",
				Subregion: "South-Eastern Asia",
				States: [
					{
						StateCode: "44",
						Name: "An Giang",
						Subdivision: null,
					},
					{
						StateCode: "43",
						Name: "Bà Rịa–Vũng Tàu",
						Subdivision: null,
					},
					{
						StateCode: "57",
						Name: "Bình Dương",
						Subdivision: null,
					},
					{
						StateCode: "58",
						Name: "Bình Phước",
						Subdivision: null,
					},
					{
						StateCode: "40",
						Name: "Bình Thuận",
						Subdivision: null,
					},
					{
						StateCode: "31",
						Name: "Bình Định",
						Subdivision: null,
					},
					{
						StateCode: "55",
						Name: "Bạc Liêu",
						Subdivision: null,
					},
					{
						StateCode: "54",
						Name: "Bắc Giang",
						Subdivision: null,
					},
					{
						StateCode: "53",
						Name: "Bắc Kạn",
						Subdivision: null,
					},
					{
						StateCode: "56",
						Name: "Bắc Ninh",
						Subdivision: null,
					},
					{
						StateCode: "50",
						Name: "Bến Tre",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Cao Bằng",
						Subdivision: null,
					},
					{
						StateCode: "59",
						Name: "Cà Mau",
						Subdivision: null,
					},
					{
						StateCode: "CT",
						Name: "Cần Thơ",
						Subdivision: null,
					},
					{
						StateCode: "30",
						Name: "Gia Lai",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Hà Giang",
						Subdivision: null,
					},
					{
						StateCode: "63",
						Name: "Hà Nam",
						Subdivision: null,
					},
					{
						StateCode: "HN",
						Name: "Hà Nội",
						Subdivision: null,
					},
					{
						StateCode: "15",
						Name: "Hà Tây",
						Subdivision: null,
					},
					{
						StateCode: "23",
						Name: "Hà Tĩnh",
						Subdivision: null,
					},
					{
						StateCode: "14",
						Name: "Hòa Bình",
						Subdivision: null,
					},
					{
						StateCode: "66",
						Name: "Hưng Yên",
						Subdivision: null,
					},
					{
						StateCode: "61",
						Name: "Hải Dương",
						Subdivision: null,
					},
					{
						StateCode: "HP",
						Name: "Hải Phòng",
						Subdivision: null,
					},
					{
						StateCode: "73",
						Name: "Hậu Giang",
						Subdivision: null,
					},
					{
						StateCode: "SG",
						Name: "Hồ Chí Minh",
						Subdivision: null,
					},
					{
						StateCode: "34",
						Name: "Khánh Hòa",
						Subdivision: null,
					},
					{
						StateCode: "47",
						Name: "Kiên Giang",
						Subdivision: null,
					},
					{
						StateCode: "28",
						Name: "Kon Tum",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Lai Châu",
						Subdivision: null,
					},
					{
						StateCode: "41",
						Name: "Long An",
						Subdivision: null,
					},
					{
						StateCode: "02",
						Name: "Lào Cai",
						Subdivision: null,
					},
					{
						StateCode: "35",
						Name: "Lâm Đồng",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Lạng Sơn",
						Subdivision: null,
					},
					{
						StateCode: "67",
						Name: "Nam Định",
						Subdivision: null,
					},
					{
						StateCode: "22",
						Name: "Nghệ An",
						Subdivision: null,
					},
					{
						StateCode: "18",
						Name: "Ninh Bình",
						Subdivision: null,
					},
					{
						StateCode: "36",
						Name: "Ninh Thuận",
						Subdivision: null,
					},
					{
						StateCode: "68",
						Name: "Phú Thọ",
						Subdivision: null,
					},
					{
						StateCode: "32",
						Name: "Phú Yên",
						Subdivision: null,
					},
					{
						StateCode: "24",
						Name: "Quảng Bình",
						Subdivision: null,
					},
					{
						StateCode: "27",
						Name: "Quảng Nam",
						Subdivision: null,
					},
					{
						StateCode: "29",
						Name: "Quảng Ngãi",
						Subdivision: null,
					},
					{
						StateCode: "13",
						Name: "Quảng Ninh",
						Subdivision: null,
					},
					{
						StateCode: "25",
						Name: "Quảng Trị",
						Subdivision: null,
					},
					{
						StateCode: "52",
						Name: "Sóc Trăng",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Sơn La",
						Subdivision: null,
					},
					{
						StateCode: "21",
						Name: "Thanh Hóa",
						Subdivision: null,
					},
					{
						StateCode: "20",
						Name: "Thái Bình",
						Subdivision: null,
					},
					{
						StateCode: "69",
						Name: "Thái Nguyên",
						Subdivision: null,
					},
					{
						StateCode: "26",
						Name: "Thừa Thiên–Huế",
						Subdivision: null,
					},
					{
						StateCode: "46",
						Name: "Tiền Giang",
						Subdivision: null,
					},
					{
						StateCode: "51",
						Name: "Trà Vinh",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Tuyên Quang",
						Subdivision: null,
					},
					{
						StateCode: "37",
						Name: "Tây Ninh",
						Subdivision: null,
					},
					{
						StateCode: "49",
						Name: "Vĩnh Long",
						Subdivision: null,
					},
					{
						StateCode: "70",
						Name: "Vĩnh Phúc",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "Yên Bái",
						Subdivision: null,
					},
					{
						StateCode: "71",
						Name: "Điện Biên",
						Subdivision: null,
					},
					{
						StateCode: "DN",
						Name: "Đà Nẵng",
						Subdivision: null,
					},
					{
						StateCode: "33",
						Name: "Đắk Lắk",
						Subdivision: null,
					},
					{
						StateCode: "72",
						Name: "Đắk Nông",
						Subdivision: null,
					},
					{
						StateCode: "39",
						Name: "Đồng Nai",
						Subdivision: null,
					},
					{
						StateCode: "45",
						Name: "Đồng Tháp",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "WF",
				ThreeDigit: "WLF",
				Name: "Wallis and Futuna",
				Capital: "Mata-Utu",
				Region: "Oceania",
				Subregion: "Polynesia",
				States: [],
			},
			{
				TwoDigit: "EH",
				ThreeDigit: "ESH",
				Name: "Western Sahara",
				Capital: "El Aaiún",
				Region: "Africa",
				Subregion: "Northern Africa",
				States: [],
			},
			{
				TwoDigit: "YE",
				ThreeDigit: "YEM",
				Name: "Yemen",
				Capital: "Sana'a",
				Region: "Asia",
				Subregion: "Western Asia",
				States: [
					{
						StateCode: "AD",
						Name: "'Adan",
						Subdivision: null,
					},
					{
						StateCode: "AM",
						Name: "'Amrān",
						Subdivision: null,
					},
					{
						StateCode: "AB",
						Name: "Abyān",
						Subdivision: null,
					},
					{
						StateCode: "BA",
						Name: "Al Bayḑā'",
						Subdivision: null,
					},
					{
						StateCode: "JA",
						Name: "Al Jawf",
						Subdivision: null,
					},
					{
						StateCode: "MR",
						Name: "Al Mahrah",
						Subdivision: null,
					},
					{
						StateCode: "MW",
						Name: "Al Maḩwīt",
						Subdivision: null,
					},
					{
						StateCode: "HU",
						Name: "Al Ḩudaydah",
						Subdivision: null,
					},
					{
						StateCode: "DA",
						Name: "Aḑ Ḑāli'",
						Subdivision: null,
					},
					{
						StateCode: "DH",
						Name: "Dhamār",
						Subdivision: null,
					},
					{
						StateCode: "IB",
						Name: "Ibb",
						Subdivision: null,
					},
					{
						StateCode: "LA",
						Name: "Laḩij",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Ma'rib",
						Subdivision: null,
					},
					{
						StateCode: "RA",
						Name: "Raymah",
						Subdivision: null,
					},
					{
						StateCode: "SH",
						Name: "Shabwah",
						Subdivision: null,
					},
					{
						StateCode: "TA",
						Name: "Tā‘izz",
						Subdivision: null,
					},
					{
						StateCode: "SA",
						Name: "Şan‘ā'",
						Subdivision: null,
					},
					{
						StateCode: "SN",
						Name: "Şan‘ā'",
						Subdivision: null,
					},
					{
						StateCode: "SD",
						Name: "Şā‘dah",
						Subdivision: null,
					},
					{
						StateCode: "HJ",
						Name: "Ḩajjah",
						Subdivision: null,
					},
					{
						StateCode: "HD",
						Name: "Ḩaḑramawt",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ZM",
				ThreeDigit: "ZMB",
				Name: "Zambia",
				Capital: "Lusaka",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "02",
						Name: "Central",
						Subdivision: null,
					},
					{
						StateCode: "08",
						Name: "Copperbelt",
						Subdivision: null,
					},
					{
						StateCode: "03",
						Name: "Eastern",
						Subdivision: null,
					},
					{
						StateCode: "04",
						Name: "Luapula",
						Subdivision: null,
					},
					{
						StateCode: "09",
						Name: "Lusaka",
						Subdivision: null,
					},
					{
						StateCode: "06",
						Name: "North-Western",
						Subdivision: null,
					},
					{
						StateCode: "05",
						Name: "Northern",
						Subdivision: null,
					},
					{
						StateCode: "07",
						Name: "Southern",
						Subdivision: null,
					},
					{
						StateCode: "01",
						Name: "Western",
						Subdivision: null,
					},
				],
			},
			{
				TwoDigit: "ZW",
				ThreeDigit: "ZWE",
				Name: "Zimbabwe",
				Capital: "Harare",
				Region: "Africa",
				Subregion: "Eastern Africa",
				States: [
					{
						StateCode: "BU",
						Name: "Bulawayo",
						Subdivision: null,
					},
					{
						StateCode: "HA",
						Name: "Harare",
						Subdivision: null,
					},
					{
						StateCode: "MA",
						Name: "Manicaland",
						Subdivision: null,
					},
					{
						StateCode: "MC",
						Name: "Mashonaland Central",
						Subdivision: null,
					},
					{
						StateCode: "ME",
						Name: "Mashonaland East",
						Subdivision: null,
					},
					{
						StateCode: "MW",
						Name: "Mashonaland West",
						Subdivision: null,
					},
					{
						StateCode: "MV",
						Name: "Masvingo",
						Subdivision: null,
					},
					{
						StateCode: "MN",
						Name: "Matabeleland North",
						Subdivision: null,
					},
					{
						StateCode: "MS",
						Name: "Matabeleland South",
						Subdivision: null,
					},
					{
						StateCode: "MI",
						Name: "Midlands",
						Subdivision: null,
					},
				],
			},
		];
		

		// If the value is blank, default it to 'CA'
		this.value = value ? value.trim().toUpperCase() : 'CA';

		// Define the properties to be used for search.
		const searchProperties = ['TwoDigit', 'ThreeDigit', 'Numeric', 'Name', 'TDL'];

		// Initialize the match object to null.
		this.match = null;

		// Iterate through each country object to find a match.
		for (const country of this.countries) {
			for (const property of searchProperties) {
				const propertyValue = String(country[property]);
				if (propertyValue === this.value) {
					// Match found, set the country object as a property of this instance.
					this.match = country;
					break;
				}
			}
			if (this.match) {
				// If a match is found, exit the loop.
				break;
			}
		}

		// If no match is found, set the match to 'CA' by default.
		if (!this.match) {
			this.match = this.countries.find(country => country.TwoDigit === 'CA');
		}

		// Add .All property to the returned match that contains the country array.
		if (this.match) {
			this.match.All = this.countries;
		}

		this.states = this.getStatesByCountryCode(this.TwoDigit);
	}

	// Getter methods for accessing country properties.
	get Name() {
		return this.match ? this.match.Name : undefined;
	}

	// ISO 3166-1 alpha-2
	get TwoDigit() {
		return this.match ? this.match.TwoDigit : undefined;
	}

	// ISO 3166-1 alpha-3
	get ThreeDigit() {
		return this.match ? this.match.ThreeDigit : undefined;
	}

	// get Numeric() {
	// 	return this.match ? this.match.Numeric : undefined;
	// }

	// TLD
	get TLD() {
		return this.match ? `.${String(this.match.TwoDigit).toLowerCase()}` : undefined;
	}

	get All() {
		return this.match ? this.match.All : undefined;
	}

	// Function to get states by TwoDigit country code
	getStatesByCountryCode(CountryCode) {
		let country = null;
		if (CountryCode.length === 2) {
			country = this.countries.find(
				(country) => country.TwoDigit.toLowerCase() === CountryCode.toLowerCase()
			);
		}
		if (CountryCode.length === 3) {
			country = this.countries.find(
				(country) => country.ThreeDigit.toLowerCase() === CountryCode.toLowerCase()
			);
		}
		return country ? country.States : [];
	}
	
	getStateNameByCode(stateCode) {
		const state = this.states.find((s) => s.StateCode === stateCode);
		return state ? state.Name : '';
	}

}

// Example usage:
// const country = new CountryHelper(''); // Blank value defaults to 'CA'
// console.log(country.Name); // Output: Canada
// console.log(country.TwoDigit); // Output: CA
// console.log(country.ThreeDigit); // Output: CAN
// console.log(country.Numeric); // Output: 124
// console.log(country.TLD); // Output: .ca
// console.log(country.All); // Output: Array of all countries
// console.log( country.getStatesByCountryCode('CA')); // Get states using TwoDigit country code
// console.log(country.getStatesByCountryCode('CAN')); // Get states using ThreeDigit country code

export default CountryHelper;